// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%233264FF%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2719%27 height=%2718%27 viewBox=%270 0 19 18%27 fill=%27none%27%3E%3Cpath d=%27M10.417 2.25V7.5H14.917L8.91699 15.75V10.5H4.41699L10.417 2.25Z%27 stroke=%27%230A7519%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2720%27 viewBox=%270 0 20 20%27 fill=%27none%27%3E%3Cpath d=%27M19 19L13 13M1 8C1 8.91925 1.18106 9.82951 1.53284 10.6788C1.88463 11.5281 2.40024 12.2997 3.05025 12.9497C3.70026 13.5998 4.47194 14.1154 5.32122 14.4672C6.1705 14.8189 7.08075 15 8 15C8.91925 15 9.82951 14.8189 10.6788 14.4672C11.5281 14.1154 12.2997 13.5998 12.9497 12.9497C13.5998 12.2997 14.1154 11.5281 14.4672 10.6788C14.8189 9.82951 15 8.91925 15 8C15 7.08075 14.8189 6.1705 14.4672 5.32122C14.1154 4.47194 13.5998 3.70026 12.9497 3.05025C12.2997 2.40024 11.5281 1.88463 10.6788 1.53284C9.82951 1.18106 8.91925 1 8 1C7.08075 1 6.1705 1.18106 5.32122 1.53284C4.47194 1.88463 3.70026 2.40024 3.05025 3.05025C2.40024 3.70026 1.88463 4.47194 1.53284 5.32122C1.18106 6.1705 1 7.08075 1 8Z%27 stroke=%27%230F294D%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2711%27 height=%279%27 viewBox=%270 0 11 9%27 fill=%27none%27%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M7.48477 1.02765L10.7591 4.30202C10.9601 4.50295 10.9601 4.82872 10.7591 5.02965L7.48477 8.30402C7.28384 8.50495 6.95806 8.50495 6.75713 8.30402C6.5562 8.10308 6.5562 7.77731 6.75713 7.57638L9.15316 5.18035H0.789907C0.505748 5.18035 0.275391 4.94999 0.275391 4.66583C0.275391 4.38167 0.505748 4.15132 0.789907 4.15132H9.15316L6.75713 1.75529C6.5562 1.55436 6.5562 1.22858 6.75713 1.02765C6.95806 0.82672 7.28384 0.82672 7.48477 1.02765Z%27 fill=%27%233264FF%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2727%27 height=%2720%27 viewBox=%270 0 27 20%27 fill=%27none%27%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M8.67002 1.20047L0.749396 9.1211C0.263348 9.60715 0.263348 10.3952 0.749396 10.8812L8.67002 18.8019C9.15607 19.2879 9.94411 19.2879 10.4302 18.8019C10.9162 18.3158 10.9162 17.5278 10.4302 17.0417L4.63421 11.2458H24.8648C25.5521 11.2458 26.1094 10.6885 26.1094 10.0012C26.1094 9.31379 25.5521 8.75656 24.8648 8.75656H4.63421L10.4302 2.96061C10.9162 2.47456 10.9162 1.68652 10.4302 1.20047C9.94411 0.714425 9.15607 0.714425 8.67002 1.20047Z%27 fill=%27%233264FF%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2720%27 viewBox=%270 0 20 20%27 fill=%27none%27%3E%3Cpath d=%27M17.2203 4.37652C17.5643 4.68228 17.5953 5.20901 17.2895 5.55299L8.40063 15.553C8.24249 15.7309 8.01582 15.8327 7.77779 15.8327C7.53975 15.8327 7.31309 15.7309 7.15495 15.553L2.7105 10.553C2.40474 10.209 2.43572 9.68228 2.77971 9.37652C3.12369 9.07075 3.65042 9.10174 3.95618 9.44572L7.77779 13.745L16.0438 4.44572C16.3496 4.10174 16.8763 4.07075 17.2203 4.37652Z%27 fill=%27%233264ff%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2720%27 viewBox=%270 0 20 20%27 fill=%27none%27%3E%3Cpath d=%27M4.41107 4.41009C4.73651 4.08466 5.26414 4.08466 5.58958 4.41009L10.0003 8.82084L14.4111 4.41009C14.7365 4.08466 15.2641 4.08466 15.5896 4.41009C15.915 4.73553 15.915 5.26317 15.5896 5.5886L11.1788 9.99935L15.5896 14.4101C15.915 14.7355 15.915 15.2632 15.5896 15.5886C15.2641 15.914 14.7365 15.914 14.4111 15.5886L10.0003 11.1779L5.58958 15.5886C5.26414 15.914 4.73651 15.914 4.41107 15.5886C4.08563 15.2632 4.08563 14.7355 4.41107 14.4101L8.82181 9.99935L4.41107 5.5886C4.08563 5.26317 4.08563 4.73553 4.41107 4.41009Z%27 fill=%27%23DA102A%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hw-widget--ticketCheckout {
  --hw-heading-color: #121826;
}

.hw-book--filterResult .row {
  row-gap: 2rem;
}

.hw-price--dropdown {
  position: relative;
  cursor: pointer;
  min-width: 180px;
}

.hw-excursion--dropdown {
  border: .1rem solid var(--hw-gray-400);
  background-color: var(--hw-white);
  border-radius: 1rem;
  padding: .8rem 2rem;
  display: flex;
  align-items: center;
  column-gap: 1rem;
}

.hw-excursion--dropdown svg:first-child {
  color: var(--hw-black);
}

.hw-excursion--dropdown span {
  flex: 1 0 0;
}

.hw-excursion--dropdown+.hw-price--dropdownContent {
  margin-top: 1rem;
}

.hw-datepicker--input .react-datepicker-wrapper {
  display: block;
}

.hw-datepicker--input .react-datepicker-wrapper .hw-input--input {
  min-height: 4.6rem;
  border-radius: 0.5rem;
}

.hw-person--roomInput {
  position: relative;
}

.hw-person--roomInput .hw-input--input {
  min-height: 4.6rem;
  border-radius: 0.5rem;
}

.hw-person--roomInput .paasenger-modal {
  top: 5.6rem;
  right: calc(var(--bs-gutter-x) * 0.5);
}

.hw-person--roomInput .DT--passenger-item .DT--divider {
  display: none;
}

.hw-gp--btn {
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: 2rem;
}

.hw-gp--btn:has(> :only-child) {
  grid-template-columns: 1fr;
}

.hw-gp--btn .hw-btn {
  padding-top: 1.2rem;
  padding-bottom: 1.2rem;
}

.hw-price--dropdownContent {
  position: absolute;
  z-index: 2;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);
  background-color: var(--hw-white);
  padding: 1rem 1rem;
  width: 100%;
  top: 100%;
  margin-top: 2rem;
  border-radius: 0.5rem;
}

.hw-price--dropdownContent>div {
  padding: .5rem 1rem;
  cursor: pointer;
  color: var(--hw-black);
}

.hw-price--dropdownContent>div:hover {
  color: var(--hw-brand-orange);
}

.hw-excursion--topSearch {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  column-gap: 1rem;
}

.hw-excursion--topSearch .hw-price--dropdown {
  flex-shrink: 0;
  /* display: flex;
  align-items: center;
  column-gap: .4rem; */
}

.hw-book--filterSlideItem {
  padding: 0.4rem;
  display: flex;
  align-items: center;
  column-gap: 1.2rem;
  cursor: pointer;
  transition: .2s;
  position: relative;
  color: var(--hw-black-900);
  font-size: 1.4rem;
  line-height: 1.71429;
}

.hw-book--filterSlideItem+.hw-book--filterSlideItem {
  margin-top: 0.8rem;
}

.hw-book--filterSlideItem::before {

  content: '';
  border: 1px solid var(--hw-gray-700);
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 99.9rem;
  margin: 2px;
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  flex-shrink: 0;
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
  print-color-adjust: exact;
}

.hw-book--filterSlideItem.active::before {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-color: var(--hw-white);
  border-color: var(--hw-brand-orange);

}



.hw-book--filterResultGrid .image-box {
  position: relative;
  border-radius: 0.5rem;
  overflow: hidden;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.00) 100%);
}

.hw-book--filterResultGrid .image-box::after {
  content: '';
  padding-top: 63.484%;
  display: block;
}

.hw-book--filterResultGrid .image-box::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 4.4rem;
  bottom: 0;
  pointer-events: none;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.00) 100%);
  z-index: 1;
  height: clamp(4.4rem, 3vw, 10rem);
}

.hw-book--filterResultGrid .image-box img {
  position: absolute;
  width: 100%;
  height: 100%;
  inset: 0;
  display: block;
  object-fit: cover;
  transition: transform .2s ease-out;

}

.hw-book--filterResultGrid .whole-link:hover~.image-box img {
  transform: scale(1.12);
}

.content-box {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  row-gap: .4rem;
  padding-top: 1rem;
}

.content-box--inner {
  display: flex;
  justify-content: space-between;
  column-gap: .4rem;
  flex-flow: nowrap;
  align-items: center;
}

@media (min-width : 480px) {
  .hw-excursion-search-btn {
    min-width: 15rem;
  }
}

/* .tick-list {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'%3E%3Cpath d='M15.4983 3.93945C15.8079 4.21464 15.8358 4.68869 15.5606 4.99828L7.56056 13.9983C7.41824 14.1584 7.21424 14.25 7.00001 14.25C6.78578 14.25 6.58178 14.1584 6.43945 13.9983L2.43945 9.49828C2.16426 9.18869 2.19215 8.71464 2.50174 8.43945C2.81132 8.16426 3.28538 8.19215 3.56056 8.50173L7.00001 12.3711L14.4395 4.00174C14.7146 3.69215 15.1887 3.66426 15.4983 3.93945Z' fill='%23555555'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: 1.8rem 1.8rem;
  background-position: top 0.4em left;
  padding-left: 2.2rem;
} */
.tick-list {
  background-repeat: no-repeat;
  background-size: 1.8rem 1.8rem;
  background-position: left .6rem center;
  background-color: #E7F5E9;
  color: var(--hw-green);
  font-size: 1.2rem;
  padding: .4rem .6rem .4rem 2.8rem;
  border-radius: .4rem;
  line-height: 1.33333;
  font-weight: 500;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.content-box--inner .price {
  display: flex;
  align-items: center;
  column-gap: 1rem;
  font-size: 1.6rem;
  line-height: 1.5;
  flex-shrink: 0;
  font-weight: bold;
  color: var(--hw-black-900);
}

.content-box--inner .price small {
  font-size: 1.2rem;
  line-height: 1.33333;
  color: var(--hw-black-900);
  font-weight: 500;
}

.hw-ticket--title {
  font-size: 1.6rem;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  color: var(--hw-black-900);
}

.whole-link:hover~.content-box .hw-ticket--title {
  color: var(--hw-brand-orange);
}

.whole-link:hover~.content-box .price {
  color: var(--hw-black);
}

.hw-book--filterResultGrid {
  position: relative;
}

.whole-link {
  position: absolute;
  width: 100%;
  height: 100%;
  display: block !important;
  inset: 0;
  z-index: 1;
}

.hw-excursion--toggleTitle {
  font-size: 1.8rem;
  line-height: 1.5;
  font-weight: bold;
  color: var(--hw-black);
}

.hw-excursion--listInfo {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.hw-excursion--listInfoList {
  display: grid;
  grid-template-columns: 2.4rem 1fr;
  column-gap: 0.4rem;
}

.hw-excursion--listInfoList .icon {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--hw-brand-orange);
}

.hw-excursion--listInfoList .icon svg {
  width: 2.3rem;
  height: 2.3rem;
  display: block;
}

.hw-excursion--listInfoList .icon-text {
  color: var(--hw-brand-blue);
  font-weight: 500;
}

.hw-excursion--listInfoList .icon-text b {
  margin-right: .4rem;
  font-weight: inherit;
}

.hw-excursion--toggleItem {
  padding-bottom: 2rem;
  border-bottom: 1px solid var(--hw-gray-400);
}

/* .hw-scroll--contentList > .hw-excursion--toggleItem:not(:first-child) {
  padding-top: 2rem;
} */
.hw-excursion--toggleContent {
  padding: 2rem 0 0 0;
}

.hw-excursion--toggleContent ul {
  margin-top: 0;
  padding-left: 2rem;
}

.hw-excursion--toggleContent> :last-child {
  margin-bottom: 0;
}

.hw-widget--ticketCheckout .hw-passenger--head {
  border-bottom-width: 0;
}

.hw-car--listShow__passangerCol {
  display: flex;
  flex-direction: column;
  row-gap: 0.8rem;
}

.hw-img--holder.hw-img--holder105 {
  width: 10.5rem;
  height: 9rem;
}

.hw-img--holder {
  position: relative;
  border-radius: 1rem;
}

.hw-img--holder img {
  position: absolute;
  width: 100%;
  height: 100%;
  inset: 0;
  object-fit: cover;
  border-radius: 0.5rem;
}

.hw-car--listShow__passangerColInner {
  display: flex;
  align-items: center;
  align-content: center;
  gap: 1rem .2rem;
  align-self: stretch;
  flex-wrap: wrap;
  margin-top: 0.4rem;
}

.middle-content--rowItem {
  display: flex;
  gap: .8rem;
  align-items: center;
  font-size: 1.4rem;
  line-height: 1.71429;
}

.middle-content--rowItem svg {
  color: var(--hw-brand-blue);
}

.middle-content--rowItem {
  /* flex-basis: 17.4rem; */
  min-width: 17.4rem;
}

.hw-img--holder.hw-img--holder105 {
  width: 10.5rem;
  height: 9rem;
}

.align-items-start {
  align-items: flex-start !important;
}

.hw-passenger--iconList {
  column-gap: 1rem;
}

.hw-passenger--iconList .d-flex {
  column-gap: 1rem;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.hw-passenger--iconList .d-flex span {
  font-weight: 500;
}

.hw-passenger--iconList>.d-flex>.d-flex>span:not(:last-child)::after {
  content: '|';
  display: inline-flex;
  color: var(--hw-gray-400);
  margin-left: 1rem;
}

.hw-car--listShow__passangerCol hr {
  margin: .6rem 0;
  color: inherit;
  border: none;
  border-top: 1px solid var(--hw-gray-600);
}

.hw-passenger--fareShowToggleContent>.row {
  row-gap: 1.5rem;
}

.hw-passenger--iconList svg {
  color: var(--hw-brand-blue);
}

.hw-passenger--fareSummary__tfoot {
  font-size: 1.8rem;
  line-height: 1.5;
}

.hw-excursion--listProductData {
  background-color: var(--hw-white);
  padding: 1.5rem;
  border-radius: 0.5rem;
  border: .1rem solid var(--hw-gray-400);
  margin-top: 2rem;
}

.hw-excursion--listProductData>.row {
  row-gap: 1rem;
}

.hw-excursion--selectSliderItem {
  border: .1rem solid var(--hw-gray-600);
  background-color: var(--hw-white);
  padding: 1.5rem;
  border-radius: 1rem;
  row-gap: 1rem;
  margin: 2rem 0 0 0 !important;
  cursor: pointer;
  /* min-height: 350px; */
}

.hw-excursion--selectSliderItem .hw-excursion--title {
  position: relative;
  padding-left: 3.8rem;
}

.hw-excursion--selectSliderItem .hw-excursion--title::before {
  content: '';
  width: 1.8rem;
  height: 1.8rem;
  border: .1rem solid var(--hw-black-900);
  position: absolute;
  left: 0;
  top: .6rem;
  border-radius: 50%;
}

.hw-excursion--selectSliderItem.active .hw-excursion--title::after {
  content: '';
  width: 1.2rem;
  height: 1.2rem;
  position: absolute;
  top: 9px;
  left: 3px;
  background-color: var(--hw-brand-orange);
  border-radius: 50%;
}

.hw-excursion--selectSliderItem.active .hw-excursion--title::before {
  border-color: var(--hw-brand-orange);
}

.hw-excursion--selectSliderItem.active {
  border-color: var(--hw-brand-orange);
}


.hw-excursion--selectSliderItem ul {
  margin: 0;
  padding-left: 2rem;
}

.hw-excursion--selectSliderItem ul li {
  font-size: 1.4rem;
  line-height: 1.71429;
}

.hw-excursion--selectSliderItem ul>li+li {
  margin-top: .5rem;
}

.hw-price--dropdownBorder .hw-price--dropdownContent {
  display: none;
}

.hw-excursion--Searchbox {
  flex: 1 0 0;
  max-width: 65rem;
  border: .1rem solid var(--hw-gray-600);
  border-radius: 0.5rem;
  overflow: hidden;
}

.hw-excursion--Searchbox>.css-b62m3t-container>div {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  padding: 0;
  min-height: 5rem;
  background-size: 1.8rem 1.8rem;
  background-position: left 1.2rem center;
  background-repeat: no-repeat;
  font-weight: 500;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.hw-excursion--Searchbox>.css-b62m3t-container>div div {
  color: var(--hw-brand-blue) !important;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 0;
  white-space: nowrap;
  padding-left: 2rem;
  width: calc(100% - 2rem);
  font-weight: 500;
}

.hw-excursion--Searchbox>.css-b62m3t-container>div .css-1wy0on6 {
  display: none;
}

.hw-excursion--Searchbox:hover {
  border-color: var(--hw-brand-orange);
}

.hw-br--5 {
  border-radius: 0.5rem !important;
}

.hw-br--10 {
  border-radius: 1rem !important;
}

.hw-excursion--listProduct .image-gallery-slide .image-gallery-image {
  position: absolute;
  width: 100%;
  height: 100%;
  inset: 0;
  max-height: 100% !important;
  object-fit: cover !important;
  border-radius: 0.5rem;
  object-position: top center;
}

.hw-excursion--listProduct .image-gallery-slide.image-gallery-center::after {
  content: '';
  padding-top: 75%;
  display: block;
}

.hw-excursion--listProduct .image-gallery-icon.image-gallery-fullscreen-button {

  left: 1.5rem;
  right: auto;


}

.hw-excursion--listProduct .image-gallery-icon.image-gallery-play-button,
.hw-excursion--listProduct .image-gallery-icon.image-gallery-fullscreen-button {
  background-color: var(--hw-white);
  filter: none !important;
  color: var(--hw-brand-orange);
  padding: .6rem;
  border-radius: .4rem;
  top: 1.5rem;
  bottom: auto;
}

.hw-excursion--listProduct .image-gallery-icon.image-gallery-play-button {
  right: 1.5rem;
  left: auto;
}

.hw-excursion--listProduct .image-gallery-fullscreen-button .image-gallery-svg,
.hw-excursion--listProduct .image-gallery-play-button .image-gallery-svg {
  height: 18px;
  width: 18px;
}

.hw-excursion--listProduct .image-gallery-thumbnail {
  width: 6.4rem;
  border-width: .2rem;
  border-radius: .4rem !important;
  overflow: hidden;
}

.hw-excursion--listProduct .image-gallery-thumbnail+.image-gallery-thumbnail {
  margin-left: .6rem;
}

.hw-excursion--listProduct .image-gallery-thumbnail.active,
.image-gallery-thumbnail:focus {
  border: 2px solid var(--hw-black);
}

.hw-excursion--listProduct .image-gallery-play-button .image-gallery-svg {
  position: relative;
  left: 2px;
}

.hw-excursion--listProduct .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: .5rem 1rem;
  display: none;
}

.hw-excursion--listProduct .image-gallery {
  background-color: var(--hw-brand-orange-light);
  border-radius: 1rem;
}

.hw-excursion--listProduct .image-gallery-icon.image-gallery-left-nav,
.hw-excursion--listProduct .image-gallery-icon.image-gallery-right-nav {
  filter: none !important;
  background-color: var(--hw-white);
  padding: 0;
  background-size: 1.1rem .9rem;
  width: 2.4rem;
  height: 2.4rem;
  background-repeat: no-repeat;
  background-position: center center;
  border-radius: .5rem;
}

.hw-excursion--listProduct .image-gallery-icon.image-gallery-left-nav svg,
.hw-excursion--listProduct .image-gallery-icon.image-gallery-right-nav svg {
  display: none;
}

.hw-excursion--listProduct .image-gallery-icon.image-gallery-right-nav {
  right: 1.5rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.hw-excursion--listProduct .image-gallery-icon.image-gallery-left-nav {
  left: 1.5rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

/* .hw-excursion--toggleContent ul li {
  word-break: break-all;
} */
.hw-excursion--pickTime .hw-select--dropdown {
  flex: 1 0 0;
  max-width: 50rem;
  position: relative;
}

.hw-dropdown--content {
  position: absolute;
  z-index: 2;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);
  background-color: var(--hw-white);
  width: 100%;
  top: 100%;
  margin-top: 1rem;
  border-radius: 1rem;
}

.hw-dropdown--content .hw-dropdown--hoverItem:not(:last-child) {
  border-bottom: .1rem solid var(--hw-gray-200);
}

.hw-dropdown--content>.hw-dropdown--hoverItem:first-child {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}

.hw-dropdown--content>.hw-dropdown--hoverItem:last-child {
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
}

.float-right {
  float: right;
}

.hw-excursion--pickTime {
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 1rem;
  padding-top: 2rem;
}

.hw-excursion--listProductSelect .hw-excursion--pickTimeCheckout {
  border-top: .1rem solid var(--hw-gray-200);
  padding-top: 2rem;
  margin-top: 2rem;
}

.hw-excursion--selectSlider>div {
  width: 100% !important;
}

.hw-dropdown--hoverItem {
  padding: 1.5rem;
  transition: background-color .2s;
  cursor: pointer;
}

.hw-dropdown--hoverItem:hover {
  background-color: var(--hw-brand-orange-light);
}

.hw-dropdown--summary {
  border: .1rem solid var(--hw-gray-400);
  background-color: var(--hw-white);
  border-radius: 0.5rem;
  padding: .8rem 2rem;
  display: flex;
  align-items: center;
  column-gap: 1rem;
  justify-content: space-between;
  position: relative;
  cursor: pointer;
}

.hw-excursion--toggleContentInclusions ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.hw-excursion--toggleContentExclusions ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.hw-excursion--toggleContentInclusions ul li::before,
.hw-excursion--toggleContentExclusions ul li::before {
  content: '';
  background-size: 2rem 2rem;
  position: absolute;
  width: 2.2rem;
  height: 2.2rem;
  background-position: center center;
  top: .5rem;
  left: 0;
}

.hw-excursion--toggleContentInclusions ul li::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.hw-excursion--toggleContentExclusions ul li::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.hw-excursion--toggleContentInclusions ul li,
.hw-excursion--toggleContentExclusions ul li {
  position: relative;
  list-style: none;
  padding-left: 3rem;
}

.hw-excursion--toggleContent p strong {
  color: var(--hw-black);
}

.hw-excursion--topSearch {
  /* overflow: hidden; */
}

.hw-page--titlebarExcursion {
  padding-bottom: 2rem;
  padding-top: 2rem;
  ;
}

.hw-excursion--modalTable thead th {
  color: var(--hw-black);
  padding-left: 1rem;
  padding-right: 1rem;
}

.hw-excursion--modalTable tbody tr td {
  padding: 1rem 1rem 0;
  vertical-align: top;
}

.hw-excursion--modalTable thead tr th:first-child,
.hw-excursion--modalTable tbody tr td:first-child {
  padding-left: 0;
}

.hw-excursion--modalTable thead tr th:last-child,
.hw-excursion--modalTable tbody tr td:last-child {
  padding-right: 0;
}

.hw-excursion--modalBlock .hw-excursion--listInfoList {
  font-size: 1.8rem;
  color: var(--hw-black);
  line-height: 1.27273;
  font-weight: bold;
}

.hw-excursion--modalBlock {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  row-gap: 1rem;
}

.hw-excursion--modalBlock+.hw-excursion--modalBlock {
  margin-top: 2rem;
}

.hw-modal-header.hw-modal-headerExcursion {
  background-color: var(--hw-brand-orange);
  color: var(--hw-white);
}

.hw-modal-header.hw-modal-headerExcursion .hw-modal-headerTitle {
  color: inherit;
  font-family: var(--hw-head-font-family);
  font-weight: 600;
}

.hw-modal-header.hw-modal-headerExcursion .hw-modal--close {
  background-color: var(--hw-white);
  color: var(--hw-brand-orange);
  border-radius: .8rem;
  padding: .8rem;
}

.hw-modal-header.hw-modal-headerExcursion .hw-modal--close:hover {
  background-color: var(--hw-brand-blue);
  color: var(--hw-white);
}

.hw-modal-header.hw-modal-headerExcursion+.hw-modal-body {
  padding-top: 2rem;
}

.hw-excursion--listInfo.row {
  row-gap: 1rem;
}

.hw-excursion--listProduct+.hw-excursion--listInfo {
  margin-top: 1.6rem;
}

.customer-swiper-excursion .swiper-button-next,
.customer-swiper-excursion .swiper-button-prev {
  border-radius: 1rem;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);
  background-color: var(--hw-brand-blue);
  color: var(--hw-white);
  width: 5rem;
  height: 5rem;
  transition: background-color .2s;
}

.customer-swiper-excursion .swiper-button-next:hover,
.customer-swiper-excursion .swiper-button-prev:hover {
  background-color: var(--hw-brand-blue);
  color: var(--hw-white);
}

.customer-swiper-excursion .swiper-button-prev::after,
.customer-swiper-excursion .swiper-button-next::after {
  font-family: swiper-icons;
  font-size: var(--swiper-navigation-size);
  text-transform: none !important;
  letter-spacing: 0;
  font-variant: initial;
  line-height: 1;
  font-size: 1.8rem;
}

.customer-swiper-excursion .swiper-button-next {
  right: 0;
}

.customer-swiper-excursion .swiper-button-prev {
  left: 0;
}

.hw-excursion--selectSlider .customer-swiper-excursion {
  /* overflow: visible; */
  margin-left: 0;
  margin-right: 0;
  position: static;
  overflow: hidden;
}

.hw-widget--ticketCheckout .hw-passenger--pageList .hw-flight--stepsWrapper+.hw-passenger--wrapper .hw-passenger--list {
  border-right-width: 0;
}

.hw-excursion--topSearch .hw-price--dropdown>div>span:first-child {
  margin-right: .6rem;
}

.hw-excursion--selectSlider {
  position: relative;
}

.hw-passenger--wrapperExcursionCheckout .hw-after--bookingWidget.tickets {
  padding: 0;
  border-radius: 0;
}

@media (hover: hover) and (pointer: fine) {
  .hw-excursion--listProduct .image-gallery-thumbnail:hover {
    border: 2px solid var(--hw-black);
  }
}

@media (min-width: 576px) {
  .hw-img--col120 {
    width: 12rem !important;
  }

  .hw-car--listShow__passangerCol {
    width: calc(100% - 12rem) !important;
    gap: 0.8rem;
  }
}

@media (min-width: 768px) {
  .hw-excursion--modalBlock+.hw-excursion--modalBlock {
    margin-top: 3rem;
  }

  .hw-modal-header.hw-modal-headerExcursion {
    padding-bottom: 4rem;
  }

  .hw-modal-header.hw-modal-headerExcursion+.hw-modal-body {
    padding-top: 4rem;
  }

  .hw-excursion--modalTable thead th {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .hw-excursion--modalTable tbody tr td {
    padding: 2rem 2rem 0;
  }

  .hw-excursion--modalBlock .hw-excursion--listInfoList {
    font-size: 2.2rem;
  }

  .hw-excursion--toggleTitle {
    font-size: 2.2rem;
  }

  .hw-excursion--modalBlock {
    row-gap: 1.6rem;
  }

  .hw-book--selectbtn:not(:hover) {
    opacity: 0;
    transition: opacity .3s !important;
  }

  .hw-book--selectbtn {
    position: relative;
    z-index: 2;
  }

  .whole-link:hover~.content-box .hw-book--selectbtn {
    opacity: 1;
  }

  .hw-modal-header.hw-modal-headerExcursion .hw-modal-headerTitle {
    font-size: 3rem;
    line-height: 1.5;
  }

  .hw-excursion--listProduct .image-gallery-slide .image-gallery-image {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

}

@media (min-width: 992px) {
  .hw-excursion--modalTable thead th {
    font-size: 1.8rem;
    line-height: 1.55556;
  }

  .hw-passenger--fareSummary__tfoot {
    font-size: 2rem;
    line-height: 1.4;
  }

  .hw-page--titlebar.hw-page--titlebarExcursion {
    padding-left: 2rem;
  }

  .hw-book--filterResult .row {
    row-gap: 3.2rem;
    --bs-gutter-x: 2rem;
  }

  .hw-book--filterSlide {
    column-gap: 2rem;
  }



  .hw-excursion--listProductData {
    padding: 2rem;
  }

  .hw-excursion--listProductData>.row {
    row-gap: 2rem;
  }

  .hw-excursion--selectSliderItem {
    /* row-gap: 1.5rem; */
    padding: 2rem;
  }

  .hw-excursion--listProduct .image-gallery-icon.image-gallery-play-button,
  .hw-excursion--listProduct .image-gallery-icon.image-gallery-fullscreen-button {
    padding: 1rem;
    border-radius: 0.5rem;
  }

  .hw-excursion--listProduct .image-gallery-fullscreen-button .image-gallery-svg,
  .hw-excursion--listProduct .image-gallery-play-button .image-gallery-svg {
    height: 20px;
    width: 20px;
  }

  .customer-swiper-excursion .swiper-button-prev {
    left: -3rem;
  }

  .customer-swiper-excursion .swiper-button-next {
    right: -3rem;
  }
}

@media (min-width: 1025px) {

  /* .hw-widget--ticketCheckout .hw-passenger--fareSummary {
    top: 0;
  } */
  .hw-excursion--listProduct .image-gallery-slide.image-gallery-center::after {
    min-height: 34.8rem;
  }
}

@media (min-width: 1100px) {
  .hw-widget.hw-widget--ticketCheckout .hw-passenger--pageList>.hw-passenger--wrapper:first-child {
    min-height: calc(100vh - 11rem);
  }
}

@media (min-width: 1200px) {

  .customer-swiper-excursion .swiper-button-prev {
    left: -5rem;
  }

  .customer-swiper-excursion .swiper-button-next {
    right: -5rem;
  }

  .hw-excursion--listProduct .image-gallery-slide .image-gallery-image {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
}

@media (min-width: 1400px) {
  .customer-swiper-excursion .swiper-button-prev {
    left: -8.5rem;
  }

  .customer-swiper-excursion .swiper-button-next {
    right: -8.5rem;
  }
}

@media (max-width: 767px) {
  .hw-excursion--listProductData .h3 {
    font-size: 2rem;
    line-height: 1.5;
  }

  .hw-excursion--thubmGalleryItem {
    border-radius: 1rem;
  }
}

.hw-btn--secondaryDefault.selected-variation {
  background-color: var(--hw-brand-blue);
  color: var(--hw-white);
}

/* @media (min-width: 1441px) {
.hw-book--filterResult .row > .col-xl-4 {
  width: 25%;
}
}
@media (min-width: 2200px) {
.hw-book--filterResult .row > .col-xl-4 {
  width: 20%;
}
} */

.hw-price--dropdown.active>div span {
  color: var(--hw-black);
}

.hw-price--dropdown.active svg {
  color: var(--hw-brand-orange);
}

.hw-excursion--selectSlider .swiper-slide {
  height: auto;
}

.hw-passenger--wrapperExcursionCheckout .css-b62m3t-container>div {
  width: 100%;
}

.hw-widget--excursionDetails>.mt-3,
.hw-widget--excursionDetails>.hw-excursion--list {
  max-width: 119rem;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.hw-excursion--listProductData .react-datepicker-popper {
  z-index: 5;
}

.hw-sidebar--nav>.nav-item .nav-link.active .hw-icon--flight svg path {
  fill: var(--hw-white);
  stroke: var(--hw-white);
}

.hw-excursion--listProduct .image-gallery,
.hw-excursion--listProduct .image-gallery-content,
.hw-excursion--listProduct .image-gallery-slide-wrapper,
.hw-excursion--listProduct .image-gallery-swipe,
.hw-excursion--listProduct .image-gallery-slides {
  height: 100%;
}

.hw-excursion--listProduct .image-gallery-slide {
  height: 100%;
}

.hw-datepicker--input .react-datepicker-popper {
  z-index: 10;
}

.hw-excursion--toggleContent ul {
  margin-bottom: 0;
}

.hw-excursion--toggleContent ul>li+li {
  margin-top: 1rem;
}

.hw-excursion--listProductData .DT--counter-value input,
.hw-excursion--listProductData .DT--counter-value input:focus-visible {
  width: 100%;
  border: 0;
  height: 100%;
  text-align: center;
  outline: none;
}

/* Chrome, Safari, Edge, Opera */
.hw-excursion--listProductData .DT--counter-value input::-webkit-outer-spin-button,
.hw-excursion--listProductData .DT--counter-value input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.hw-excursion--listProductData .DT--counter-value input[type=number] {
  -moz-appearance: textfield;
}

.hw-excursion--listProductData .react-datepicker__day--excluded {
  color: var(--hw-red);
}

.hw-excursion--selectSliderItem .hw-btn--secondaryDefault.disabled,
.hw-checkout-btn.disabled {
  background-color: var(--hw-gray-400);
  cursor: not-allowed;
  cursor: not-allowed;
  color: var(--hw-white);
  border: none;
}

.hw-checkout-btn.raiseInquiryBtn {
  color: white;
  background-color: #0F294D;
  border-color: transparent;
}

.hw-checkout-btn {
  padding: 15px 28px !important;
}

.DT--counter-display {
  width: 6.7rem;
  max-width: 6.7rem;
  overflow: hidden;
}

.DT--passenger-item .DT--passenger-info {
  display: flex;
  flex-wrap: wrap;
  word-break: break-all;
}

.DT--counter-value input {
  max-width: 6.5rem;
  border: none !important;
  outline: none !important;
  padding: 0;
  text-align: center;
}

.hw-date-range-picker+.react-datepicker__tab-loop {
  position: unset;
}

.hw-date-range-picker-excursion+.react-datepicker__tab-loop .react-datepicker-popper {
  transform: translate(4px, 10px) !important;
}

/*Excursion redesign*/


.ml-auto {
  margin-left: auto;
}

/* .hw-widget.hw-widget--excursionDetails {
  width: 100%;
  overflow-x: hidden;
} */
.hw-tab--scroll__list {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  align-items: center;
  column-gap: 1rem;
  padding: 1.6rem 0;
}

.hw-scroll--listItem {
  padding: .8rem 1.6rem;
  border: .1rem solid var(--hw-gray-400);
  border-radius: 0.5rem;
  font-size: 1.6rem;
  line-height: 1.5;
  font-weight: 500;
  color: var(--hw-black-900);
  text-transform: capitalize;
  transition: .2s ease-out;
  cursor: pointer;
  white-space: nowrap;
  background-color: var(--hw-white);
}

.hw-scroll--listItem:hover {
  background-color: var(--hw-brand-orange-light);
  border-color: var(--hw-brand-orange);
}

.hw-scroll--listItem.active {
  background-color: var(--hw-brand-orange);
  color: var(--hw-white);
  border-color: var(--hw-brand-orange);
}


.hw-stay--stick {
  border: .1rem solid var(--hw-gray-600);
  background-color: var(--hw-white);
  padding: 2rem;
  border-radius: 0.5rem;
}

.hw-stay--stick .unlist {
  list-style: none;
  margin: 2rem 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
}

.hw-stay--stick .unlist li {
  display: flex;
  align-items: flex-start;
  column-gap: .6rem;
}

.hw-stay--stick .unlist li svg {
  width: 2.4rem;
  height: 2.4rem;
  color: var(--hw-brand-orange);
  flex-shrink: 0;
  margin-top: 1%;
}

.hw-stay--stick .unlist li span {
  font-weight: 500;
  color: var(--hw-black-900);
}

.hw-excursion--thubmGallery {
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr 1fr;
  height: 100%;
}

.hw-excursion--thubmGalleryItem {
  background-color: var(--hw-brand-orange-light);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  min-height: 11rem;
}

.hw-excursion--thubmGalleryItem img {
  object-fit: cover;
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
}

.hw-excursion--thubmGalleryItem .hw-btn {
  z-index: 1;
}

.hw-excursion--thubmGalleryItem .hw-btn::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  inset: 0;
}

.hw-excursion--thubmGallery .hw-excursion--thubmGalleryItem:nth-of-type(4)::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.hw-excursion--thubmGallery .hw-excursion--thubmGalleryItem:nth-of-type(2) {
  border-top-right-radius: 0.5rem;
}

.hw-excursion--thubmGallery .hw-excursion--thubmGalleryItem:nth-of-type(4) {
  border-bottom-right-radius: 0.5rem;
}

.hw-excursion--thubmGalleryItem.empty-image {
  color: var(--hw-brand-orange);
}

.hw-person--roomInput .hw-input--input {
  display: grid;
  grid-template-columns: auto 1fr;
  padding-top: 0;
  padding-bottom: 0;
  place-content: center;
}

.hw-person--roomInput .hw-input--input svg {
  grid-row: span 2;
}

.hw-person--roomInput .hw-input--input,
.hw-gp--btn .hw-btn,
.hw-excursion--listProductData .hw-datepicker--input .react-datepicker-wrapper .hw-input--input {
  min-height: 5.8rem;
}

.hw-mt--20 {
  margin-top: 2rem !important;
}

.hw-excursion--availabilityWrapper {
  display: flex;
  column-gap: 1.5rem;
  flex-wrap: wrap;
  row-gap: 1rem;
  justify-content: end;
}

.hw-excursion--availabilityWrapperNoTimeSlots {
  display: flex;
  column-gap: 1.5rem;
  flex-wrap: wrap;
  row-gap: 1rem;
  /* gap: 6.5rem; */
  justify-content: end;
}

.hw-excursion--availabilityWrapper .hw-select--dropdown {
  min-width: 16.7rem;
}

.hw-excursion--selectSliderItem {
  position: relative;
}

.hw-excursion--selectSliderItem .hw-main--loaderCommon {
  position: absolute;
  top: 0;
  width: 100%;
  right: 0;
  min-height: 100%;
}

.hw-excursion--availabilityWrapper .hw-dropdown--content {
  right: 0;
}

.hw-excursion--listProduct .col-md-12>.row {
  row-gap: 1rem;
}

.hw-excursion--checkout {
  display: flex;
  align-items: flex-end;
}

.ml-auto {
  margin-left: auto;
}

@media (min-width: 370px) {
  .hw-excursion--availabilityWrapper .hw-dropdown--content {
    min-width: 32rem;
  }
}

@media (min-width: 480px) {

  .hw-widget--excursionDetails>.mt-3,
  .hw-widget--excursionDetails>.hw-excursion--list {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .hw-excursion--availabilityWrapper {
    column-gap: 3.2rem;
  }
}

@media (min-width : 750px) {

  .hw-person--roomInput .hw-input--input,
  .hw-gp--btn .hw-btn,
  .hw-excursion--listProductData .hw-datepicker--input .react-datepicker-wrapper .hw-input--input {
    min-height: 6.6rem;
  }
}

@media (min-width: 900px) {

  /* .hw-person--roomInput .hw-input--input, .hw-gp--btn .hw-btn,.hw-excursion--listProductData .hw-datepicker--input .react-datepicker-wrapper .hw-input--input {
    min-height: 6.4rem;
  } */
  .hw-scroll--content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    column-gap: 1.6rem;
    margin-top: 2rem;
  }

  .hw-scroll--listItem {
    padding: 1rem 1.6rem;
    font-size: 1.8rem;
    line-height: 1.55556;
  }

  .hw-stay--stick {
    min-width: 34.2rem;
    flex-shrink: 0;
    max-width: 34.2rem;
    position: sticky;
    top: 17rem;
  }



  .hw-book--ticketSection {
    flex: 1 0 0;
  }

  .hw-tab--scroll__list {
    position: sticky;
    top: 7rem;
    z-index: 2;
    background-color: var(--hw-gray-100);
  }
}

@media (min-width: 992px) {
  .hw-tab--scroll__list {
    top: 8.7rem;
  }

  .hw-excursion--selectSliderItem .hw-main--loaderCommon {
    width: 41.66666667%;
  }
}

@media (min-width: 1100px) {

  .hw-scroll--content {
    column-gap: 3.2rem;
  }
}

@media (min-width: 1200px) {
  .hw-excursion--selectSliderItem .hw-main--loaderCommon {
    width: 50%;
  }

  .hw-excursion--availabilityWrapper .hw-dropdown--content {
    min-width: 34rem;
    left: 0;
    right: auto;
  }

}

@media (min-width: 1440px) {
  .hw-excursion--availabilityWrapper {
    column-gap: 4rem;
    padding-left: 4rem;
  }
}

@media (max-width: 991px) {
  .hw-excursion--thubmGalleryItem .hw-btn {
    font-size: 1.4rem;
    padding: .5rem 1rem;
    border-radius: .4rem;
    column-gap: .5rem;
  }

  .hw-excursion--thubmGalleryItem .hw-btn svg {
    width: 2rem;
    height: 2rem;
  }
}

@media (max-width: 899px) {
  .hw-scroll--content {
    display: flex;
    flex-direction: column;
    row-gap: 2rem;
    margin-top: 2rem;

  }

  .hw-scroll--contentList>.hw-excursion--toggleItem:last-child {
    border-bottom-width: 0;
  }

  .hw-tab--scroll__list {
    position: sticky;
    top: 7rem;
    background-color: var(--hw-gray-300);
    z-index: 9;
    margin: 0 -3rem;

  }
}

@media (max-width: 600px) {
  .hw-tab--scroll__list {
    margin: 0 -1.5rem;
  }
}

@media (max-width: 479px) {
  .hw-excursion--checkout {
    flex: 1 0 0;
  }

  .hw-excursion--checkout .hw-btn {
    width: 100%;
  }

  .sxxl-flex--grow {
    flex-grow: 1;
  }
}

@media (max-width: 400px) {
  .hw-person--roomInput .paasenger-modal {
    width: 100%;
  }
}

/*End Excursion redesign*/


.hw-excursion--availabilityWrapper .hw-dropdown--content {
  z-index: 4;
}

.mr-auto {
  margin-right: auto;
}

.hw-widget.hw-widget--excursionDetails .paasenger-modal .DT--card-container .DT--title {
  padding: 1.6rem 1.6rem 0;
  margin-bottom: 0 !important;
}

.hw-widget.hw-widget--excursionDetails .paasenger-modal .DT--card-container .DT--section {
  padding-bottom: 1.6rem;
}

.hw-scroll--contentList .hw-excursion--toggleItem+.hw-excursion--toggleItem {
  margin-top: 2rem;
}

@media (min-width: 768px) {
  .hw-widget.hw-widget--excursionDetails .hw-person--roomInput .paasenger-modal {
    min-width: 47.4rem;
  }

  .hw-excursion--toggleItem+.hw-excursion--toggleItem {
    margin-top: 2rem;
  }
}

@media (min-width: 900px) {
  .hw-excursion--listProductData .hw-person--roomInput .paasenger-modal {
    top: 7rem;
  }
}

@media (max-width: 1024px) {
  .hw-widget--ticketCheckout .hw-passenger--fareSummary {
    position: unset;
    max-height: unset;
  }
}

@media (max-width: 1150px) {
  .time-options-container {
    flex-direction: column;

    gap: 1rem;
  }

  .time-grid {
    max-width: 100% !important;
  }
}


/*New CSS*/
.hw-excursion--mainSearch {
  display: flex;
  flex-direction: column;
  margin-top: 1.5rem;
}

.hw-excursion--mainSearch .hw-widget--card {
  background-color: var(--hw-white);
  position: relative;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.hw-excursion--iconScroll {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  overflow-x: auto;
}

.hw-excursion--categorySlider {
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
  z-index: 2;
}

.hw-excursion--categorySlider .hw-excursion--categorySlider-btn {
  position: absolute;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background-color: var(--hw-white);
  border: 1px solid #3264FF;
  color: var(--hw-black-900);
  font-size: 2.4rem;
  line-height: 1;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  z-index: 2;
}

.hw-excursion--categorySlider-btn.prev {
  left: -1rem;
}

.hw-excursion--categorySlider-btn.next {
  right: -1rem;
}

.hw-excursion--categorySlider .hw-excursion--categorySlider-btn:hover {
  background-color: var(--hw-brand-orange-light);
  border-color: var(--hw-brand-orange);
  color: var(--hw-brand-orange);
}

.hw-excursion--categorySlider .hw-excursion--categorySlider-btn:active {
  transform: scale(0.95);
}

.hw-excursion--categorySlider .hw-excursion--categorySlider-btn.prev {
  order: -1;
}

.hw-excursion--categorySlider .hw-excursion--categorySlider-btn.next {
  order: 1;
}

.hw-excursion--categorySlider .hw-excursion--customSlider {
  flex: 1;
  overflow: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.hw-excursion--categorySlider .hw-excursion--customSlider::-webkit-scrollbar {
  display: none;
}

.hw-excursion--categorySlider .swiper-button-next {
  width: 18px !important;
  height: 18px !important;
  transform: rotate(-90deg) !important;
  aspect-ratio: 1/1 !important;
}

.hw-excursion--iconScrollItem {
  /* padding: 0.5rem 1.2rem;
  border: 1px solid var(--hw-gray-600);
  border-radius: 5px;
  display: flex !important;
  align-items: center;
  gap: 0.8rem;
  white-space: nowrap;
  color: var(--hw-black-900);
  font-size: 1.6rem;
  line-height: 1.5;
  font-weight: 500;
  cursor: pointer;
  transition: 0.2s ease-in-out; */
  border-radius: 5px;
  border: 1px solid #D7D7D7;
  background: var(--White, #FFF);
  display: flex;
  padding: 10px 24px;
  align-items: center;
  gap: 8px;
  color: var(--Violet, #121826);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
}

.hw-excursion--iconScrollItem:hover {
  background-color: var(--hw-brand-blue-light);
  border-color: var(--hw-brand-orange);
  cursor: pointer;
}

.hw-book--filterResult .load-more {
  max-width: 18rem;
  margin-left: auto;
  margin-right: auto;
}

.hw-excursion--thubmGalleryItem .hw-btn {
  column-gap: 0.8rem;
}

.hw-excursion--thubmGalleryItem .hw-btn svg {
  width: 2rem;
  height: 2rem;
}

.image-gallery-swipe .image-gallery-slides {
  border-radius: 0.5rem;
}

.react-datepicker-wrapper .hw-input--input,
.hw-person--roomInput svg {
  color: var(--hw-brand-blue);
}

.hw-excursion--selectSlider p:last-child {
  margin-bottom: 0;
}

.hw-widget--ticketCheckout .hw-passenger--detailsGroup {
  margin-top: 2rem;
}

.hw-passenger--wrapperExcursionCheckout .hw-after--bookingWidget.price-backup {
  padding: 0;
}

/*Time slot design*/
.time-picker-container {
  /* max-width: 79.8rem; */
  background: var(--hw-white);
  padding: 0 0 0 3rem;
}

.time-options-container {
  display: flex;
  gap: 4rem;
  align-items: flex-start;
  justify-content: space-between;
}

.legend {
  display: flex;
  gap: 1.6rem;
  margin-bottom: 1rem;
  align-items: center;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.legend-item-tooltip {
  position: relative;
  display: inline-flex;
  align-items: center;
  /* cursor: help; */
}

.legend-tooltip {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: 3rem;
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  color: var(--hw-black);
  padding: 0.8rem 1.2rem;
  font-size: 1.2rem;
  line-height: 1.5;
  font-weight: 400;
  white-space: normal;
  width: 18rem;
  /* max-width: 90vw; */
  z-index: 1000;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  text-align: center;
  border: 1px solid #3264FF;
}

.legend-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: #3264FF transparent transparent transparent;
}

.legend-item-tooltip:hover .legend-tooltip {
  visibility: visible;
  opacity: 1;
}

.legend-color {
  width: 1.1rem;
  height: 1.2rem;
  border-radius: 2px;
  border: 1px solid transparent;
}

.prime-color {
  background-color: #3264FF;
  border-color: #3264FF;
}

.non-prime-color {
  background-color: #4AB562;
  border-color: #4AB562;
}

.nonprime-color {
  color: #4AB562;
  line-height: 24px;
}

.primecolor {
  color: #3264FF;
  line-height: 24px;
}

.lowticket-color {
  color: #DA102A;
  line-height: 24px;
}

.low-ticket-color {
  background-color: #DA102A;
  border-color: #DA102A;
}

.time-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1.6rem;
  max-width: 79.6rem;
  /* min-width: 79.6rem; */
  min-width: auto;
  /* Remove fixed min-width */
}

.time-slot {
  padding: 0;
  border: 1px solid;
  border-radius: 5px;
  text-align: center;
  font-size: 16px;
  font-weight: normal;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: var(--hw-white);
  user-select: none;
  max-height: 4.5rem;
  max-width: 180px;
}

.time-slot-seats {
  color: #7B7B7B;
  font-weight: 500;
}

.time-slot:hover {
  transform: translateY(-1px);

}

.time-slot.disabled-slot {
  cursor: not-allowed;
  border-color: #DA102A !important;
}

.time-slot.disabled-slot .time-grid--topTime {
  border-radius: 5px !important;
  color: #DA102A !important;
  background-color: #FCEFF1 !important;
}

.time-slot.disabled-slot .time-slot-seats {
  color: #DA102A !important;
}

.time-slot:active,
.time-slot.selected {
  transform: translateY(0);
}

.time-slot.selected {
  cursor: auto;
}

.time-slot.prime {
  border-color: rgba(50, 100, 255, 0.30);
}

.time-slot.open-date {
  border-color: #3264FF;
  max-height: fit-content;
}

.time-slot.open-date:hover,
.time-slot.open-date.selected {
  border-color: #3264FF;
}

.time-slot.prime:hover,
.time-slot.prime.selected {
  border-color: #3264FF;
}

.time-slot.open-date .time-grid--topTime {
  color: #3264FF;
  border-radius: 5px;

}

.time-slot.open-date.selected .time-grid--topTime {
  background-color: #3264FF;
  color: #fff;
}

.time-slot.open-date.selected .time-grid--topTime svg g path {
  stroke: #fff;
}

.time-slot.non-prime {
  border-color: rgba(74, 181, 98, 0.30);
}

.time-slot.low-ticket {
  border-color: rgba(218, 16, 42, 0.30);
}

.time-slot.non-prime:hover,
.time-slot.non-prime.selected {
  border-color: #1EAC3E;
}

.time-slot.low-ticket:hover,
.time-slot.low-ticket.selected {
  border-color: #DA102A;
}

.time-grid--topTime {
  display: flex;
  padding: 1.1rem;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-weight: 700;
  align-self: stretch;
  min-height: 3.6rem;
}

.time-slot.non-prime .time-grid--topTime {
  color: #1EAC3E;
  background-color: rgba(30, 172, 62, 0.10);
}

.time-slot.prime .time-grid--topTime {
  background: rgba(50, 100, 255, 0.10);
  color: #3264FF;
}

.time-slot.low-ticket .time-grid--topTime {
  color: #DA102A;
  background-color: #FCEFF1;
  border-radius: 5px;
}

.time-grid--priceDetails {
  display: flex;
  flex-direction: column;
  row-gap: 0.8rem;
  padding: 0.8rem;
}

.time-grid--priceDetails div>span:first-child {
  margin-right: 0.4rem;
}

.time-slot.non-prime.selected .time-grid--topTime,
.time-slot.non-prime.selected .time-slot-seats {
  background-color: #1EAC3E;
  color: var(--hw-white);
}

.time-slot.low-ticket.selected .time-grid--topTime,
.time-slot.low-ticket.selected .time-slot-seats {
  background-color: #DA102A;
  color: var(--hw-white);
}

.time-slot.prime.selected .time-grid--topTime,
.time-slot.prime.selected .time-slot-seats {
  background-color: #3264FF;
  color: var(--hw-white);
}

.time-options-right {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: -webkit-fill-available;
  max-width: 350px;
}

.time-options-item {
  border-radius: 10px;
  border: 1px solid rgba(215, 215, 215, 0.20);
  background: #FFF;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  padding: 8px 16px;
  flex-direction: column;
  gap: 8px;
  flex: 1 0 0;
}

.time-options-item-price {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}

.time-options-item-price .price {
  overflow: hidden;
  color: var(--hw-brand-blue);
  text-overflow: ellipsis;
  font-weight: 700;
  line-height: 24px;
}

.excursion-error-cls {
  margin-top: 10px;
  max-width: 130px;
}

.hw-excursion--pageLoader {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(1px);
}

.hw-excursion--pageLoaderSpinner {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  border: 0.5rem solid var(--hw-brand-orange-light);
  border-top-color: var(--hw-brand-orange);
  animation: loading 2s linear infinite;
}

.hw-variation--cancellation {
  margin-top: 1.6rem;
}

.hw-variation--cancellation .hw-passenger--listShow__widget {
  padding: 0;
  border: none;
  background: transparent;
  box-shadow: none;
}

.hw-variation--cancellation .hw-text20 {
  font-size: 1.6rem;
}

.hw-cancellation--list,
.hw-cancellation--list ul {
  margin: 0;
  padding-left: 1.8rem;
  list-style: disc;
}

.hw-cancellation--list li {
  font-size: 1.4rem;
  line-height: 1.6;
  color: var(--hw-black-900);
}

.hw-cancellation--list li+li {
  margin-top: 0.6rem;
}

.hw-availability--error {
  margin-top: 0.8rem;
  font-size: 1.3rem;
  line-height: 1.4;
  text-align: right;
}

.excursion-error-cls.w-100 {
  max-width: 100%;
  width: 100%;
  text-align: right;
  white-space: normal;
}

/* Responsive adjustments */
@media (max-width: 640px) {
  .time-grid {
    grid-template-columns: repeat(auto-fit, minmax(90px, 1fr));
    gap: 10px;
  }

  .time-slot {
    /* padding: 10px 12px; */
    font-size: 13px;
    min-width: 90px;
  }

  .legend {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .time-grid--topTime {
    padding: 0;
  }

  .time-slot-seats {
    white-space: nowrap;
    font-size: 10px;
  }

  .excursion-error-cls {
    max-width: 100%;
  }

  .hw-excursion--checkout {
    align-items: flex-start;
  }
}

/*End Time slot design*/


@media (min-width: 768px) {
  .image-gallery-swipe .image-gallery-slides {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .hw-excursion--mainSearch {
    /* margin-top: 11rem; */
  }

  .hw-excursion--mainSearch .hw-widget--card {
    padding: 2.4rem;
  }
}

@media (min-width: 901px) {
  .hw-excursion--iconScroll {
    gap: 1.6rem;
  }

  .hw-excursion--iconScrollItem {
    padding: 0.9rem 2.4rem;
    font-size: 1.8rem;
    line-height: 1.55556;
  }

  .hw-search--excursionList {
    align-items: flex-start;
  }

  /* Keep the sticky filter below the fixed site header so its top
     (Filters bar + search box) is never hidden behind it. */
  .hw-search--excursionList .hw-search--flightFilter {
    top: 9rem;
    max-height: calc(100dvh - 11rem);
  }

  /* .hw-search--excursionList .hw-search--flightFilter__top {
    padding-top: 0.4rem;
    padding-bottom: 0.4rem;
  } */
}

@media (min-width: 1024px) {
  .hw-excursion--thubmGalleryItem .hw-btn {
    padding-left: 2.8rem;
    padding-right: 2.8rem;
  }
}

@media (min-width: 1360px) {

  .hw-person--roomInput .hw-input--input,
  .hw-gp--btn .hw-btn,
  .hw-excursion--listProductData .hw-datepicker--input .react-datepicker-wrapper .hw-input--input {
    min-height: 7.6rem;
  }

  .hw-excursion--listProductData .hw-input--input,
  .hw-excursion--listProductData .hw-gp--btn .hw-btn {
    min-height: 7.6rem !important;
  }
}

.hw-excursion-search .css-1jqq78o-placeholder {
  color: var(--Dark-Blue, #0F294D);
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500 !important;
  line-height: 1.75rem;
  padding-left: 2rem;
  /* margin-left: 2rem !important; */
}

/*End New Design CSS*/

.hw-excursion-search .css-19bb58m {
  padding-left: 1.8rem;
}

.hw-excursion-search .css-1cfo1cf {
  padding-left: 2rem;
}

.hw-excursion-search .css-eegupw-control svg {
  color: var(--hw-brand-blue) !important;
}

.hw-excursion-search .css-b62m3t-container>div {
  background-repeat: no-repeat;
  background-size: 2rem 2rem;
  min-height: 5rem;
  background-position: left 1.5rem center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.hw-excursion-search .css-b62m3t-container>div:hover {
  background-color: var(--hw-brand-orange-light);
  border-color: var(--hw-brand-orange);
  cursor: pointer;
}

.hw-excursion-search .css-b62m3t-container>div>.css-hlgwow {
  padding-left: 1rem;
}

.hw-excursion-search .css-b62m3t-container>div .css-1dimb5e-singleValue {
  padding-left: 2rem;
}

.pb-0 {
  padding-bottom: 0 !important;
}

@media (min-width: 1200px) {

  .hw-person--roomInput .hw-input--input,
  .hw-gp--btn .hw-btn,
  .hw-excursion--listProductData .hw-datepicker--input .react-datepicker-wrapper .hw-input--input {
    min-height: 7.6rem;
  }
}

.hw-date-right-align {
  margin-left: auto;
}

.hw-excursion--listProduct .image-gallery-icon.image-gallery-fullscreen-button:hover {
  background-color: #3264FF;
}

.hw-excursion--listProduct .image-gallery-icon.image-gallery-fullscreen-button:hover svg path {
  fill: white !important;
}

@media (max-width: 468px) {
  .hw-excursion-search>div:first-child {
    width: 100% !important;
  }

  .hw-excursion-banner-title {
    font-size: 25px;
  }

  .time-picker-container {
    padding: 0;
  }

  .time-grid {
    min-width: 9rem !important;
  }

  .time-options-right {
    min-width: auto;
  }
}

@media (max-width: 1268px) {
  .time-grid {
    min-width: max-content;
  }

  .time-options-right {
    width: 30rem;
  }
}

.hw-excursion--note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
}

.hw-p-success-cls {
  color: #1EAC3E;
}

.hw-excursion--note.note-seat-available {
  border-radius: 5px;
  background: #FBE7EA;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px;
  color: #DA102A;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin-top: 2rem;
  flex-wrap: wrap;
}

.hw-excursion--note.note-seat-available svg {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  margin-top: 2px;
}

.hw-excursion--note.seat-available {
  border-radius: 5px;
  background: #E7F5E9;
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  color: #0A7519;
  margin-top: 2rem;
}

.hw-excursion--note.note-seat-available span {
  white-space: nowrap;
}

.hw-excursion--error-cls {
  /* bottom: -120% !important; */
  position: absolute;
  top: 8%;
  right: 15%;
}

.opendate-color svg {
  width: 1.5rem !important;
  height: 1.5rem !important;
}

@media (max-width : 1100px) {
  .hw-excursion--error-cls {
    right: 18%;
  }
}

@media (max-width: 768px) {
  .hw-excursion--note.note-seat-available {
    font-size: 14px;
    line-height: 20px;
    padding: 10px;
    gap: 6px;
    margin-top: 1.5rem;
  }

  .hw-excursion--note.note-seat-available svg {
    width: 18px;
    height: 18px;
  }

  .hw-excursion-search>div:first-child {
    width: 70% !important;
  }

  .hw-excursion--error-cls {
    top: 13%;
    right: 25%;
  }
}

@media (max-width: 480px) {
  .hw-excursion-search>div:first-child {
    width: 100% !important;
  }

  .hw-excursion--note.note-seat-available {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .hw-excursion--note.note-seat-available span {
    white-space: normal;
  }

  .hw-excursion--error-cls {
    top: 13%;
    right: 15%;
  }
}

.hw-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid white;
  border-top: 3px solid transparent;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

.hw-excursion-banner-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(15, 41, 77, 0.4) 0%, rgba(15, 41, 77, 0.6) 100%);
  z-index: 1;
}

.hw-excursion-banner-title {
  position: relative;
  z-index: 2;
  font-family: 'Poppins', sans-serif;
  font-size: 3.6rem;
  font-weight: 600;
  color: var(--hw-white);
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  margin-bottom: 2rem;
}

.hw-excursion-search-widget {
  position: relative;
  z-index: 20;
  background: var(--hw-white);
  border-radius: 1.2rem;
  padding: 1.5rem 2.5rem;
  box-shadow: 0 10px 40px rgba(15, 41, 77, 0.15);
  display: flex;
  align-items: stretch;
  gap: 2rem;
  width: 100%;
  max-width: 100%;
  margin-top: 1rem;
}

.hw-excursion-search-col {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.hw-excursion-search-col label {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--hw-gray-500);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.hw-excursion-search-btn {
  background-color: var(--hw-brand-orange);
  color: var(--hw-white);
  border: none;
  border-radius: 0.8rem;
  padding: 0;
  cursor: pointer;
  transition: all 0.3s ease;
  flex: 1;
  min-height: 5.5rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hw-excursion-search-col-btn {
  flex: 0 0 10rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.hw-excursion-search-btn svg {
  width: 2.2rem;
  height: 2.2rem;
}

/* Travel date field in hero search widget */
.hw-excursion-search-col .react-datepicker-wrapper,
.hw-excursion-search-col .hw-excursion-search-datepicker {
  display: flex;
  flex: 1;
  width: 100%;
}

.hw-excursion-search-col-date .react-datepicker__input-container {
  display: flex;
  width: 100%;
}

.hw-excursion-search-col-date .hw-input--input {
  display: flex;
  align-items: center;
  column-gap: 1rem;
  min-height: 5.5rem;
  height: 100%;
  width: 100%;
  padding: 0 1.4rem;
  border: 1px solid var(--hw-gray-400);
  border-radius: 4px;
  background-color: var(--hw-white);
  cursor: pointer;
  font-size: 1.4rem;
  position: relative;
}

.hw-excursion-search-col-date .hw-input--input:hover {
  border-color: var(--hw-brand-orange);
}

.hw-excursion-search-col-date .hw-input--input svg {
  flex-shrink: 0;
}

.hw-excursion-search-col-date .hw-date--selectedDate {
  font-weight: 500;
  color: var(--hw-black-900);
}

.hw-excursion-search-col-date {
  position: relative;
}

/* Anchor the calendar directly below the field, flush with the widget's bottom edge */
.hw-excursion-search-col-date .react-datepicker__tab-loop {
  position: absolute;
  top: calc(100% + 1.6rem);
  left: 0;
  width: 100%;
  z-index: 30;
}

.hw-excursion-search-col-date .react-datepicker-popper {
  position: static !important;
  transform: none !important;
  width: 100%;
  margin: 0;
  padding: 0;
}

.hw-excursion-search-col-date .react-datepicker {
  width: 100%;
  background-color: var(--hw-white);
  border: 1px solid var(--hw-gray-400);
  border-radius: 1.2rem;
  padding: 1.6rem;
  box-shadow: 0 10px 40px rgba(15, 41, 77, 0.2);
}

.hw-excursion-search-col-date .react-datepicker__month-container {
  float: none;
  width: 100%;
}

.hw-excursion-search-col-date .react-datepicker__day-names,
.hw-excursion-search-col-date .react-datepicker__week {
  display: flex;
  column-gap: 0.5rem;
  width: 100%;
}

.hw-excursion-search-col-date .react-datepicker__day-name,
.hw-excursion-search-col-date .react-datepicker__day {
  flex: 1 1 0;
  width: auto;
  min-width: 0;
  margin: 0;
  text-align: center;
}

.hw-select--option {
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 1rem 1.4rem;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.hw-select--option .hw-select--optionRow {
  display: flex;
  align-items: center;
  column-gap: 1rem;
  width: 100%;
  pointer-events: none;
}

.hw-select--option.is-focused,
.hw-select--option:hover {
  background-color: var(--hw-brand-orange-light);
}

.hw-select--option.is-selected {
  background-color: var(--hw-brand-orange-light);
  font-weight: 600;
}

.hw-excursion-search-col-date .hw-blue.overflow-hidden {
  flex: 1;
  min-width: 0;
  overflow: visible;
}

.hw-excursion-search-col-date .hw-date--selectedDate {
  display: block;
  line-height: 1.6;
  padding-block: 0.2rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hw-excursion-search-col-date .hw-line--height1 {
  line-height: 1.6;
}

.hw-excursion-search-col-date .react-datepicker__day--outside-month:not([aria-disabled="true"]),
.hw-date-range-picker-excursion+.react-datepicker__tab-loop .react-datepicker__day--outside-month:not([aria-disabled="true"]) {
  cursor: pointer;
  color: var(--hw-gray-700);
}

.hw-excursion-search-col-date .react-datepicker__day--outside-month:not([aria-disabled="true"]):hover,
.hw-date-range-picker-excursion+.react-datepicker__tab-loop .react-datepicker__day--outside-month:not([aria-disabled="true"]):hover {
  background-color: var(--hw-brand-orange-light) !important;
  color: var(--hw-brand-orange);
}

.hw-excursion-search-skeleton {
  flex: 1;
  display: flex;
  min-height: 5.5rem;
  width: 100%;
}

.hw-excursion-search-skeleton .react-loading-skeleton {
  height: 100%;
  width: 100%;
}

.hw-excursion-search-error {
  font-size: 1.2rem;
  color: var(--hw-red, #e02424);
  line-height: 1.3;
  margin-top: 0.2rem;
}

.hw-excursion-search-col-date .hw-input--input.hw--error-cls-date-input {
  border-color: var(--hw-red, #e02424);
}

@media (max-width: 992px) {
  .hw-excursion-search-col-btn {
    flex: 1;
  }

  .hw-excursion-search-col-btn label {
    display: none;
  }
}

.hw-excursion-search-btn:hover {
  background-color: var(--hw-brand-orange-hover);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(50, 100, 255, 0.3);
}

.hw-excursion-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  /* border-left: 4px solid var(--hw-brand-orange);
  padding-left: 1.5rem; */
}

.hw-excursion-section-title {
  font-family: 'Poppins';
  font-size: 2.4rem;
  font-weight: 600;
  color: var(--hw-black-900);
  margin-bottom: 0;
}

.hw-excursion-section-subtitle {
  font-size: 1.4rem;
  color: var(--hw-gray-500);
  margin-top: 0.4rem;
}

.hw-excursion-slider-container {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.hw-excursion-card-slider {
  display: flex;
  gap: 2rem;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: 1rem 0;
  width: 100%;
}

.hw-excursion-card-slider::-webkit-scrollbar {
  display: none;
}

.hw-excursion-premium-card {
  flex: 0 0 28rem;
  background: var(--hw-white);
  border-radius: 1rem;
  border: 1px solid var(--hw-gray-200);
  overflow: hidden;
  position: relative;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
}

.hw-excursion-premium-card:hover {
  /* transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(15, 41, 77, 0.1); */
  border-color: var(--hw-brand-orange);
}

.hw-excursion-card-img-wrapper {
  position: relative;
  width: 100%;
  height: 18rem;
  overflow: hidden;
}

.hw-excursion-card-img-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.hw-excursion-premium-card:hover .hw-excursion-card-img-wrapper img {
  transform: scale(1.1);
}

.hw-excursion-card-badge {
  position: absolute;
  top: 1rem;
  left: 1rem;
  background-color: var(--hw-brand-blue);
  color: var(--hw-white);
  font-size: 1.1rem;
  font-weight: 700;
  padding: 0.4rem 0.8rem;
  border-radius: 0.4rem;
  z-index: 2;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.hw-excursion-card-content {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.hw-excursion-card-category {
  font-size: 1.2rem;
  color: var(--hw-brand-orange);
  font-weight: 600;
  margin-bottom: 0.6rem;
  text-transform: uppercase;
}

.hw-excursion-card-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--hw-black-900);
  line-height: 1.4;
  margin-bottom: 1rem;
  height: 4.4rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.hw-excursion-card-meta {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1.2rem;
  color: var(--hw-gray-500);
  margin-bottom: 1.5rem;
}

.hw-excursion-card-meta-item {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.hw-excursion-card-rating {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  color: #ffc107;
  font-weight: 700;
}

.hw-excursion-card-rating span {
  color: var(--hw-black-900);
}

.hw-excursion-card-footer {
  margin-top: auto;
  border-top: 1px solid var(--hw-gray-200);
  padding-top: 1.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.hw-excursion-card-price {
  display: flex;
  flex-direction: column;
}

.hw-excursion-card-price-label {
  font-size: 1.1rem;
  color: var(--hw-gray-500);
}

.hw-excursion-card-price-amount {
  font-size: 1.8rem;
  font-weight: 800;
  color: var(--hw-black-900);
}

.hw-excursion-card-btn {
  background-color: var(--hw-brand-orange-light);
  color: var(--hw-brand-orange);
  border: 1px solid transparent;
  border-radius: 0.6rem;
  padding: 0.6rem 1.2rem;
  font-size: 1.3rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
}

.hw-excursion-card-btn:hover {
  background-color: var(--hw-brand-orange);
  color: var(--hw-white);
}

.hw-excursion-grid-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2.5rem;
  margin-top: 1rem;
}

.hw-excursion-slider-nav-btn {
  position: absolute;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  background-color: var(--hw-white);
  border: 1px solid var(--hw-brand-orange);
  color: var(--hw-brand-orange);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.hw-excursion-slider-nav-btn:hover:not(:disabled) {
  background-color: var(--hw-brand-orange);
  color: var(--hw-white);
  box-shadow: 0 4px 12px rgba(50, 100, 255, 0.3);
}

.hw-excursion-slider-nav-btn:disabled {
  cursor: not-allowed;
  opacity: 0.4;
  border-color: var(--hw-gray-400);
  color: var(--hw-gray-500);
  background-color: var(--hw-white);
  box-shadow: none;
}

.hw-excursion-slider-nav-btn.prev {
  left: -2rem;
}

.hw-excursion-slider-nav-btn.next {
  right: -2rem;
}

@media (max-width: 992px) {
  .hw-excursion-search-widget {
    flex-direction: column;
    padding: 2rem;
    gap: 1.5rem;
    align-items: stretch;
  }

  .hw-excursion-search-btn {
    width: 100%;
    margin-top: 1rem;
  }

  .hw-excursion-grid-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .hw-excursion-grid-container {
    grid-template-columns: 1fr;
  }

  .hw-excursion-banner-title {
    font-size: 2.2rem;
    text-align: center;
  }
}

.typewriter-text {
  color: #ffc107;
  font-weight: 700;
  border-right: 2px solid #ffc107;
  padding-right: 5px;
  animation: blink-cursor 0.75s step-end infinite;
}

@keyframes blink-cursor {

  from,
  to {
    border-color: transparent
  }

  50% {
    border-color: #ffc107;
  }
}

.hw-excursion-banner-title.single-line {
  white-space: nowrap;
}

@media (max-width: 768px) {
  .hw-excursion-banner-title.single-line {
    font-size: 2.2rem;
    white-space: normal;
  }
}

/* Best Cities to Visit — immersive image cards */
.hw-city-card {
  position: relative;
  height: 30rem;
  border-radius: 1.6rem;
  overflow: hidden;
  cursor: pointer;
  opacity: 0;
  transition: box-shadow 0.4s ease;
}

.hw-city-slider {
  cursor: grab;
  user-select: none;
}

.hw-city-slider.dragging {
  cursor: grabbing;
}

.hw-city-slider.dragging .hw-city-card {
  pointer-events: none;
}

/* Scroll-in entrance (staggered via inline animation-delay) */
.hw-city-slider.in-view .hw-city-card {
  animation: hwCityCardIn 0.65s cubic-bezier(0.165, 0.84, 0.44, 1) both;
}

@keyframes hwCityCardIn {
  from {
    opacity: 0;
    transform: translateY(2.8rem) scale(0.97);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  .hw-city-slider.in-view .hw-city-card {
    animation: none;
    opacity: 1;
  }
}

.hw-city-card-media {
  position: absolute;
  inset: 0;
}

.hw-city-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.7s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.hw-city-card:hover .hw-city-card-img {
  transform: scale(1.08);
}

.hw-city-card-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(15, 41, 77, 0) 35%, rgba(15, 41, 77, 0.35) 65%, rgba(15, 41, 77, 0.75) 100%);
}

.hw-city-card-overlay::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(15, 41, 77, 0.1) 0%, rgba(15, 41, 77, 0.85) 100%);
  opacity: 0;
  transition: opacity 0.4s ease;
}

.hw-city-card:hover .hw-city-card-overlay::after {
  opacity: 1;
}

.hw-city-card-weather {
  position: absolute;
  top: 1.2rem;
  right: 1.2rem;
  z-index: 2;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(4px);
  color: var(--hw-black-900);
  font-size: 1.2rem;
  font-weight: 600;
  padding: 0.4rem 1rem;
  border-radius: 99rem;
}

.hw-city-card-content {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  padding: 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  transform: translateY(3.4rem);
  transition: transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.hw-city-card:hover .hw-city-card-content {
  transform: translateY(0);
}

.hw-city-card-subtitle {
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.75);
  margin-bottom: 0;
}

.hw-city-card-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--hw-white);
  line-height: 1.3;
  margin-bottom: 0.6rem;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.hw-city-card-cta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  opacity: 0;
  transform: translateY(8px);
  transition: opacity 0.35s ease 0.08s, transform 0.35s ease 0.08s;
}

.hw-city-card:hover .hw-city-card-cta {
  opacity: 1;
  transform: translateY(0);
}

.hw-city-card-cta-label {
  font-size: 1.3rem;
  font-weight: 600;
  color: var(--hw-white);
}

.hw-city-card-arrow {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background: var(--hw-white);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--hw-black-900);
  transition: background 0.25s ease, color 0.25s ease, transform 0.25s ease;
}

.hw-city-card:hover .hw-city-card-arrow {
  background: var(--hw-brand-orange);
  color: var(--hw-white);
  transform: translateX(0.3rem);
}

.hw-city-card-arrow svg {
  width: 1.6rem;
  height: 1.6rem;
}

/* Touch devices: no hover — keep content and CTA fully visible */
@media (hover: none) {
  .hw-city-card-content {
    transform: translateY(0);
  }

  .hw-city-card-cta {
    opacity: 1;
    transform: none;
  }
}

.hw-abu-dhabi-card {
  position: relative;
  border-radius: 1.6rem;
  overflow: hidden;
  height: 36rem;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.hw-abu-dhabi-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

.hw-abu-dhabi-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.hw-abu-dhabi-card:hover .hw-abu-dhabi-card-img {
  transform: scale(1.05);
}

.hw-abu-dhabi-card-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.8) 100%);
  z-index: 1;
  pointer-events: none;
}

.hw-abu-dhabi-card-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 2rem;
  z-index: 2;
  color: var(--hw-white);
}

.hw-abu-dhabi-card-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--hw-white);
  margin-bottom: 0.8rem;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
}

.hw-abu-dhabi-card-desc {
  font-size: 1.3rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 1.2rem;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
}

.hw-abu-dhabi-card-price {
  font-size: 2rem;
  font-weight: 700;
  color: var(--hw-white);
}

.hw-abu-dhabi-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2.5rem;
  margin-top: 1rem;
}

@media (max-width: 992px) {
  .hw-abu-dhabi-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .hw-abu-dhabi-grid {
    grid-template-columns: 1fr;
  }
}

.hw-rak-card {
  position: relative;
  border-radius: 2rem;
  background: var(--hw-white);
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  padding: 1.2rem;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.hw-rak-card-img-wrapper {
  position: relative;
  width: 100%;
  height: 20rem;
  border-radius: 1.6rem;
  overflow: hidden;
}

.hw-rak-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.hw-rak-card-badge {
  position: absolute;
  top: 1.2rem;
  left: 1.2rem;
  background: var(--hw-brand-orange);
  color: var(--hw-white);
  padding: 0.4rem 1rem;
  border-radius: 1rem;
  font-size: 1.1rem;
  font-weight: 700;
  z-index: 2;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.hw-rak-card-info {
  padding: 1.6rem 0.8rem 0.8rem 0.8rem;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  transition: transform 0.3s ease;
}

.hw-rak-card-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--hw-black-900);
  margin-bottom: 0.8rem;
  line-height: 1.3;
  transition: color 0.3s ease;
}

.hw-rak-card-desc {
  font-size: 1.2rem;
  color: var(--hw-gray-500);
  line-height: 1.5;
  margin-bottom: 1.5rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.hw-rak-card-footer {
  /* margin-top: auto; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.hw-rak-card-price {
  font-size: 1.8rem;
  font-weight: 800;
  color: var(--hw-brand-orange);
}

.hw-rak-card-arrow {
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--hw-black-900);
  transition: all 0.3s ease;
}

.hw-rak-card-arrow svg {
  width: 1.6rem;
  height: 1.6rem;
}

.hw-rak-card:hover {
  border-color: rgba(255, 127, 80, 0.2);
}

.hw-rak-card:hover .hw-rak-card-img {
  transform: scale(1.08) rotate(1deg);
}

.hw-rak-card:hover .hw-rak-card-title {
  color: var(--hw-brand-orange);
}

.hw-rak-card:hover .hw-rak-card-arrow {
  background: var(--hw-brand-orange);
  color: var(--hw-white);
  transform: translateX(3px);
}

.hw-abu-dhabi-card-badge {
  position: absolute;
  top: 1.5rem;
  left: 1.5rem;
  background: var(--hw-brand-orange);
  color: var(--hw-white);
  padding: 0.4rem 1rem;
  border-radius: 1rem;
  font-size: 1.1rem;
  font-weight: 700;
  z-index: 2;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

/* /excursion/cities — all cities directory page */

.hw-cities-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.hw-cities-page-title {
  font-size: 2.4rem;
  font-weight: 700;
  color: var(--hw-black-900);
  margin: 0;
}

.hw-cities-filter {
  display: flex;
  gap: 1rem;
  overflow-x: auto;
  padding: 0.4rem 0.2rem;
  scrollbar-width: none;
  -ms-overflow-style: none;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  outline: none;
  cursor: grab;
  user-select: none;
}

.hw-cities-filter.dragging {
  cursor: grabbing;
  scroll-behavior: auto;
}

.hw-cities-filter.dragging .hw-cities-chip {
  pointer-events: none;
}

.hw-cities-filter:focus-visible {
  border-radius: 0.6rem;
  box-shadow: 0 0 0 2px var(--hw-brand-orange-light);
}

.hw-cities-filter::-webkit-scrollbar {
  display: none;
}

.hw-cities-chip {
  flex-shrink: 0;
  padding: 0.8rem 1.6rem;
  background: var(--hw-white);
  border: 1px solid var(--hw-gray-400);
  border-radius: 0.6rem;
  font-size: 1.3rem;
  font-weight: 500;
  color: var(--hw-black-900);
  white-space: nowrap;
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease, background-color 0.2s ease;
}

.hw-cities-chip:hover {
  border-color: var(--hw-brand-orange);
  color: var(--hw-brand-orange);
}

.hw-cities-chip.active {
  border-color: var(--hw-brand-orange);
  color: var(--hw-brand-orange);
  background: var(--hw-brand-orange-light);
}

.hw-cities-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 2rem;
  margin-top: 2.4rem;
}

@media (max-width: 1200px) {
  .hw-cities-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 768px) {
  .hw-cities-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 576px) {
  .hw-cities-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.hw-cities-card {
  background: var(--hw-white);
  border: 1px solid var(--hw-gray-300, #e9ecef);
  border-radius: 1.2rem;
  padding: 1rem;
  cursor: pointer;
  transition: box-shadow 0.25s ease, transform 0.25s ease, border-color 0.25s ease;
}

.hw-cities-card:hover {
  border-color: var(--hw-gray-400);
  box-shadow: 0 10px 24px rgba(15, 41, 77, 0.12);
  transform: translateY(-2px);
}

.hw-cities-card-img-wrapper {
  border-radius: 0.8rem;
  overflow: hidden;
  aspect-ratio: 1 / 1;
}

.hw-cities-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.hw-cities-card:hover .hw-cities-card-img {
  transform: scale(1.06);
}

.hw-cities-card-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--hw-black-900);
  line-height: 1.35;
  margin-top: 1.2rem;
}

.hw-cities-card:hover .hw-cities-card-title {
  color: var(--hw-brand-orange);
}

.hw-cities-card-country {
  font-size: 1.2rem;
  color: var(--hw-gray-500);
  margin-top: 0.4rem;
}
/* ============================================================
   Excursion checkout redesign (stepped) — scoped .hw-exchk
   ============================================================ */
.hw-exchk { width: 100%; }
.hw-exchk--body { max-width: 144rem; width: 100%; margin-left: auto; margin-right: auto; padding: 0 1.5rem 40px; }
.hw-exchk--heroInner { max-width: 144rem; width: 100%; margin-left: auto; margin-right: auto; padding: 0 1.5rem; }
@media (min-width: 600px) { .hw-exchk--body, .hw-exchk--heroInner { padding-left: 3rem; padding-right: 3rem; } }
@media (min-width: 1200px) { .hw-exchk--body, .hw-exchk--heroInner { padding-left: 5rem; padding-right: 5rem; } }
@media (min-width: 1300px) { .hw-exchk--body, .hw-exchk--heroInner { padding-left: 6rem; padding-right: 6rem; } }
@media (min-width: 1400px) { .hw-exchk--body, .hw-exchk--heroInner { padding-left: 10rem; padding-right: 10rem; } }
.hw-exchk--hero { background: linear-gradient(120deg, #283D6B 0%, #22335e 52%, #3264FF 165%); border-radius: 0; padding: 18px 0 60px; margin: 0; color: #fff; box-shadow: 0 10px 26px -18px rgba(40,61,107,.5); min-height: 147px; }
.hw-exchk--hero .hw-exchk--back { color: rgba(255,255,255,.85); }
.hw-exchk--hero .hw-exchk--back:hover { color: #fff; }
.hw-exchk--heroBar { display: flex; align-items: center; justify-content: space-between; gap: 20px; flex-wrap: wrap; margin-top: 4px; }
.hw-exchk--heroTitle { margin: 0; color: #fff; font-weight: 700; font-size: clamp(20px, 2.4vw, 27px); }
.hw-exchk--hero .hw-exchk--step { color: rgba(255,255,255,.6); }
.hw-exchk--hero .hw-exchk--step:not(:last-child)::after { background: rgba(255,255,255,.28); }
.hw-exchk--hero .hw-exchk--step.is-done:not(:last-child)::after { background: rgba(255,255,255,.55); }
.hw-exchk--hero .hw-exchk--stepNum { background: rgba(255,255,255,.18); color: #fff; border: 1.5px solid rgba(255,255,255,.5); }
.hw-exchk--hero .hw-exchk--step.is-active { color: #fff; }
.hw-exchk--hero .hw-exchk--step.is-active .hw-exchk--stepNum { background: #fff; color: #283D6B; border-color: #fff; }
.hw-exchk--hero .hw-exchk--step.is-done { color: #fff; }
.hw-exchk--hero .hw-exchk--step.is-done .hw-exchk--stepNum { background: #4ade80; color: #0f3d22; border-color: #4ade80; }
.hw-exchk--back { display: inline-flex; align-items: center; gap: 6px; background: none; border: none; color: #556; font-weight: 600; cursor: pointer; padding: 6px 8px 6px 0; }
.hw-exchk--back:hover { color: #3264FF; }
.hw-exchk--steps { list-style: none; display: flex; align-items: center; gap: 6px; margin: 0; padding: 0; }
.hw-exchk--step { display: flex; align-items: center; gap: 8px; color: #98a2b6; font-weight: 600; font-size: 14px; }
.hw-exchk--step:not(:last-child)::after { content: ""; width: 30px; height: 2px; background: #e2e6ee; margin: 0 6px; border-radius: 2px; }
.hw-exchk--step.is-done:not(:last-child)::after { background: #b8d8c3; }
.hw-exchk--stepNum { width: 26px; height: 26px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; background: #eef1f7; color: #98a2b6; font-size: 13px; font-weight: 700; }
.hw-exchk--step.is-active { color: #1b2439; }
.hw-exchk--step.is-active .hw-exchk--stepNum { background: #3264FF; color: #fff; }
.hw-exchk--step.is-done { color: #283D6B; cursor: pointer; }
.hw-exchk--step.is-done .hw-exchk--stepNum { background: #137333; color: #fff; }

.hw-exchk--grid { display: grid; grid-template-columns: minmax(0,1fr) 450px; gap: 2rem; align-items: start; margin-top: -34px; position: relative; z-index: 1; }
.hw-exchk--main { min-width: 0; }
.hw-exchk--panel { background: #fff; border: 1px solid #eceef3; border-radius: 6px; padding: 22px; box-shadow: 0 1px 2px rgba(16,24,40,.04); }
.hw-exchk--panelTitle { font-size: 18px; font-weight: 700; color: #1b2439; margin-bottom: 14px; }
.hw-exchk--sectionHead { display: flex; align-items: center; gap: 12px; padding-bottom: 14px; margin-bottom: 20px; border-bottom: 1px solid #eceef3; }
.hw-exchk--sectionIcon { display: inline-flex; align-items: center; justify-content: center; width: 36px; height: 36px; flex-shrink: 0; border-radius: 10px; background: #ebefff; color: #3264ff; }
.hw-exchk--sectionIcon svg { width: 18px; height: 18px; color: #3264ff; }
.hw-exchk--sectionTitle { font-size: 18px; font-weight: 700; color: #1b2439; letter-spacing: -0.01em; }
.hw-exchk--sectionHead__toggle { cursor: pointer; user-select: none; margin-bottom: 0; transition: margin-bottom .25s ease; }
.hw-exchk--sectionHead__toggle.is-open { margin-bottom: 20px; }
.hw-exchk--sectionToggle { display: inline-flex; align-items: center; gap: 10px; margin-left: auto; }
.hw-exchk--sectionMeta { font-size: 13px; font-weight: 600; color: black; margin-left: auto; }
.hw-exchk--sectionToggle .hw-exchk--sectionMeta { margin-left: 0; }
.hw-exchk--sectionChevron { display: inline-flex; align-items: center; justify-content: center; color: black; transition: transform .25s ease; }
.hw-exchk--sectionChevron svg { width: 20px; height: 20px; }
.hw-exchk--sectionHead__toggle.is-open .hw-exchk--sectionChevron { transform: rotate(180deg); }

.hw-exchk--collapseWrapper { display: grid; grid-template-rows: 0fr; transition: grid-template-rows .3s cubic-bezier(0.4, 0, 0.2, 1); overflow: hidden; }
.hw-exchk--collapseWrapper.is-open { grid-template-rows: 1fr; }
.hw-exchk--collapseInner { min-height: 0; overflow: hidden; }
.hw-exchk--stickyFoot { position: sticky; bottom: 0; z-index: 3; display: flex; justify-content: flex-end; background: #fff; margin: 22px -22px -22px; padding: 16px 22px; border-top: 1px solid #eef1f7; border-radius: 0 0 6px 6px; }
.hw-exchk--agree { margin-top: 16px; }
.hw-exchk--agreeCheck { display: flex; align-items: flex-start; gap: 10px; font-size: 13.5px; color: #4b5563; line-height: 1.55; cursor: pointer; }
.hw-exchk--agreeCheck input { width: 18px; height: 18px; margin-top: 1px; flex-shrink: 0; accent-color: #3264FF; cursor: pointer; }
.hw-exchk--agreeCheck a { color: #3264FF; text-decoration: underline; }
.hw-exchk--agree .hw-p-error-cls { margin-top: 2rem; }
.hw-exchk--panelHint { font-size: 13.5px; color: #6b7280; margin: -6px 0 16px; }
.hw-exchk--field { margin-top: 16px; }
.hw-exchk--label { display: block; font-weight: 600; color: #1b2439; margin-bottom: 6px; font-size: 14px; }
.hw-exchk--optional { color: #98a2b6; font-weight: 500; }
.hw-exchk--panelFoot { margin-top: 20px; display: flex; }
.hw-exchk--panelFoot--split { justify-content: space-between; gap: 12px; }
.hw-exchk--btnWide { min-width: 200px; }
.hw-exchk--panelFoot .hw-btn { min-width: 100px;column-gap: 0rem; }

.hw-exchk--aside { position: sticky; top: 110px; align-self: start; }
.hw-exchk--summary { background: #fff; border: 1px solid #eceef3; border-radius: 6px; padding: 18px; box-shadow: 0 1px 2px rgba(16,24,40,.04); }
.hw-exchk--summaryHead { font-size: 16px; font-weight: 700; color: #1b2439; margin-bottom: 14px; }
.hw-exchk--miniTour { display: flex; gap: 12px; padding-bottom: 14px; margin-bottom: 14px; border-bottom: 1px solid #eef1f7; }
.hw-exchk--miniTour img { width: 64px; height: 64px; border-radius: 10px; object-fit: cover; flex: none; }
.hw-exchk--miniInfo { min-width: 0; }
.hw-exchk--miniTitle { font-weight: 700; color: #1b2439; font-size: 14px; line-height: 1.3; }
.hw-exchk--miniMeta { color: #6b7280; font-size: 12.5px; margin-top: 3px; }
.hw-exchk--trust { list-style: none; margin: 14px 0 0; padding: 14px 0 0; border-top: 1px solid #eef1f7; display: grid; gap: 10px; }
.hw-exchk--trust li { display: flex; align-items: center; gap: 9px; color: #283D6B; font-size: 13px; font-weight: 600; }
.hw-exchk--trust svg { color: #3264FF; flex: none; }
.hw-exchk--asideCta { margin-top: 16px; padding-top: 16px; border-top: 1px solid #eef1f7; display: grid; gap: 8px; }
.hw-exchk--asideCta .hw-btn { width: 100%; }
.hw-exchk--asideBack { background: none; border: none; color: #556; font-weight: 600; font-size: 13px; cursor: pointer; padding: 4px; }
.hw-exchk--asideBack:hover { color: #3264FF; }
.hw-exchk--bookingRef { margin-top: 18px; padding-top: 18px; border-top: 1px solid #eef1f7; }

.hw-exchk--payGrid { display: flex; flex-wrap: wrap; gap: 12px; }
.hw-exchk--method { display: flex; align-items: center; gap: 14px; flex: 1 1 240px; min-width: 0; text-align: left; background: #fff; border: 1.5px solid #e2e6ee; border-radius: 12px; padding: 16px; cursor: pointer; transition: border-color .15s, box-shadow .15s, background .15s; }
.hw-exchk--method:hover { border-color: #c3ccdb; }
.hw-exchk--method.is-selected { border-color: #3264FF; background: #f5f8ff }
.hw-exchk--methodRadio { width: 20px; height: 20px; border-radius: 50%; border: 2px solid #c3ccdb; flex: none; position: relative; }
.hw-exchk--method.is-selected .hw-exchk--methodRadio { border-color: #3264FF; }
.hw-exchk--method.is-selected .hw-exchk--methodRadio::after { content: ""; position: absolute; inset: 3px; border-radius: 50%; background: #3264FF; }
.hw-exchk--methodIco { color: #283D6B; display: inline-flex; }
.hw-exchk--methodBody { display: flex; flex-direction: column; }
.hw-exchk--methodName { font-weight: 700; color: #1b2439; font-size: 15px; }
.hw-exchk--methodDesc { color: #6b7280; font-size: 12.5px; margin-top: 2px; }
.hw-exchk--pay { min-width: 180px; }

.hw-exchk--tourCard { display: flex; gap: 12px; align-items: flex-start; }
.hw-exchk--tourImg { width: 110px; height: 66px; border-radius: 4px; object-fit: cover; flex: none; }
.hw-exchk--tourInfo { min-width: 0; }
.hw-exchk--tourTitle { font-weight: 700; color: #1b2439; font-size: 18px; line-height: 1.3; }
.hw-exchk--edit { background: none; border: none; padding: 0; margin-top: 5px; color: #3264FF; font-weight: 600; font-size: 13px; cursor: pointer; }
.hw-exchk--edit:hover { text-decoration: underline; }
.hw-exchk--ticketLine { margin-top: 14px; font-weight: 700; color: #1b2439; font-size: 16px; }
.hw-exchk--summaryDivider { height: 1px; background: #eef1f7; margin: 14px 0; }
.hw-exchk--cancel { margin-top: 14px; padding-top: 14px; border-top: 1px solid #eef1f7; }
.hw-exchk--cancelHead { display: flex; align-items: center; justify-content: space-between; gap: 10px; width: 100%; background: none; border: none; padding: 0; cursor: pointer; text-align: left; font-weight: 700; color: #1b2439; font-size: 16px; }
.hw-exchk--cancelChevron { display: inline-flex; color: #6b7280; flex: none; transition: transform .2s ease; }
.hw-exchk--cancel.is-open .hw-exchk--cancelChevron { transform: rotate(180deg); }
.hw-exchk--cancelBody { color: #6b7280; font-size: 13px; line-height: 1.5; margin-top: 8px; }
.hw-exchk--cancelBody ul { padding-left: 16px; margin: 6px 0; }
.hw-exchk--terms { margin: 16px 0 0; color: #6b7280; font-size: 12.5px; line-height: 1.5; }
.hw-exchk--terms a { color: #3264FF; text-decoration: underline; }
.hw-exchk--review { border: 1px solid #eceef3; border-radius: 12px; padding: 14px 16px; margin-bottom: 18px; background: #fbfcfe; }
.hw-exchk--reviewHead { display: flex; align-items: center; justify-content: space-between; font-weight: 700; color: #1b2439; font-size: 15px; margin-bottom: 8px; }
.hw-exchk--reviewList { list-style: none; margin: 0; padding: 0; display: grid; gap: 8px; }
.hw-exchk--reviewRow { display: flex; justify-content: space-between; gap: 16px; font-size: 13.5px; }
.hw-exchk--reviewLbl { color: #6b7280; flex: none; }
.hw-exchk--reviewVal { color: #1b2439; font-weight: 600; text-align: right; display: flex; flex-direction: column; align-items: flex-end; }
.hw-exchk--reviewSub { color: #98a2b6; font-weight: 500; font-size: 12px; margin-top: 2px; }
.hw-exchk--payHead { font-weight: 700; color: #1b2439; font-size: 15px; margin-bottom: 10px; }
.hw-exchk--mobileBar { display: none; }

@media (max-width: 991px) {
  .hw-exchk--grid { grid-template-columns: 1fr; }
  .hw-exchk--aside { position: static; }
  .hw-exchk--asideCta { display: none; }
}
@media (max-width: 767px) {
  .hw-exchk--body { padding-bottom: 84px; }
  .hw-exchk--panel { padding: 18px; }
  .hw-exchk--stickyFoot { display: none; }
  .hw-exchk--btnWide, .hw-exchk--panelFoot .hw-btn { min-width: 0; flex: 1; }
  /* .hw-exchk--stepLabel { display: none; } */
  .hw-exchk--step.is-active .hw-exchk--stepLabel { display: inline; }
  .hw-exchk--heroBar { flex-direction: column; align-items: flex-start; gap: 12px; margin-top: 10px; }
  .hw-exchk--steps { gap: 4px; flex-wrap: nowrap; }
  .hw-exchk--step { font-size: 13px; }
  .hw-exchk--step:not(:last-child)::after { width: 20px; margin: 0 4px; }
  .hw-exchk--stepNum { width: 24px; height: 24px; font-size: 12px; flex: none; }
  .hw-exchk--mobileBar { display: flex; position: fixed; left: 0; right: 0; bottom: 0; z-index: 60; background: #fff; border-top: 1px solid #e6e9f0; padding: 10px 16px; align-items: center; justify-content: space-between; gap: 12px; box-shadow: 0 -4px 16px rgba(16,24,40,.08); }
  .hw-exchk--mobileTotal { display: flex; flex-direction: column; }
  .hw-exchk--mobileTotal span { font-size: 16px; color: #000; }
  .hw-exchk--mobileTotal strong { font-size: 17px; color: #1b2439; }
  .hw-exchk--mobileBar .hw-btn { min-width: 150px; }
}
/* end excursion checkout redesign */

.hw-bkovl { position: fixed; inset: 0; z-index: 3000; display: flex; align-items: center; justify-content: center; padding: 20px; background: rgba(20,28,48,.55); -webkit-backdrop-filter: blur(3px); backdrop-filter: blur(3px); }
.hw-bkovl--card { width: 100%; max-width: 380px; background: #fff; border-radius: 18px; padding: 30px 26px 22px; box-shadow: 0 26px 64px -22px rgba(16,24,40,.45); text-align: center; animation: hwBkPop .28s ease; }
@keyframes hwBkPop { from { opacity: 0; transform: translateY(10px) scale(.97); } to { opacity: 1; transform: none; } }
.hw-bkovl--ring { position: relative; width: 74px; height: 74px; margin: 0 auto 16px; }
.hw-bkovl--spinner { width: 74px; height: 74px; animation: hwBkRotate 1.3s linear infinite; }
.hw-bkovl--track { fill: none; stroke: #eaf0ff; stroke-width: 4; }
.hw-bkovl--path { fill: none; stroke: #3264FF; stroke-width: 4; stroke-linecap: round; stroke-dasharray: 85 160; }
.hw-bkovl--lock { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; color: #283D6B; }
@keyframes hwBkRotate { to { transform: rotate(360deg); } }
.hw-bkovl--title { font-size: 18px; font-weight: 800; color: #1b2439; }
.hw-bkovl--sub { margin-top: 4px; color: #6b7280; font-size: 13px; }
.hw-bkovl--steps { list-style: none; margin: 18px 0 0; padding: 0; display: grid; gap: 11px; text-align: left; }
.hw-bkovl--step { display: flex; align-items: center; gap: 11px; color: #98a2b6; font-size: 14px; font-weight: 600; transition: color .3s; }
.hw-bkovl--step.is-active { color: #1b2439; }
.hw-bkovl--step.is-done { color: #137333; }
.hw-bkovl--dot { width: 21px; height: 21px; border-radius: 50%; border: 2px solid #dfe4ee; display: inline-flex; align-items: center; justify-content: center; flex: none; color: #fff; transition: all .3s; }
.hw-bkovl--dot svg { opacity: 0; transition: opacity .2s; }
.hw-bkovl--step.is-active .hw-bkovl--dot { border-color: #3264FF; box-shadow: 0 0 0 4px rgba(50,100,255,.12); animation: hwBkPulse 1.2s ease-in-out infinite; }
.hw-bkovl--step.is-done .hw-bkovl--dot { background: #137333; border-color: #137333; }
.hw-bkovl--step.is-done .hw-bkovl--dot svg { opacity: 1; }
@keyframes hwBkPulse { 0%,100% { box-shadow: 0 0 0 4px rgba(50,100,255,.12); } 50% { box-shadow: 0 0 0 7px rgba(50,100,255,.05); } }
.hw-bkovl--note { margin-top: 18px; padding-top: 14px; border-top: 1px solid #eef1f7; color: #6b7280; font-size: 12.5px; }

.hw-cfhero { width: 100%; color: #fff; padding: 26px 0 125px; }
.hw-cfhero.is-confirm { background: linear-gradient(120deg, #283D6B 0%, #22335e 52%, #3264FF 165%);padding: 26px 0 75px; }
.hw-cfhero.is-cancel-hotel { background: linear-gradient(120deg, #283D6B 0%, #22335e 52%, #3264FF 165%); padding: 26px 0 75px;}
.hw-cfhero.is-confirm-hotel { background: linear-gradient(120deg, #283D6B 0%, #22335e 52%, #3264FF 165%);padding: 26px 0 75px; }
.hw-cfhero--bar { display: flex; align-items: center; justify-content: space-between; gap: 20px; flex-wrap: wrap; }
.hw-cfhero--left { display: flex; align-items: center; gap: 16px; }
.hw-cfhero--badge { width: 40px; height: 40px; border-radius: 50%; background: rgba(255,255,255,.16); display: inline-flex; align-items: center; justify-content: center; flex: none; }
.hw-cfhero--title { margin: 0; color: #fff; font-weight: 700; font-size: clamp(20px, 2.4vw, 27px);  }
.hw-cfhero--sub { margin: 3px 0 0; color: rgba(255,255,255,.85); font-size: 14px; max-width: 640px; line-height: 1.45; }
.hw-cfhero--id { text-align: right; }
.hw-cfhero--idLabel { display: flex; color: rgba(255,255,255,.7); font-size: 11.5px; text-transform: uppercase; letter-spacing: .05em; }
.hw-cfhero--idVal { display: block; color: #fff; font-weight: 800; font-size: 16px; margin-top: 2px; }
@media (max-width: 600px) { .hw-cfhero--id { text-align: left; } .hw-cfhero--sub , .hw-cfhero--idVal { font-size: 12px; } .hw-cfhero.is-confirm , .hw-cfhero.is-confirm-hotel{padding : 26px 0 60px} }

.hw-exchk--confirm {  position: relative; z-index: 1; }
.hw-exchk--panelHead { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 14px; }
.hw-exchk--panelHead .hw-exchk--panelTitle { margin-bottom: 0; }
.hw-exchk--travelerTable table { width: 100%; border-collapse: collapse; }
.hw-exchk--travelerTable th { text-align: left; font-size: 12px; text-transform: uppercase; letter-spacing: .03em; color: #1b2439; font-weight: 700; padding: 0 0 10px; border-bottom: 1px solid #eef1f7; }
.hw-exchk--travelerTable td { padding: 12px 2px; border-bottom: 1px solid #f1f3f8; color: #1b2439; font-weight: 600; font-size: 14px; }
.hw-exchk--travelerTable tr:last-child td { border-bottom: 0; }
.hw-exchk--travelerTable th:nth-child(2), .hw-exchk--travelerTable td:nth-child(2) { text-align: right; }
.hw-exchk--dl { display: inline-flex; align-items: center; justify-content: center; width: 34px; height: 34px; border-radius: 8px; border: 1px solid #e2e6ee; color: #3264FF; transition: background .15s, border-color .15s; }
.hw-exchk--dl:hover { background: #f5f8ff; border-color: #3264FF; }
.hw-hotel--reviewRoomCard { border: 1px solid #eef1f7; border-radius: 6px; overflow: hidden; margin-top: 12px; }
.hw-hotel--reviewRoomCard:first-of-type { margin-top: 10px; }
.hw-hotel--reviewRoomHead { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 12px 16px; background: #F8FAFC; border-bottom: 1px solid #e2e6ee; }
.hw-hotel--reviewRoomBadge { font-size: 14.5px; font-weight: 700; color: #1e293b; letter-spacing: .01em; }
.hw-hotel--reviewRoomCount { font-size: 14.5px; font-weight: 600; color: #1e293b; }
.hw-hotel--reviewList { list-style: none; margin: 0; padding: 0; }
.hw-hotel--reviewGuest { display: flex; align-items: center; gap: 12px; padding: 12px 14px; background: #fff; }
.hw-hotel--reviewGuest + .hw-hotel--reviewGuest { border-top: 1px solid #f0f2f7; }
.hw-hotel--reviewGuestIcon { display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border-radius: 50%; background: #eaf0ff; color: #3264FF; flex: none; }
.hw-hotel--reviewGuestIcon svg { width: 16px; height: 16px; }
.hw-hotel--reviewGuestName { font-size: 14.5px; font-weight: 600; color: #1e293b; flex: 1 1 auto; min-width: 0; }
.hw-hotel--reviewGuestType { font-size: 11.5px; font-weight: 600; color: #1e293b; background: #f7f9fc; border: 1px solid #e2e6ee; border-radius: 999px; padding: 3px 11px; flex: none; }
.hw-exchk--richText { color: #6b7280; font-size: 13.5px; line-height: 1.6; }
.hw-exchk--richText ul { padding-left: 18px; margin: 6px 0; }


.hw-exchk--tourImg { width: 96px; height: 66px; border-radius: 8px; object-fit: cover; flex: none; }
.hw-exchk--tourInfo { min-width: 0; }
.hw-exchk--tourVariation { color: #6b7280; font-size: 13px; margin-top: 3px; }
.hw-exchk--facts { list-style: none; margin: 14px 0 0; padding: 0; display: grid; gap: 10px; }
.hw-exchk--facts li { display: flex; justify-content: space-between; gap: 12px; font-size: 13.5px; }
.hw-exchk--factLbl { color: #6b7280; }
.hw-exchk--factVal { color: #1b2439; font-weight: 600; text-align: right; }

.hw-cfhero--back { color: rgba(255,255,255,.85); margin-bottom: 6px; }
.hw-cfhero--back:hover { color: #fff; }

.hw-exchk--ticketsSection { position: sticky; bottom: 0; background: #fff; padding: 16px 0 6px; border-top: 1px solid #eef1f7; z-index: 2; }
.hw-exchk--panelSubTitle { font-size: 15px; font-weight: 700; color: #1b2439; margin-bottom: 12px; }
.hw-exchk--ticketsSection .hw-after--bookingWidget.tickets > .d-flex.justify-between { display: none !important; }
.hw-exchk--ticketsSection .hw-after--bookingWidget.tickets { display: block; margin: 0; padding: 0; }
.hw-tk--dlRow { display: flex;gap: 10px; margin: 0 0 10px; }
/* .hw-tk--dlRow > div { flex: 1 1 200px; min-width: 0; margin: 0; } */
.hw-tk--dlRow > div > .hw-btn { width: 100%; padding: 11px 14px; font-size: 14px; font-weight: 600; border-radius: 4px; height: auto; line-height: 1.2; }
.hw-exchk--ticketsSection .hw-after--bookingWidget.tickets > span { display: block; margin-top: 6px; }

.hw-exchk--summary .price-backup { padding: 0; }
.hw-exchk--summary .price-backup h4 { font-size: 16px; font-weight: 700; color: #1b2439; margin: 0 0 6px; line-height: 1.3; }
.hw-exchk--summary .price-backup .hw-passenger--fareSummary__thead,
.hw-exchk--summary .price-backup .hw-passenger--fareSummary__tbodyTR { margin-top: 4px; }
.hw-exchk--summary .price-backup .hw-passenger--fareSummary__tfoot { padding-top: 1.4rem; }

.hw-tk--dlRow > div { min-width: 160px; }
.hw-tk--dlRow > div > .hw-btn { min-height: 44px; min-width: 160px; display: inline-flex; align-items: center; justify-content: center; white-space: nowrap; }
.hw-tk--dlRow > div > .hw-btn .hw-main--loaderCommon { min-width: 20px !important; min-height: 20px !important; width: 20px; height: 20px; }

/* confirm: download tickets label + buttons on one line (buttons keep their width) */
.hw-exchk--dlInline { display: flex; align-items: center; flex-wrap: wrap; gap: 12px 16px; }
.hw-exchk--dlInline .hw-exchk--panelSubTitle { margin: 0; white-space: nowrap; flex: none; }
.hw-exchk--ticketsSection.hw-exchk--dlInline .hw-after--bookingWidget.tickets { display: contents; }
.hw-exchk--dlInline .hw-tk--dlRow { margin: 0; }
.hw-exchk--dlInline .hw-after--bookingWidget.tickets > span { flex: 1 1 100%; margin: 0; }
@media (max-width: 575px) {
  .hw-exchk--dlInline { align-items: stretch; }
  .hw-tk--dlRow > div{ min-width: 0;}
  .hw-tk--dlRow > div > .hw-btn {min-width: 0;  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/Excursion.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gDAAgD;EAChD,iCAAiC;EACjC,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd;;sBAEoB;AACtB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,oCAAoC;EACpC,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,+CAA+C;EAC/C,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,cAAc;EACd,iCAAiC;EACjC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iEAAkK;EAClK,iCAAiC;EACjC,oCAAoC;;AAEtC;;;;AAIA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,mFAAmF;AACrF;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,SAAS;EACT,oBAAoB;EACpB,mFAAmF;EACnF,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,kCAAkC;;AAEpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;;;;;GAMG;AACH;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,sCAAsC;EACtC,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,iCAAiC;EACjC,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,yDAA6T;AAC/T;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;EAC5B,qBAAqB;EACrB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;;GAEG;AACH;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,qBAAqB;EACrB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,uCAAuC;EACvC,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;;AAGA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,2BAA2B;EAC3B,UAAU;EACV,gBAAgB;EAChB,8BAA8B;EAC9B,uCAAuC;EACvC,4BAA4B;EAC5B,gBAAgB;EAChB,yDAAi7B;AACn7B;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,WAAW;;;AAGb;;AAEA;;EAEE,iCAAiC;EACjC,uBAAuB;EACvB,6BAA6B;EAC7B,cAAc;EACd,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;;EAEE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;EACvB,iCAAiC;EACjC,UAAU;EACV,6BAA6B;EAC7B,aAAa;EACb,cAAc;EACd,4BAA4B;EAC5B,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yDAAopB;AACtpB;;AAEA;EACE,YAAY;EACZ,yDAAwpB;AAC1pB;;AAEA;;GAEG;AACH;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gDAAgD;EAChD,iCAAiC;EACjC,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kCAAkC;EAClC,UAAU;EACV,OAAO;AACT;;AAEA;EACE,yDAAqiB;AACviB;;AAEA;EACE,yDAAisB;AACnsB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;;AAEnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,+CAA+C;EAC/C,sCAAsC;EACtC,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;AAEA;;EAEE,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,wCAAwC;EACxC,+BAA+B;EAC/B,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,oCAAoC;IACpC,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;AAEF;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;;;EAIA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,aAAa;EACf;;EAEA;;IAEE,aAAa;IACb,qBAAqB;EACvB;;EAEA;;IAEE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;;EAEE;;KAEG;EACH;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;AACF;;AAEA;;EAEE;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;;;;;;;;;GASG;;AAEH;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;;;;EAKE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;EACxB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,qBAAqB;;;AAGrB;EACE,iBAAiB;AACnB;;AAEA;;;GAGG;AACH;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,8CAA8C;EAC9C,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,oCAAoC;AACtC;;;AAGA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,6BAA6B;EAC7B,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;EAEE;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;EAEE;;;IAGE,kBAAkB;EACpB;AACF;;AAEA;;EAEE;;KAEG;EACH;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;EACZ;;;;EAIA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;;EAEE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,OAAO;IACP,WAAW;EACb;;AAEF;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,gBAAgB;;EAElB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,oCAAoC;IACpC,UAAU;IACV,eAAe;;EAEjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA,yBAAyB;;;AAGzB;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;;IAEtB,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;AACF;;;AAGA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE;;;;;;;;;;;;iCAY+B;EAC/B,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;EAC5C,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,mDAAmD;EACnD,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;;AAE7B;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;;AAEpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iDAAiD;EACjD,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,0DAA0D;IAC1D,SAAS;EACX;;EAEA;IACE,wBAAwB;IACxB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,uBAAuB;;;AAGvB;EACE;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;4DAC0D;EAC1D;IACE,SAAS;IACT,gCAAgC;EAClC;;EAEA;;;KAGG;AACL;;AAEA;EACE;IACE,oBAAoB;IACpB,qBAAqB;EACvB;AACF;;AAEA;;EAEE;;;IAGE,kBAAkB;EACpB;;EAEA;;IAEE,6BAA6B;EAC/B;AACF;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,qBAAqB;;AAErB;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;EAChB,uCAAuC;EACvC,yDAAi7B;AACn7B;;AAEA;EACE,8CAA8C;EAC9C,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE;;;IAGE,kBAAkB;EACpB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,iCAAiC;EACjC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,yFAAyF;EACzF,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,qBAAqB;EACrB,sBAAsB;EACtB,8CAA8C;EAC9C,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,OAAO;EACP,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;;EAEE,aAAa;EACb,OAAO;EACP,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sFAAsF;AACtF;EACE,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,WAAW;EACX,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,oCAAoC;EACpC,qBAAqB;EACrB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,yDAAyD;EACzD,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,OAAO;EACT;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB;yBACuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;kDACgD;EAChD,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,sCAAsC;EACtC,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,8CAA8C;EAC9C,6BAA6B;EAC7B,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,wCAAwC;EACxC,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,yBAAyB;EACzB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;;EAEE;;IAEE;EACF;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,8DAA8D;AAC9D;EACE,qEAAqE;AACvE;;AAEA;EACE;IACE,UAAU;IACV,yCAAyC;EAC3C;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qHAAqH;AACvH;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,0FAA0F;EAC1F,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,UAAU;EACV,oCAAoC;EACpC,0BAA0B;EAC1B,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,6BAA6B;EAC7B,6DAA6D;AAC/D;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,0BAA0B;EAC1B,gEAAgE;AAClE;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,yEAAyE;AAC3E;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kFAAkF;EAClF,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;EACrC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,0CAA0C;AAC5C;;AAEA,kDAAkD;;AAElD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;EACvB,iCAAiC;EACjC,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;EACpC,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,+EAA+E;AACjF;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,gFAAgF;AAClF;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;;iEAEiE;AACjE,YAAY,WAAW,EAAE;AACzB,kBAAkB,iBAAiB,EAAE,WAAW,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,sBAAsB,EAAE;AACjH,uBAAuB,iBAAiB,EAAE,WAAW,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AACjH,4BAA4B,wCAAwC,kBAAkB,EAAE,mBAAmB,EAAE,EAAE;AAC/G,6BAA6B,wCAAwC,kBAAkB,EAAE,mBAAmB,EAAE,EAAE;AAChH,6BAA6B,wCAAwC,kBAAkB,EAAE,mBAAmB,EAAE,EAAE;AAChH,6BAA6B,wCAAwC,mBAAmB,EAAE,oBAAoB,EAAE,EAAE;AAClH,kBAAkB,0EAA0E,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,SAAS,EAAE,WAAW,EAAE,gDAAgD,EAAE,iBAAiB,EAAE;AACnO,kCAAkC,4BAA4B,EAAE;AAChE,wCAAwC,WAAW,EAAE;AACrD,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,eAAe,EAAE,eAAe,EAAE;AACtI,uBAAuB,SAAS,EAAE,WAAW,EAAE,gBAAgB,EAAE,mCAAmC,EAAE;AACtG,kCAAkC,2BAA2B,EAAE;AAC/D,0DAA0D,iCAAiC,EAAE;AAC7F,kEAAkE,iCAAiC,EAAE;AACrG,qCAAqC,iCAAiC,EAAE,WAAW,EAAE,wCAAwC,EAAE;AAC/H,4CAA4C,WAAW,EAAE;AACzD,+DAA+D,gBAAgB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACrH,0CAA0C,WAAW,EAAE;AACvD,6DAA6D,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AACzH,kBAAkB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,YAAY,EAAE,WAAW,EAAE,gBAAgB,EAAE,eAAe,EAAE,sBAAsB,EAAE;AAC/K,wBAAwB,cAAc,EAAE;AACxC,mBAAmB,gBAAgB,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,SAAS,EAAE,UAAU,EAAE;AAC1G,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACnH,0CAA0C,WAAW,EAAE,WAAW,EAAE,WAAW,EAAE,mBAAmB,EAAE,aAAa,EAAE,kBAAkB,EAAE;AACzI,kDAAkD,mBAAmB,EAAE;AACvE,qBAAqB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAChN,4BAA4B,cAAc,EAAE;AAC5C,+CAA+C,mBAAmB,EAAE,WAAW,EAAE;AACjF,0BAA0B,cAAc,EAAE,eAAe,EAAE;AAC3D,6CAA6C,mBAAmB,EAAE,WAAW,EAAE;;AAE/E,kBAAkB,aAAa,EAAE,0CAA0C,EAAE,SAAS,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,UAAU,EAAE;AAC/J,kBAAkB,YAAY,EAAE;AAChC,mBAAmB,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,aAAa,EAAE,wCAAwC,EAAE;AAC7I,wBAAwB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAChG,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,gCAAgC,EAAE;AACrJ,yBAAyB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAClM,6BAA6B,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;AACxE,0BAA0B,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,uBAAuB,EAAE;AACtG,iCAAiC,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,mCAAmC,EAAE;AAC5H,yCAAyC,mBAAmB,EAAE;AAC9D,2BAA2B,oBAAoB,EAAE,mBAAmB,EAAE,SAAS,EAAE,iBAAiB,EAAE;AACpG,yBAAyB,eAAe,EAAE,gBAAgB,EAAE,YAAY,EAAE,iBAAiB,EAAE;AAC7F,kDAAkD,cAAc,EAAE;AAClE,4BAA4B,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,YAAY,EAAE,+BAA+B,EAAE;AAC/I,gCAAgC,WAAW,EAAE,YAAY,EAAE;AAC3D,mEAAmE,yBAAyB,EAAE;;AAE9F,6BAA6B,aAAa,EAAE,uBAAuB,EAAE,+DAA+D,EAAE,gBAAgB,EAAE;AACxJ,qCAAqC,uBAAuB,EAAE;AAC9D,2BAA2B,aAAa,EAAE,gBAAgB,EAAE;AAC5D,wBAAwB,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE,aAAa,EAAE,yBAAyB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,kBAAkB,EAAE,6BAA6B,EAAE,0BAA0B,EAAE;AACtO,mBAAmB,gBAAgB,EAAE;AACrC,wBAAwB,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE,iBAAiB,EAAE,cAAc,EAAE,iBAAiB,EAAE,eAAe,EAAE;AAClJ,8BAA8B,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE,cAAc,EAAE,qBAAqB,EAAE,eAAe,EAAE;AAClI,0BAA0B,cAAc,EAAE,0BAA0B,EAAE;AACtE,mCAAmC,gBAAgB,EAAE;AACrD,uBAAuB,iBAAiB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC/E,mBAAmB,gBAAgB,EAAE;AACrC,mBAAmB,cAAc,EAAE,gBAAgB,EAAE,cAAc,EAAE,kBAAkB,EAAE,eAAe,EAAE;AAC1G,sBAAsB,cAAc,EAAE,gBAAgB,EAAE;AACxD,uBAAuB,gBAAgB,EAAE,aAAa,EAAE;AACxD,8BAA8B,8BAA8B,EAAE,SAAS,EAAE;AACzE,qBAAqB,gBAAgB,EAAE;AACvC,+BAA+B,gBAAgB,CAAC,gBAAgB,EAAE;;AAElE,mBAAmB,gBAAgB,EAAE,UAAU,EAAE,iBAAiB,EAAE;AACpE,qBAAqB,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,aAAa,EAAE,wCAAwC,EAAE;AAC/I,yBAAyB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACjG,sBAAsB,aAAa,EAAE,SAAS,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,gCAAgC,EAAE;AAC7H,0BAA0B,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,UAAU,EAAE;AACzG,sBAAsB,YAAY,EAAE;AACpC,uBAAuB,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC5F,sBAAsB,cAAc,EAAE,iBAAiB,EAAE,eAAe,EAAE;AAC1E,mBAAmB,gBAAgB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,6BAA6B,EAAE,aAAa,EAAE,SAAS,EAAE;AACnI,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACvH,uBAAuB,cAAc,EAAE,UAAU,EAAE;AACnD,sBAAsB,gBAAgB,EAAE,iBAAiB,EAAE,6BAA6B,EAAE,aAAa,EAAE,QAAQ,EAAE;AACnH,8BAA8B,WAAW,EAAE;AAC3C,uBAAuB,gBAAgB,EAAE,YAAY,EAAE,WAAW,EAAE,gBAAgB,EAAE,eAAe,EAAE,eAAe,EAAE,YAAY,EAAE;AACtI,6BAA6B,cAAc,EAAE;AAC7C,wBAAwB,gBAAgB,EAAE,iBAAiB,EAAE,6BAA6B,EAAE;;AAE5F,qBAAqB,aAAa,EAAE,eAAe,EAAE,SAAS,EAAE;AAChE,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE,YAAY,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,2BAA2B,EAAE,mBAAmB,EAAE,aAAa,EAAE,eAAe,EAAE,+DAA+D,EAAE;AACzR,0BAA0B,qBAAqB,EAAE;AACjD,gCAAgC,qBAAqB,EAAE,oBAAoB;AAC3E,yBAAyB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,UAAU,EAAE,kBAAkB,EAAE;AACnI,uDAAuD,qBAAqB,EAAE;AAC9E,8DAA8D,WAAW,EAAE,kBAAkB,EAAE,UAAU,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AACpJ,uBAAuB,cAAc,EAAE,oBAAoB,EAAE;AAC7D,wBAAwB,aAAa,EAAE,sBAAsB,EAAE;AAC/D,wBAAwB,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE;AAC3E,wBAAwB,cAAc,EAAE,iBAAiB,EAAE,eAAe,EAAE;AAC5E,iBAAiB,gBAAgB,EAAE;;AAEnC,sBAAsB,aAAa,EAAE,SAAS,EAAE,uBAAuB,EAAE;AACzE,qBAAqB,YAAY,EAAE,YAAY,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,UAAU,EAAE;AACpG,sBAAsB,YAAY,EAAE;AACpC,uBAAuB,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC5F,kBAAkB,gBAAgB,EAAE,YAAY,EAAE,UAAU,EAAE,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE,eAAe,EAAE;AACnJ,wBAAwB,0BAA0B,EAAE;AACpD,wBAAwB,gBAAgB,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE;AAC7F,4BAA4B,WAAW,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC9E,oBAAoB,gBAAgB,EAAE,iBAAiB,EAAE,6BAA6B,EAAE;AACxF,wBAAwB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,WAAW,EAAE,gBAAgB,EAAE,YAAY,EAAE,UAAU,EAAE,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE;AACtP,2BAA2B,oBAAoB,EAAE,cAAc,EAAE,UAAU,EAAE,8BAA8B,EAAE;AAC7G,qDAAqD,yBAAyB,EAAE;AAChF,wBAAwB,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC5F,2BAA2B,kBAAkB,EAAE,aAAa,EAAE;AAC9D,mBAAmB,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC1F,qBAAqB,cAAc,EAAE,0BAA0B,EAAE;AACjE,oBAAoB,yBAAyB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AAClI,wBAAwB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE,kBAAkB,EAAE;AACnK,wBAAwB,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE,aAAa,EAAE,QAAQ,EAAE;AAC1F,uBAAuB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE,iBAAiB,EAAE;AACpG,uBAAuB,cAAc,EAAE,UAAU,EAAE;AACnD,uBAAuB,cAAc,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,aAAa,EAAE,sBAAsB,EAAE,qBAAqB,EAAE;AAC1I,uBAAuB,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE,eAAe,EAAE;AAC3F,qBAAqB,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE,mBAAmB,EAAE;AAC7F,uBAAuB,aAAa,EAAE;;AAEtC;EACE,kBAAkB,0BAA0B,EAAE;EAC9C,mBAAmB,gBAAgB,EAAE;EACrC,sBAAsB,aAAa,EAAE;AACvC;AACA;EACE,kBAAkB,oBAAoB,EAAE;EACxC,mBAAmB,aAAa,EAAE;EAClC,wBAAwB,aAAa,EAAE;EACvC,mDAAmD,YAAY,EAAE,OAAO,EAAE;EAC1E,4CAA4C;EAC5C,iDAAiD,eAAe,EAAE;EAClE,qBAAqB,sBAAsB,EAAE,uBAAuB,EAAE,SAAS,EAAE,gBAAgB,EAAE;EACnG,mBAAmB,QAAQ,EAAE,iBAAiB,EAAE;EAChD,kBAAkB,eAAe,EAAE;EACnC,0CAA0C,WAAW,EAAE,aAAa,EAAE;EACtE,qBAAqB,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE,UAAU,EAAE;EAC7E,uBAAuB,aAAa,EAAE,eAAe,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS,EAAE,WAAW,EAAE,gBAAgB,EAAE,6BAA6B,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,0CAA0C,EAAE;EACnR,yBAAyB,aAAa,EAAE,sBAAsB,EAAE;EAChE,8BAA8B,eAAe,EAAE,WAAW,EAAE;EAC5D,gCAAgC,eAAe,EAAE,cAAc,EAAE;EACjE,+BAA+B,gBAAgB,EAAE;AACnD;AACA,oCAAoC;;AAEpC,YAAY,eAAe,EAAE,QAAQ,EAAE,aAAa,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,aAAa,EAAE,8BAA8B,EAAE,kCAAkC,EAAE,0BAA0B,EAAE;AAClO,kBAAkB,WAAW,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,gDAAgD,EAAE,kBAAkB,EAAE,4BAA4B,EAAE;AACrN,qBAAqB,OAAO,UAAU,EAAE,sCAAsC,EAAE,EAAE,KAAK,UAAU,EAAE,eAAe,EAAE,EAAE;AACtH,kBAAkB,kBAAkB,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACtF,qBAAqB,WAAW,EAAE,YAAY,EAAE,0CAA0C,EAAE;AAC5F,mBAAmB,UAAU,EAAE,eAAe,EAAE,eAAe,EAAE;AACjE,kBAAkB,UAAU,EAAE,eAAe,EAAE,eAAe,EAAE,qBAAqB,EAAE,wBAAwB,EAAE;AACjH,kBAAkB,kBAAkB,EAAE,QAAQ,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,cAAc,EAAE;AAC7H,wBAAwB,KAAK,yBAAyB,EAAE,EAAE;AAC1D,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACtE,iBAAiB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AACnE,mBAAmB,gBAAgB,EAAE,gBAAgB,EAAE,UAAU,EAAE,aAAa,EAAE,SAAS,EAAE,gBAAgB,EAAE;AAC/G,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AAC3I,4BAA4B,cAAc,EAAE;AAC5C,0BAA0B,cAAc,EAAE;AAC1C,iBAAiB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,UAAU,EAAE,WAAW,EAAE,mBAAmB,EAAE;AAC7M,qBAAqB,UAAU,EAAE,uBAAuB,EAAE;AAC1D,2CAA2C,qBAAqB,EAAE,0CAA0C,EAAE,8CAA8C,EAAE;AAC9J,yCAAyC,mBAAmB,EAAE,qBAAqB,EAAE;AACrF,6CAA6C,UAAU,EAAE;AACzD,uBAAuB,UAAU,0CAA0C,EAAE,EAAE,MAAM,0CAA0C,EAAE,EAAE;AACnI,kBAAkB,gBAAgB,EAAE,iBAAiB,EAAE,6BAA6B,EAAE,cAAc,EAAE,iBAAiB,EAAE;;AAEzH,aAAa,WAAW,EAAE,WAAW,EAAE,qBAAqB,EAAE;AAC9D,wBAAwB,0EAA0E,CAAC,oBAAoB,EAAE;AACzH,6BAA6B,0EAA0E,EAAE,oBAAoB,CAAC;AAC9H,8BAA8B,0EAA0E,CAAC,oBAAoB,EAAE;AAC/H,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,eAAe,EAAE;AAClH,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAClE,oBAAoB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,iCAAiC,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,UAAU,EAAE;AACtL,oBAAoB,SAAS,EAAE,WAAW,EAAE,gBAAgB,EAAE,mCAAmC,GAAG;AACpG,kBAAkB,eAAe,EAAE,4BAA4B,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AACvH,iBAAiB,iBAAiB,EAAE;AACpC,sBAAsB,aAAa,EAAE,2BAA2B,EAAE,iBAAiB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE;AACvI,oBAAoB,cAAc,EAAE,WAAW,EAAE,gBAAgB,EAAE,eAAe,EAAE,eAAe,EAAE;AACrG,4BAA4B,iBAAiB,gBAAgB,EAAE,EAAE,sCAAsC,eAAe,EAAE,EAAE,oDAAoD,qBAAqB,EAAE;;AAErM,sBAAsB,kBAAkB,EAAE,UAAU,EAAE;AACtD,uBAAuB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,mBAAmB,EAAE;AAC3H,6CAA6C,gBAAgB,EAAE;AAC/D,iCAAiC,WAAW,EAAE,yBAAyB,EAAE;AACzE,8BAA8B,gBAAgB,EAAE,eAAe,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,cAAc,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,gCAAgC,EAAE;AAC1M,8BAA8B,iBAAiB,EAAE,gCAAgC,EAAE,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACtI,4CAA4C,gBAAgB,EAAE;AAC9D,qFAAqF,iBAAiB,EAAE;AACxG,gBAAgB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,cAAc,EAAE,8CAA8C,EAAE;AAC9N,sBAAsB,mBAAmB,EAAE,qBAAqB,EAAE;AAClE,4BAA4B,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAC/G,0CAA0C,gBAAgB,EAAE;AAC5D,4BAA4B,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,gCAAgC,EAAE;AACtL,6BAA6B,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AACzG,6BAA6B,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAClF,wBAAwB,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE;AACjE,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC9G,kDAAkD,6BAA6B,EAAE;AACjF,6BAA6B,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,cAAc,EAAE,UAAU,EAAE;AACjM,iCAAiC,WAAW,EAAE,YAAY,EAAE;AAC5D,6BAA6B,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE,cAAc,EAAE,YAAY,EAAE;AAChH,6BAA6B,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,oBAAoB,EAAE,iBAAiB,EAAE,UAAU,EAAE;AACvL,sBAAsB,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC3E,yBAAyB,kBAAkB,EAAE,aAAa,EAAE;;;AAG5D,qBAAqB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,UAAU,EAAE;AACnG,sBAAsB,YAAY,EAAE;AACpC,2BAA2B,cAAc,EAAE,eAAe,EAAE,eAAe,EAAE;AAC7E,mBAAmB,gBAAgB,EAAE,gBAAgB,EAAE,UAAU,EAAE,aAAa,EAAE,SAAS,EAAE;AAC7F,sBAAsB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE,iBAAiB,EAAE;AACnG,qBAAqB,cAAc,EAAE;AACrC,qBAAqB,cAAc,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AAE1E,mBAAmB,4BAA4B,EAAE,kBAAkB,EAAE;AACrE,yBAAyB,WAAW,EAAE;;AAEtC,4BAA4B,gBAAgB,EAAE,SAAS,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,6BAA6B,EAAE,UAAU,EAAE;AAC3I,2BAA2B,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACnG,uFAAuF,wBAAwB,EAAE;AACjH,6DAA6D,cAAc,EAAE,SAAS,EAAE,UAAU,EAAE;AACpG,gBAAgB,aAAa,CAAC,SAAS,EAAE,gBAAgB,EAAE;AAC3D,sEAAsE;AACtE,gCAAgC,WAAW,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,YAAY,EAAE,gBAAgB,EAAE;AACxJ,oEAAoE,cAAc,EAAE,eAAe,EAAE;;AAErG,mCAAmC,UAAU,EAAE;AAC/C,sCAAsC,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC5H;uEACuE,eAAe,EAAE;AACxF,qEAAqE,mBAAmB,EAAE;;AAE1F,sBAAsB,gBAAgB,EAAE;AACxC,gCAAgC,gBAAgB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC7J,uDAAuD,0BAA0B,EAAE,2BAA2B,EAAE,WAAW,EAAE,YAAY,EAAE;;AAE3I,qFAAqF;AACrF,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,cAAc,EAAE;AAC3F,+CAA+C,SAAS,EAAE,mBAAmB,EAAE,UAAU,EAAE;AAC3F,gFAAgF,iBAAiB,EAAE;AACnG,oCAAoC,SAAS,EAAE;AAC/C,8DAA8D,cAAc,EAAE,SAAS,EAAE;AACzF;EACE,sBAAsB,oBAAoB,EAAE;EAC5C,qBAAqB,YAAY,CAAC;EAClC,+BAA+B,YAAY,GAAG;AAChD","sourcesContent":[".hw-widget--ticketCheckout {\n  --hw-heading-color: #121826;\n}\n\n.hw-book--filterResult .row {\n  row-gap: 2rem;\n}\n\n.hw-price--dropdown {\n  position: relative;\n  cursor: pointer;\n  min-width: 180px;\n}\n\n.hw-excursion--dropdown {\n  border: .1rem solid var(--hw-gray-400);\n  background-color: var(--hw-white);\n  border-radius: 1rem;\n  padding: .8rem 2rem;\n  display: flex;\n  align-items: center;\n  column-gap: 1rem;\n}\n\n.hw-excursion--dropdown svg:first-child {\n  color: var(--hw-black);\n}\n\n.hw-excursion--dropdown span {\n  flex: 1 0 0;\n}\n\n.hw-excursion--dropdown+.hw-price--dropdownContent {\n  margin-top: 1rem;\n}\n\n.hw-datepicker--input .react-datepicker-wrapper {\n  display: block;\n}\n\n.hw-datepicker--input .react-datepicker-wrapper .hw-input--input {\n  min-height: 4.6rem;\n  border-radius: 0.5rem;\n}\n\n.hw-person--roomInput {\n  position: relative;\n}\n\n.hw-person--roomInput .hw-input--input {\n  min-height: 4.6rem;\n  border-radius: 0.5rem;\n}\n\n.hw-person--roomInput .paasenger-modal {\n  top: 5.6rem;\n  right: calc(var(--bs-gutter-x) * 0.5);\n}\n\n.hw-person--roomInput .DT--passenger-item .DT--divider {\n  display: none;\n}\n\n.hw-gp--btn {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  column-gap: 2rem;\n}\n\n.hw-gp--btn:has(> :only-child) {\n  grid-template-columns: 1fr;\n}\n\n.hw-gp--btn .hw-btn {\n  padding-top: 1.2rem;\n  padding-bottom: 1.2rem;\n}\n\n.hw-price--dropdownContent {\n  position: absolute;\n  z-index: 2;\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);\n  background-color: var(--hw-white);\n  padding: 1rem 1rem;\n  width: 100%;\n  top: 100%;\n  margin-top: 2rem;\n  border-radius: 0.5rem;\n}\n\n.hw-price--dropdownContent>div {\n  padding: .5rem 1rem;\n  cursor: pointer;\n  color: var(--hw-black);\n}\n\n.hw-price--dropdownContent>div:hover {\n  color: var(--hw-brand-orange);\n}\n\n.hw-excursion--topSearch {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  column-gap: 1rem;\n}\n\n.hw-excursion--topSearch .hw-price--dropdown {\n  flex-shrink: 0;\n  /* display: flex;\n  align-items: center;\n  column-gap: .4rem; */\n}\n\n.hw-book--filterSlideItem {\n  padding: 0.4rem;\n  display: flex;\n  align-items: center;\n  column-gap: 1.2rem;\n  cursor: pointer;\n  transition: .2s;\n  position: relative;\n  color: var(--hw-black-900);\n  font-size: 1.4rem;\n  line-height: 1.71429;\n}\n\n.hw-book--filterSlideItem+.hw-book--filterSlideItem {\n  margin-top: 0.8rem;\n}\n\n.hw-book--filterSlideItem::before {\n\n  content: '';\n  border: 1px solid var(--hw-gray-700);\n  width: 1.8rem;\n  height: 1.8rem;\n  border-radius: 99.9rem;\n  margin: 2px;\n  background-image: var(--bs-form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  flex-shrink: 0;\n  -webkit-print-color-adjust: exact;\n  color-adjust: exact;\n  print-color-adjust: exact;\n}\n\n.hw-book--filterSlideItem.active::before {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%233264FF'/%3e%3c/svg%3e\");\n  background-color: var(--hw-white);\n  border-color: var(--hw-brand-orange);\n\n}\n\n\n\n.hw-book--filterResultGrid .image-box {\n  position: relative;\n  border-radius: 0.5rem;\n  overflow: hidden;\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.00) 100%);\n}\n\n.hw-book--filterResultGrid .image-box::after {\n  content: '';\n  padding-top: 63.484%;\n  display: block;\n}\n\n.hw-book--filterResultGrid .image-box::before {\n  content: '';\n  position: absolute;\n  width: 100%;\n  height: 4.4rem;\n  bottom: 0;\n  pointer-events: none;\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.00) 100%);\n  z-index: 1;\n  height: clamp(4.4rem, 3vw, 10rem);\n}\n\n.hw-book--filterResultGrid .image-box img {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  inset: 0;\n  display: block;\n  object-fit: cover;\n  transition: transform .2s ease-out;\n\n}\n\n.hw-book--filterResultGrid .whole-link:hover~.image-box img {\n  transform: scale(1.12);\n}\n\n.content-box {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  row-gap: .4rem;\n  padding-top: 1rem;\n}\n\n.content-box--inner {\n  display: flex;\n  justify-content: space-between;\n  column-gap: .4rem;\n  flex-flow: nowrap;\n  align-items: center;\n}\n\n@media (min-width : 480px) {\n  .hw-excursion-search-btn {\n    min-width: 15rem;\n  }\n}\n\n/* .tick-list {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'%3E%3Cpath d='M15.4983 3.93945C15.8079 4.21464 15.8358 4.68869 15.5606 4.99828L7.56056 13.9983C7.41824 14.1584 7.21424 14.25 7.00001 14.25C6.78578 14.25 6.58178 14.1584 6.43945 13.9983L2.43945 9.49828C2.16426 9.18869 2.19215 8.71464 2.50174 8.43945C2.81132 8.16426 3.28538 8.19215 3.56056 8.50173L7.00001 12.3711L14.4395 4.00174C14.7146 3.69215 15.1887 3.66426 15.4983 3.93945Z' fill='%23555555'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-size: 1.8rem 1.8rem;\n  background-position: top 0.4em left;\n  padding-left: 2.2rem;\n} */\n.tick-list {\n  background-repeat: no-repeat;\n  background-size: 1.8rem 1.8rem;\n  background-position: left .6rem center;\n  background-color: #E7F5E9;\n  color: var(--hw-green);\n  font-size: 1.2rem;\n  padding: .4rem .6rem .4rem 2.8rem;\n  border-radius: .4rem;\n  line-height: 1.33333;\n  font-weight: 500;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='19' height='18' viewBox='0 0 19 18' fill='none'%3E%3Cpath d='M10.417 2.25V7.5H14.917L8.91699 15.75V10.5H4.41699L10.417 2.25Z' stroke='%230A7519' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n}\n\n.content-box--inner .price {\n  display: flex;\n  align-items: center;\n  column-gap: 1rem;\n  font-size: 1.6rem;\n  line-height: 1.5;\n  flex-shrink: 0;\n  font-weight: bold;\n  color: var(--hw-black-900);\n}\n\n.content-box--inner .price small {\n  font-size: 1.2rem;\n  line-height: 1.33333;\n  color: var(--hw-black-900);\n  font-weight: 500;\n}\n\n.hw-ticket--title {\n  font-size: 1.6rem;\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  display: -webkit-box;\n  color: var(--hw-black-900);\n}\n\n.whole-link:hover~.content-box .hw-ticket--title {\n  color: var(--hw-brand-orange);\n}\n\n.whole-link:hover~.content-box .price {\n  color: var(--hw-black);\n}\n\n.hw-book--filterResultGrid {\n  position: relative;\n}\n\n.whole-link {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: block !important;\n  inset: 0;\n  z-index: 1;\n}\n\n.hw-excursion--toggleTitle {\n  font-size: 1.8rem;\n  line-height: 1.5;\n  font-weight: bold;\n  color: var(--hw-black);\n}\n\n.hw-excursion--listInfo {\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n\n.hw-excursion--listInfoList {\n  display: grid;\n  grid-template-columns: 2.4rem 1fr;\n  column-gap: 0.4rem;\n}\n\n.hw-excursion--listInfoList .icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--hw-brand-orange);\n}\n\n.hw-excursion--listInfoList .icon svg {\n  width: 2.3rem;\n  height: 2.3rem;\n  display: block;\n}\n\n.hw-excursion--listInfoList .icon-text {\n  color: var(--hw-brand-blue);\n  font-weight: 500;\n}\n\n.hw-excursion--listInfoList .icon-text b {\n  margin-right: .4rem;\n  font-weight: inherit;\n}\n\n.hw-excursion--toggleItem {\n  padding-bottom: 2rem;\n  border-bottom: 1px solid var(--hw-gray-400);\n}\n\n/* .hw-scroll--contentList > .hw-excursion--toggleItem:not(:first-child) {\n  padding-top: 2rem;\n} */\n.hw-excursion--toggleContent {\n  padding: 2rem 0 0 0;\n}\n\n.hw-excursion--toggleContent ul {\n  margin-top: 0;\n  padding-left: 2rem;\n}\n\n.hw-excursion--toggleContent> :last-child {\n  margin-bottom: 0;\n}\n\n.hw-widget--ticketCheckout .hw-passenger--head {\n  border-bottom-width: 0;\n}\n\n.hw-car--listShow__passangerCol {\n  display: flex;\n  flex-direction: column;\n  row-gap: 0.8rem;\n}\n\n.hw-img--holder.hw-img--holder105 {\n  width: 10.5rem;\n  height: 9rem;\n}\n\n.hw-img--holder {\n  position: relative;\n  border-radius: 1rem;\n}\n\n.hw-img--holder img {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  inset: 0;\n  object-fit: cover;\n  border-radius: 0.5rem;\n}\n\n.hw-car--listShow__passangerColInner {\n  display: flex;\n  align-items: center;\n  align-content: center;\n  gap: 1rem .2rem;\n  align-self: stretch;\n  flex-wrap: wrap;\n  margin-top: 0.4rem;\n}\n\n.middle-content--rowItem {\n  display: flex;\n  gap: .8rem;\n  align-items: center;\n  font-size: 1.4rem;\n  line-height: 1.71429;\n}\n\n.middle-content--rowItem svg {\n  color: var(--hw-brand-blue);\n}\n\n.middle-content--rowItem {\n  /* flex-basis: 17.4rem; */\n  min-width: 17.4rem;\n}\n\n.hw-img--holder.hw-img--holder105 {\n  width: 10.5rem;\n  height: 9rem;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.hw-passenger--iconList {\n  column-gap: 1rem;\n}\n\n.hw-passenger--iconList .d-flex {\n  column-gap: 1rem;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.hw-passenger--iconList .d-flex span {\n  font-weight: 500;\n}\n\n.hw-passenger--iconList>.d-flex>.d-flex>span:not(:last-child)::after {\n  content: '|';\n  display: inline-flex;\n  color: var(--hw-gray-400);\n  margin-left: 1rem;\n}\n\n.hw-car--listShow__passangerCol hr {\n  margin: .6rem 0;\n  color: inherit;\n  border: none;\n  border-top: 1px solid var(--hw-gray-600);\n}\n\n.hw-passenger--fareShowToggleContent>.row {\n  row-gap: 1.5rem;\n}\n\n.hw-passenger--iconList svg {\n  color: var(--hw-brand-blue);\n}\n\n.hw-passenger--fareSummary__tfoot {\n  font-size: 1.8rem;\n  line-height: 1.5;\n}\n\n.hw-excursion--listProductData {\n  background-color: var(--hw-white);\n  padding: 1.5rem;\n  border-radius: 0.5rem;\n  border: .1rem solid var(--hw-gray-400);\n  margin-top: 2rem;\n}\n\n.hw-excursion--listProductData>.row {\n  row-gap: 1rem;\n}\n\n.hw-excursion--selectSliderItem {\n  border: .1rem solid var(--hw-gray-600);\n  background-color: var(--hw-white);\n  padding: 1.5rem;\n  border-radius: 1rem;\n  row-gap: 1rem;\n  margin: 2rem 0 0 0 !important;\n  cursor: pointer;\n  /* min-height: 350px; */\n}\n\n.hw-excursion--selectSliderItem .hw-excursion--title {\n  position: relative;\n  padding-left: 3.8rem;\n}\n\n.hw-excursion--selectSliderItem .hw-excursion--title::before {\n  content: '';\n  width: 1.8rem;\n  height: 1.8rem;\n  border: .1rem solid var(--hw-black-900);\n  position: absolute;\n  left: 0;\n  top: .6rem;\n  border-radius: 50%;\n}\n\n.hw-excursion--selectSliderItem.active .hw-excursion--title::after {\n  content: '';\n  width: 1.2rem;\n  height: 1.2rem;\n  position: absolute;\n  top: 9px;\n  left: 3px;\n  background-color: var(--hw-brand-orange);\n  border-radius: 50%;\n}\n\n.hw-excursion--selectSliderItem.active .hw-excursion--title::before {\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-excursion--selectSliderItem.active {\n  border-color: var(--hw-brand-orange);\n}\n\n\n.hw-excursion--selectSliderItem ul {\n  margin: 0;\n  padding-left: 2rem;\n}\n\n.hw-excursion--selectSliderItem ul li {\n  font-size: 1.4rem;\n  line-height: 1.71429;\n}\n\n.hw-excursion--selectSliderItem ul>li+li {\n  margin-top: .5rem;\n}\n\n.hw-price--dropdownBorder .hw-price--dropdownContent {\n  display: none;\n}\n\n.hw-excursion--Searchbox {\n  flex: 1 0 0;\n  max-width: 65rem;\n  border: .1rem solid var(--hw-gray-600);\n  border-radius: 0.5rem;\n  overflow: hidden;\n}\n\n.hw-excursion--Searchbox>.css-b62m3t-container>div {\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  padding: 0;\n  min-height: 5rem;\n  background-size: 1.8rem 1.8rem;\n  background-position: left 1.2rem center;\n  background-repeat: no-repeat;\n  font-weight: 500;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3E%3Cpath d='M19 19L13 13M1 8C1 8.91925 1.18106 9.82951 1.53284 10.6788C1.88463 11.5281 2.40024 12.2997 3.05025 12.9497C3.70026 13.5998 4.47194 14.1154 5.32122 14.4672C6.1705 14.8189 7.08075 15 8 15C8.91925 15 9.82951 14.8189 10.6788 14.4672C11.5281 14.1154 12.2997 13.5998 12.9497 12.9497C13.5998 12.2997 14.1154 11.5281 14.4672 10.6788C14.8189 9.82951 15 8.91925 15 8C15 7.08075 14.8189 6.1705 14.4672 5.32122C14.1154 4.47194 13.5998 3.70026 12.9497 3.05025C12.2997 2.40024 11.5281 1.88463 10.6788 1.53284C9.82951 1.18106 8.91925 1 8 1C7.08075 1 6.1705 1.18106 5.32122 1.53284C4.47194 1.88463 3.70026 2.40024 3.05025 3.05025C2.40024 3.70026 1.88463 4.47194 1.53284 5.32122C1.18106 6.1705 1 7.08075 1 8Z' stroke='%230F294D' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n}\n\n.hw-excursion--Searchbox>.css-b62m3t-container>div div {\n  color: var(--hw-brand-blue) !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-right: 0;\n  white-space: nowrap;\n  padding-left: 2rem;\n  width: calc(100% - 2rem);\n  font-weight: 500;\n}\n\n.hw-excursion--Searchbox>.css-b62m3t-container>div .css-1wy0on6 {\n  display: none;\n}\n\n.hw-excursion--Searchbox:hover {\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-br--5 {\n  border-radius: 0.5rem !important;\n}\n\n.hw-br--10 {\n  border-radius: 1rem !important;\n}\n\n.hw-excursion--listProduct .image-gallery-slide .image-gallery-image {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  inset: 0;\n  max-height: 100% !important;\n  object-fit: cover !important;\n  border-radius: 0.5rem;\n  object-position: top center;\n}\n\n.hw-excursion--listProduct .image-gallery-slide.image-gallery-center::after {\n  content: '';\n  padding-top: 75%;\n  display: block;\n}\n\n.hw-excursion--listProduct .image-gallery-icon.image-gallery-fullscreen-button {\n\n  left: 1.5rem;\n  right: auto;\n\n\n}\n\n.hw-excursion--listProduct .image-gallery-icon.image-gallery-play-button,\n.hw-excursion--listProduct .image-gallery-icon.image-gallery-fullscreen-button {\n  background-color: var(--hw-white);\n  filter: none !important;\n  color: var(--hw-brand-orange);\n  padding: .6rem;\n  border-radius: .4rem;\n  top: 1.5rem;\n  bottom: auto;\n}\n\n.hw-excursion--listProduct .image-gallery-icon.image-gallery-play-button {\n  right: 1.5rem;\n  left: auto;\n}\n\n.hw-excursion--listProduct .image-gallery-fullscreen-button .image-gallery-svg,\n.hw-excursion--listProduct .image-gallery-play-button .image-gallery-svg {\n  height: 18px;\n  width: 18px;\n}\n\n.hw-excursion--listProduct .image-gallery-thumbnail {\n  width: 6.4rem;\n  border-width: .2rem;\n  border-radius: .4rem !important;\n  overflow: hidden;\n}\n\n.hw-excursion--listProduct .image-gallery-thumbnail+.image-gallery-thumbnail {\n  margin-left: .6rem;\n}\n\n.hw-excursion--listProduct .image-gallery-thumbnail.active,\n.image-gallery-thumbnail:focus {\n  border: 2px solid var(--hw-black);\n}\n\n.hw-excursion--listProduct .image-gallery-play-button .image-gallery-svg {\n  position: relative;\n  left: 2px;\n}\n\n.hw-excursion--listProduct .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-bottom {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: .5rem 1rem;\n  display: none;\n}\n\n.hw-excursion--listProduct .image-gallery {\n  background-color: var(--hw-brand-orange-light);\n  border-radius: 1rem;\n}\n\n.hw-excursion--listProduct .image-gallery-icon.image-gallery-left-nav,\n.hw-excursion--listProduct .image-gallery-icon.image-gallery-right-nav {\n  filter: none !important;\n  background-color: var(--hw-white);\n  padding: 0;\n  background-size: 1.1rem .9rem;\n  width: 2.4rem;\n  height: 2.4rem;\n  background-repeat: no-repeat;\n  background-position: center center;\n  border-radius: .5rem;\n}\n\n.hw-excursion--listProduct .image-gallery-icon.image-gallery-left-nav svg,\n.hw-excursion--listProduct .image-gallery-icon.image-gallery-right-nav svg {\n  display: none;\n}\n\n.hw-excursion--listProduct .image-gallery-icon.image-gallery-right-nav {\n  right: 1.5rem;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11' height='9' viewBox='0 0 11 9' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M7.48477 1.02765L10.7591 4.30202C10.9601 4.50295 10.9601 4.82872 10.7591 5.02965L7.48477 8.30402C7.28384 8.50495 6.95806 8.50495 6.75713 8.30402C6.5562 8.10308 6.5562 7.77731 6.75713 7.57638L9.15316 5.18035H0.789907C0.505748 5.18035 0.275391 4.94999 0.275391 4.66583C0.275391 4.38167 0.505748 4.15132 0.789907 4.15132H9.15316L6.75713 1.75529C6.5562 1.55436 6.5562 1.22858 6.75713 1.02765C6.95806 0.82672 7.28384 0.82672 7.48477 1.02765Z' fill='%233264FF'/%3E%3C/svg%3E\");\n}\n\n.hw-excursion--listProduct .image-gallery-icon.image-gallery-left-nav {\n  left: 1.5rem;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='27' height='20' viewBox='0 0 27 20' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8.67002 1.20047L0.749396 9.1211C0.263348 9.60715 0.263348 10.3952 0.749396 10.8812L8.67002 18.8019C9.15607 19.2879 9.94411 19.2879 10.4302 18.8019C10.9162 18.3158 10.9162 17.5278 10.4302 17.0417L4.63421 11.2458H24.8648C25.5521 11.2458 26.1094 10.6885 26.1094 10.0012C26.1094 9.31379 25.5521 8.75656 24.8648 8.75656H4.63421L10.4302 2.96061C10.9162 2.47456 10.9162 1.68652 10.4302 1.20047C9.94411 0.714425 9.15607 0.714425 8.67002 1.20047Z' fill='%233264FF'/%3E%3C/svg%3E\");\n}\n\n/* .hw-excursion--toggleContent ul li {\n  word-break: break-all;\n} */\n.hw-excursion--pickTime .hw-select--dropdown {\n  flex: 1 0 0;\n  max-width: 50rem;\n  position: relative;\n}\n\n.hw-dropdown--content {\n  position: absolute;\n  z-index: 2;\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);\n  background-color: var(--hw-white);\n  width: 100%;\n  top: 100%;\n  margin-top: 1rem;\n  border-radius: 1rem;\n}\n\n.hw-dropdown--content .hw-dropdown--hoverItem:not(:last-child) {\n  border-bottom: .1rem solid var(--hw-gray-200);\n}\n\n.hw-dropdown--content>.hw-dropdown--hoverItem:first-child {\n  border-top-left-radius: 1rem;\n  border-top-right-radius: 1rem;\n}\n\n.hw-dropdown--content>.hw-dropdown--hoverItem:last-child {\n  border-bottom-left-radius: 1rem;\n  border-bottom-right-radius: 1rem;\n}\n\n.float-right {\n  float: right;\n}\n\n.hw-excursion--pickTime {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  column-gap: 1rem;\n  padding-top: 2rem;\n}\n\n.hw-excursion--listProductSelect .hw-excursion--pickTimeCheckout {\n  border-top: .1rem solid var(--hw-gray-200);\n  padding-top: 2rem;\n  margin-top: 2rem;\n}\n\n.hw-excursion--selectSlider>div {\n  width: 100% !important;\n}\n\n.hw-dropdown--hoverItem {\n  padding: 1.5rem;\n  transition: background-color .2s;\n  cursor: pointer;\n}\n\n.hw-dropdown--hoverItem:hover {\n  background-color: var(--hw-brand-orange-light);\n}\n\n.hw-dropdown--summary {\n  border: .1rem solid var(--hw-gray-400);\n  background-color: var(--hw-white);\n  border-radius: 0.5rem;\n  padding: .8rem 2rem;\n  display: flex;\n  align-items: center;\n  column-gap: 1rem;\n  justify-content: space-between;\n  position: relative;\n  cursor: pointer;\n}\n\n.hw-excursion--toggleContentInclusions ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.hw-excursion--toggleContentExclusions ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.hw-excursion--toggleContentInclusions ul li::before,\n.hw-excursion--toggleContentExclusions ul li::before {\n  content: '';\n  background-size: 2rem 2rem;\n  position: absolute;\n  width: 2.2rem;\n  height: 2.2rem;\n  background-position: center center;\n  top: .5rem;\n  left: 0;\n}\n\n.hw-excursion--toggleContentInclusions ul li::before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3E%3Cpath d='M17.2203 4.37652C17.5643 4.68228 17.5953 5.20901 17.2895 5.55299L8.40063 15.553C8.24249 15.7309 8.01582 15.8327 7.77779 15.8327C7.53975 15.8327 7.31309 15.7309 7.15495 15.553L2.7105 10.553C2.40474 10.209 2.43572 9.68228 2.77971 9.37652C3.12369 9.07075 3.65042 9.10174 3.95618 9.44572L7.77779 13.745L16.0438 4.44572C16.3496 4.10174 16.8763 4.07075 17.2203 4.37652Z' fill='%233264ff'/%3E%3C/svg%3E\");\n}\n\n.hw-excursion--toggleContentExclusions ul li::before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3E%3Cpath d='M4.41107 4.41009C4.73651 4.08466 5.26414 4.08466 5.58958 4.41009L10.0003 8.82084L14.4111 4.41009C14.7365 4.08466 15.2641 4.08466 15.5896 4.41009C15.915 4.73553 15.915 5.26317 15.5896 5.5886L11.1788 9.99935L15.5896 14.4101C15.915 14.7355 15.915 15.2632 15.5896 15.5886C15.2641 15.914 14.7365 15.914 14.4111 15.5886L10.0003 11.1779L5.58958 15.5886C5.26414 15.914 4.73651 15.914 4.41107 15.5886C4.08563 15.2632 4.08563 14.7355 4.41107 14.4101L8.82181 9.99935L4.41107 5.5886C4.08563 5.26317 4.08563 4.73553 4.41107 4.41009Z' fill='%23DA102A'/%3E%3C/svg%3E\");\n}\n\n.hw-excursion--toggleContentInclusions ul li,\n.hw-excursion--toggleContentExclusions ul li {\n  position: relative;\n  list-style: none;\n  padding-left: 3rem;\n}\n\n.hw-excursion--toggleContent p strong {\n  color: var(--hw-black);\n}\n\n.hw-excursion--topSearch {\n  /* overflow: hidden; */\n}\n\n.hw-page--titlebarExcursion {\n  padding-bottom: 2rem;\n  padding-top: 2rem;\n  ;\n}\n\n.hw-excursion--modalTable thead th {\n  color: var(--hw-black);\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.hw-excursion--modalTable tbody tr td {\n  padding: 1rem 1rem 0;\n  vertical-align: top;\n}\n\n.hw-excursion--modalTable thead tr th:first-child,\n.hw-excursion--modalTable tbody tr td:first-child {\n  padding-left: 0;\n}\n\n.hw-excursion--modalTable thead tr th:last-child,\n.hw-excursion--modalTable tbody tr td:last-child {\n  padding-right: 0;\n}\n\n.hw-excursion--modalBlock .hw-excursion--listInfoList {\n  font-size: 1.8rem;\n  color: var(--hw-black);\n  line-height: 1.27273;\n  font-weight: bold;\n}\n\n.hw-excursion--modalBlock {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  row-gap: 1rem;\n}\n\n.hw-excursion--modalBlock+.hw-excursion--modalBlock {\n  margin-top: 2rem;\n}\n\n.hw-modal-header.hw-modal-headerExcursion {\n  background-color: var(--hw-brand-orange);\n  color: var(--hw-white);\n}\n\n.hw-modal-header.hw-modal-headerExcursion .hw-modal-headerTitle {\n  color: inherit;\n  font-family: var(--hw-head-font-family);\n  font-weight: 600;\n}\n\n.hw-modal-header.hw-modal-headerExcursion .hw-modal--close {\n  background-color: var(--hw-white);\n  color: var(--hw-brand-orange);\n  border-radius: .8rem;\n  padding: .8rem;\n}\n\n.hw-modal-header.hw-modal-headerExcursion .hw-modal--close:hover {\n  background-color: var(--hw-brand-blue);\n  color: var(--hw-white);\n}\n\n.hw-modal-header.hw-modal-headerExcursion+.hw-modal-body {\n  padding-top: 2rem;\n}\n\n.hw-excursion--listInfo.row {\n  row-gap: 1rem;\n}\n\n.hw-excursion--listProduct+.hw-excursion--listInfo {\n  margin-top: 1.6rem;\n}\n\n.customer-swiper-excursion .swiper-button-next,\n.customer-swiper-excursion .swiper-button-prev {\n  border-radius: 1rem;\n  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);\n  background-color: var(--hw-brand-blue);\n  color: var(--hw-white);\n  width: 5rem;\n  height: 5rem;\n  transition: background-color .2s;\n}\n\n.customer-swiper-excursion .swiper-button-next:hover,\n.customer-swiper-excursion .swiper-button-prev:hover {\n  background-color: var(--hw-brand-blue);\n  color: var(--hw-white);\n}\n\n.customer-swiper-excursion .swiper-button-prev::after,\n.customer-swiper-excursion .swiper-button-next::after {\n  font-family: swiper-icons;\n  font-size: var(--swiper-navigation-size);\n  text-transform: none !important;\n  letter-spacing: 0;\n  font-variant: initial;\n  line-height: 1;\n  font-size: 1.8rem;\n}\n\n.customer-swiper-excursion .swiper-button-next {\n  right: 0;\n}\n\n.customer-swiper-excursion .swiper-button-prev {\n  left: 0;\n}\n\n.hw-excursion--selectSlider .customer-swiper-excursion {\n  /* overflow: visible; */\n  margin-left: 0;\n  margin-right: 0;\n  position: static;\n  overflow: hidden;\n}\n\n.hw-widget--ticketCheckout .hw-passenger--pageList .hw-flight--stepsWrapper+.hw-passenger--wrapper .hw-passenger--list {\n  border-right-width: 0;\n}\n\n.hw-excursion--topSearch .hw-price--dropdown>div>span:first-child {\n  margin-right: .6rem;\n}\n\n.hw-excursion--selectSlider {\n  position: relative;\n}\n\n.hw-passenger--wrapperExcursionCheckout .hw-after--bookingWidget.tickets {\n  padding: 0;\n  border-radius: 0;\n}\n\n@media (hover: hover) and (pointer: fine) {\n  .hw-excursion--listProduct .image-gallery-thumbnail:hover {\n    border: 2px solid var(--hw-black);\n  }\n}\n\n@media (min-width: 576px) {\n  .hw-img--col120 {\n    width: 12rem !important;\n  }\n\n  .hw-car--listShow__passangerCol {\n    width: calc(100% - 12rem) !important;\n    gap: 0.8rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .hw-excursion--modalBlock+.hw-excursion--modalBlock {\n    margin-top: 3rem;\n  }\n\n  .hw-modal-header.hw-modal-headerExcursion {\n    padding-bottom: 4rem;\n  }\n\n  .hw-modal-header.hw-modal-headerExcursion+.hw-modal-body {\n    padding-top: 4rem;\n  }\n\n  .hw-excursion--modalTable thead th {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n\n  .hw-excursion--modalTable tbody tr td {\n    padding: 2rem 2rem 0;\n  }\n\n  .hw-excursion--modalBlock .hw-excursion--listInfoList {\n    font-size: 2.2rem;\n  }\n\n  .hw-excursion--toggleTitle {\n    font-size: 2.2rem;\n  }\n\n  .hw-excursion--modalBlock {\n    row-gap: 1.6rem;\n  }\n\n  .hw-book--selectbtn:not(:hover) {\n    opacity: 0;\n    transition: opacity .3s !important;\n  }\n\n  .hw-book--selectbtn {\n    position: relative;\n    z-index: 2;\n  }\n\n  .whole-link:hover~.content-box .hw-book--selectbtn {\n    opacity: 1;\n  }\n\n  .hw-modal-header.hw-modal-headerExcursion .hw-modal-headerTitle {\n    font-size: 3rem;\n    line-height: 1.5;\n  }\n\n  .hw-excursion--listProduct .image-gallery-slide .image-gallery-image {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n}\n\n@media (min-width: 992px) {\n  .hw-excursion--modalTable thead th {\n    font-size: 1.8rem;\n    line-height: 1.55556;\n  }\n\n  .hw-passenger--fareSummary__tfoot {\n    font-size: 2rem;\n    line-height: 1.4;\n  }\n\n  .hw-page--titlebar.hw-page--titlebarExcursion {\n    padding-left: 2rem;\n  }\n\n  .hw-book--filterResult .row {\n    row-gap: 3.2rem;\n    --bs-gutter-x: 2rem;\n  }\n\n  .hw-book--filterSlide {\n    column-gap: 2rem;\n  }\n\n\n\n  .hw-excursion--listProductData {\n    padding: 2rem;\n  }\n\n  .hw-excursion--listProductData>.row {\n    row-gap: 2rem;\n  }\n\n  .hw-excursion--selectSliderItem {\n    /* row-gap: 1.5rem; */\n    padding: 2rem;\n  }\n\n  .hw-excursion--listProduct .image-gallery-icon.image-gallery-play-button,\n  .hw-excursion--listProduct .image-gallery-icon.image-gallery-fullscreen-button {\n    padding: 1rem;\n    border-radius: 0.5rem;\n  }\n\n  .hw-excursion--listProduct .image-gallery-fullscreen-button .image-gallery-svg,\n  .hw-excursion--listProduct .image-gallery-play-button .image-gallery-svg {\n    height: 20px;\n    width: 20px;\n  }\n\n  .customer-swiper-excursion .swiper-button-prev {\n    left: -3rem;\n  }\n\n  .customer-swiper-excursion .swiper-button-next {\n    right: -3rem;\n  }\n}\n\n@media (min-width: 1025px) {\n\n  /* .hw-widget--ticketCheckout .hw-passenger--fareSummary {\n    top: 0;\n  } */\n  .hw-excursion--listProduct .image-gallery-slide.image-gallery-center::after {\n    min-height: 34.8rem;\n  }\n}\n\n@media (min-width: 1100px) {\n  .hw-widget.hw-widget--ticketCheckout .hw-passenger--pageList>.hw-passenger--wrapper:first-child {\n    min-height: calc(100vh - 11rem);\n  }\n}\n\n@media (min-width: 1200px) {\n\n  .customer-swiper-excursion .swiper-button-prev {\n    left: -5rem;\n  }\n\n  .customer-swiper-excursion .swiper-button-next {\n    right: -5rem;\n  }\n\n  .hw-excursion--listProduct .image-gallery-slide .image-gallery-image {\n    border-top-left-radius: 0.5rem;\n    border-bottom-left-radius: 0.5rem;\n  }\n}\n\n@media (min-width: 1400px) {\n  .customer-swiper-excursion .swiper-button-prev {\n    left: -8.5rem;\n  }\n\n  .customer-swiper-excursion .swiper-button-next {\n    right: -8.5rem;\n  }\n}\n\n@media (max-width: 767px) {\n  .hw-excursion--listProductData .h3 {\n    font-size: 2rem;\n    line-height: 1.5;\n  }\n\n  .hw-excursion--thubmGalleryItem {\n    border-radius: 1rem;\n  }\n}\n\n.hw-btn--secondaryDefault.selected-variation {\n  background-color: var(--hw-brand-blue);\n  color: var(--hw-white);\n}\n\n/* @media (min-width: 1441px) {\n.hw-book--filterResult .row > .col-xl-4 {\n  width: 25%;\n}\n}\n@media (min-width: 2200px) {\n.hw-book--filterResult .row > .col-xl-4 {\n  width: 20%;\n}\n} */\n\n.hw-price--dropdown.active>div span {\n  color: var(--hw-black);\n}\n\n.hw-price--dropdown.active svg {\n  color: var(--hw-brand-orange);\n}\n\n.hw-excursion--selectSlider .swiper-slide {\n  height: auto;\n}\n\n.hw-passenger--wrapperExcursionCheckout .css-b62m3t-container>div {\n  width: 100%;\n}\n\n.hw-widget--excursionDetails>.mt-3,\n.hw-widget--excursionDetails>.hw-excursion--list {\n  max-width: 119rem;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n\n.hw-excursion--listProductData .react-datepicker-popper {\n  z-index: 5;\n}\n\n.hw-sidebar--nav>.nav-item .nav-link.active .hw-icon--flight svg path {\n  fill: var(--hw-white);\n  stroke: var(--hw-white);\n}\n\n.hw-excursion--listProduct .image-gallery,\n.hw-excursion--listProduct .image-gallery-content,\n.hw-excursion--listProduct .image-gallery-slide-wrapper,\n.hw-excursion--listProduct .image-gallery-swipe,\n.hw-excursion--listProduct .image-gallery-slides {\n  height: 100%;\n}\n\n.hw-excursion--listProduct .image-gallery-slide {\n  height: 100%;\n}\n\n.hw-datepicker--input .react-datepicker-popper {\n  z-index: 10;\n}\n\n.hw-excursion--toggleContent ul {\n  margin-bottom: 0;\n}\n\n.hw-excursion--toggleContent ul>li+li {\n  margin-top: 1rem;\n}\n\n.hw-excursion--listProductData .DT--counter-value input,\n.hw-excursion--listProductData .DT--counter-value input:focus-visible {\n  width: 100%;\n  border: 0;\n  height: 100%;\n  text-align: center;\n  outline: none;\n}\n\n/* Chrome, Safari, Edge, Opera */\n.hw-excursion--listProductData .DT--counter-value input::-webkit-outer-spin-button,\n.hw-excursion--listProductData .DT--counter-value input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\n.hw-excursion--listProductData .DT--counter-value input[type=number] {\n  -moz-appearance: textfield;\n}\n\n.hw-excursion--listProductData .react-datepicker__day--excluded {\n  color: var(--hw-red);\n}\n\n.hw-excursion--selectSliderItem .hw-btn--secondaryDefault.disabled,\n.hw-checkout-btn.disabled {\n  background-color: var(--hw-gray-400);\n  cursor: not-allowed;\n  cursor: not-allowed;\n  color: var(--hw-white);\n  border: none;\n}\n\n.hw-checkout-btn.raiseInquiryBtn {\n  color: white;\n  background-color: #0F294D;\n  border-color: transparent;\n}\n\n.hw-checkout-btn {\n  padding: 15px 28px !important;\n}\n\n.DT--counter-display {\n  width: 6.7rem;\n  max-width: 6.7rem;\n  overflow: hidden;\n}\n\n.DT--passenger-item .DT--passenger-info {\n  display: flex;\n  flex-wrap: wrap;\n  word-break: break-all;\n}\n\n.DT--counter-value input {\n  max-width: 6.5rem;\n  border: none !important;\n  outline: none !important;\n  padding: 0;\n  text-align: center;\n}\n\n.hw-date-range-picker+.react-datepicker__tab-loop {\n  position: unset;\n}\n\n.hw-date-range-picker-excursion+.react-datepicker__tab-loop .react-datepicker-popper {\n  transform: translate(4px, 10px) !important;\n}\n\n/*Excursion redesign*/\n\n\n.ml-auto {\n  margin-left: auto;\n}\n\n/* .hw-widget.hw-widget--excursionDetails {\n  width: 100%;\n  overflow-x: hidden;\n} */\n.hw-tab--scroll__list {\n  display: flex;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  align-items: center;\n  column-gap: 1rem;\n  padding: 1.6rem 0;\n}\n\n.hw-scroll--listItem {\n  padding: .8rem 1.6rem;\n  border: .1rem solid var(--hw-gray-400);\n  border-radius: 0.5rem;\n  font-size: 1.6rem;\n  line-height: 1.5;\n  font-weight: 500;\n  color: var(--hw-black-900);\n  text-transform: capitalize;\n  transition: .2s ease-out;\n  cursor: pointer;\n  white-space: nowrap;\n  background-color: var(--hw-white);\n}\n\n.hw-scroll--listItem:hover {\n  background-color: var(--hw-brand-orange-light);\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-scroll--listItem.active {\n  background-color: var(--hw-brand-orange);\n  color: var(--hw-white);\n  border-color: var(--hw-brand-orange);\n}\n\n\n.hw-stay--stick {\n  border: .1rem solid var(--hw-gray-600);\n  background-color: var(--hw-white);\n  padding: 2rem;\n  border-radius: 0.5rem;\n}\n\n.hw-stay--stick .unlist {\n  list-style: none;\n  margin: 2rem 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  row-gap: 1rem;\n}\n\n.hw-stay--stick .unlist li {\n  display: flex;\n  align-items: flex-start;\n  column-gap: .6rem;\n}\n\n.hw-stay--stick .unlist li svg {\n  width: 2.4rem;\n  height: 2.4rem;\n  color: var(--hw-brand-orange);\n  flex-shrink: 0;\n  margin-top: 1%;\n}\n\n.hw-stay--stick .unlist li span {\n  font-weight: 500;\n  color: var(--hw-black-900);\n}\n\n.hw-excursion--thubmGallery {\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: 1fr 1fr;\n  height: 100%;\n}\n\n.hw-excursion--thubmGalleryItem {\n  background-color: var(--hw-brand-orange-light);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  overflow: hidden;\n  min-height: 11rem;\n}\n\n.hw-excursion--thubmGalleryItem img {\n  object-fit: cover;\n  position: absolute;\n  inset: 0;\n  height: 100%;\n  width: 100%;\n}\n\n.hw-excursion--thubmGalleryItem .hw-btn {\n  z-index: 1;\n}\n\n.hw-excursion--thubmGalleryItem .hw-btn::after {\n  content: '';\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  inset: 0;\n}\n\n.hw-excursion--thubmGallery .hw-excursion--thubmGalleryItem:nth-of-type(4)::after {\n  content: '';\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.hw-excursion--thubmGallery .hw-excursion--thubmGalleryItem:nth-of-type(2) {\n  border-top-right-radius: 0.5rem;\n}\n\n.hw-excursion--thubmGallery .hw-excursion--thubmGalleryItem:nth-of-type(4) {\n  border-bottom-right-radius: 0.5rem;\n}\n\n.hw-excursion--thubmGalleryItem.empty-image {\n  color: var(--hw-brand-orange);\n}\n\n.hw-person--roomInput .hw-input--input {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  padding-top: 0;\n  padding-bottom: 0;\n  place-content: center;\n}\n\n.hw-person--roomInput .hw-input--input svg {\n  grid-row: span 2;\n}\n\n.hw-person--roomInput .hw-input--input,\n.hw-gp--btn .hw-btn,\n.hw-excursion--listProductData .hw-datepicker--input .react-datepicker-wrapper .hw-input--input {\n  min-height: 5.8rem;\n}\n\n.hw-mt--20 {\n  margin-top: 2rem !important;\n}\n\n.hw-excursion--availabilityWrapper {\n  display: flex;\n  column-gap: 1.5rem;\n  flex-wrap: wrap;\n  row-gap: 1rem;\n  justify-content: end;\n}\n\n.hw-excursion--availabilityWrapperNoTimeSlots {\n  display: flex;\n  column-gap: 1.5rem;\n  flex-wrap: wrap;\n  row-gap: 1rem;\n  /* gap: 6.5rem; */\n  justify-content: end;\n}\n\n.hw-excursion--availabilityWrapper .hw-select--dropdown {\n  min-width: 16.7rem;\n}\n\n.hw-excursion--selectSliderItem {\n  position: relative;\n}\n\n.hw-excursion--selectSliderItem .hw-main--loaderCommon {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  right: 0;\n  min-height: 100%;\n}\n\n.hw-excursion--availabilityWrapper .hw-dropdown--content {\n  right: 0;\n}\n\n.hw-excursion--listProduct .col-md-12>.row {\n  row-gap: 1rem;\n}\n\n.hw-excursion--checkout {\n  display: flex;\n  align-items: flex-end;\n}\n\n.ml-auto {\n  margin-left: auto;\n}\n\n@media (min-width: 370px) {\n  .hw-excursion--availabilityWrapper .hw-dropdown--content {\n    min-width: 32rem;\n  }\n}\n\n@media (min-width: 480px) {\n\n  .hw-widget--excursionDetails>.mt-3,\n  .hw-widget--excursionDetails>.hw-excursion--list {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n\n  .hw-excursion--availabilityWrapper {\n    column-gap: 3.2rem;\n  }\n}\n\n@media (min-width : 750px) {\n\n  .hw-person--roomInput .hw-input--input,\n  .hw-gp--btn .hw-btn,\n  .hw-excursion--listProductData .hw-datepicker--input .react-datepicker-wrapper .hw-input--input {\n    min-height: 6.6rem;\n  }\n}\n\n@media (min-width: 900px) {\n\n  /* .hw-person--roomInput .hw-input--input, .hw-gp--btn .hw-btn,.hw-excursion--listProductData .hw-datepicker--input .react-datepicker-wrapper .hw-input--input {\n    min-height: 6.4rem;\n  } */\n  .hw-scroll--content {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    column-gap: 1.6rem;\n    margin-top: 2rem;\n  }\n\n  .hw-scroll--listItem {\n    padding: 1rem 1.6rem;\n    font-size: 1.8rem;\n    line-height: 1.55556;\n  }\n\n  .hw-stay--stick {\n    min-width: 34.2rem;\n    flex-shrink: 0;\n    max-width: 34.2rem;\n    position: sticky;\n    top: 17rem;\n  }\n\n\n\n  .hw-book--ticketSection {\n    flex: 1 0 0;\n  }\n\n  .hw-tab--scroll__list {\n    position: sticky;\n    top: 7rem;\n    z-index: 2;\n    background-color: var(--hw-gray-100);\n  }\n}\n\n@media (min-width: 992px) {\n  .hw-tab--scroll__list {\n    top: 8.7rem;\n  }\n\n  .hw-excursion--selectSliderItem .hw-main--loaderCommon {\n    width: 41.66666667%;\n  }\n}\n\n@media (min-width: 1100px) {\n\n  .hw-scroll--content {\n    column-gap: 3.2rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  .hw-excursion--selectSliderItem .hw-main--loaderCommon {\n    width: 50%;\n  }\n\n  .hw-excursion--availabilityWrapper .hw-dropdown--content {\n    min-width: 34rem;\n    left: 0;\n    right: auto;\n  }\n\n}\n\n@media (min-width: 1440px) {\n  .hw-excursion--availabilityWrapper {\n    column-gap: 4rem;\n    padding-left: 4rem;\n  }\n}\n\n@media (max-width: 991px) {\n  .hw-excursion--thubmGalleryItem .hw-btn {\n    font-size: 1.4rem;\n    padding: .5rem 1rem;\n    border-radius: .4rem;\n    column-gap: .5rem;\n  }\n\n  .hw-excursion--thubmGalleryItem .hw-btn svg {\n    width: 2rem;\n    height: 2rem;\n  }\n}\n\n@media (max-width: 899px) {\n  .hw-scroll--content {\n    display: flex;\n    flex-direction: column;\n    row-gap: 2rem;\n    margin-top: 2rem;\n\n  }\n\n  .hw-scroll--contentList>.hw-excursion--toggleItem:last-child {\n    border-bottom-width: 0;\n  }\n\n  .hw-tab--scroll__list {\n    position: sticky;\n    top: 7rem;\n    background-color: var(--hw-gray-300);\n    z-index: 9;\n    margin: 0 -3rem;\n\n  }\n}\n\n@media (max-width: 600px) {\n  .hw-tab--scroll__list {\n    margin: 0 -1.5rem;\n  }\n}\n\n@media (max-width: 479px) {\n  .hw-excursion--checkout {\n    flex: 1 0 0;\n  }\n\n  .hw-excursion--checkout .hw-btn {\n    width: 100%;\n  }\n\n  .sxxl-flex--grow {\n    flex-grow: 1;\n  }\n}\n\n@media (max-width: 400px) {\n  .hw-person--roomInput .paasenger-modal {\n    width: 100%;\n  }\n}\n\n/*End Excursion redesign*/\n\n\n.hw-excursion--availabilityWrapper .hw-dropdown--content {\n  z-index: 4;\n}\n\n.mr-auto {\n  margin-right: auto;\n}\n\n.hw-widget.hw-widget--excursionDetails .paasenger-modal .DT--card-container .DT--title {\n  padding: 1.6rem 1.6rem 0;\n  margin-bottom: 0 !important;\n}\n\n.hw-widget.hw-widget--excursionDetails .paasenger-modal .DT--card-container .DT--section {\n  padding-bottom: 1.6rem;\n}\n\n.hw-scroll--contentList .hw-excursion--toggleItem+.hw-excursion--toggleItem {\n  margin-top: 2rem;\n}\n\n@media (min-width: 768px) {\n  .hw-widget.hw-widget--excursionDetails .hw-person--roomInput .paasenger-modal {\n    min-width: 47.4rem;\n  }\n\n  .hw-excursion--toggleItem+.hw-excursion--toggleItem {\n    margin-top: 2rem;\n  }\n}\n\n@media (min-width: 900px) {\n  .hw-excursion--listProductData .hw-person--roomInput .paasenger-modal {\n    top: 7rem;\n  }\n}\n\n@media (max-width: 1024px) {\n  .hw-widget--ticketCheckout .hw-passenger--fareSummary {\n    position: unset;\n    max-height: unset;\n  }\n}\n\n@media (max-width: 1150px) {\n  .time-options-container {\n    flex-direction: column;\n\n    gap: 1rem;\n  }\n\n  .time-grid {\n    max-width: 100% !important;\n  }\n}\n\n\n/*New CSS*/\n.hw-excursion--mainSearch {\n  display: flex;\n  flex-direction: column;\n  margin-top: 1.5rem;\n}\n\n.hw-excursion--mainSearch .hw-widget--card {\n  background-color: var(--hw-white);\n  position: relative;\n  border-radius: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.hw-excursion--iconScroll {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  overflow-x: auto;\n}\n\n.hw-excursion--categorySlider {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  z-index: 2;\n}\n\n.hw-excursion--categorySlider .hw-excursion--categorySlider-btn {\n  position: absolute;\n  width: 3rem;\n  height: 3rem;\n  border-radius: 50%;\n  background-color: var(--hw-white);\n  border: 1px solid #3264FF;\n  color: var(--hw-black-900);\n  font-size: 2.4rem;\n  line-height: 1;\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n  z-index: 2;\n}\n\n.hw-excursion--categorySlider-btn.prev {\n  left: -1rem;\n}\n\n.hw-excursion--categorySlider-btn.next {\n  right: -1rem;\n}\n\n.hw-excursion--categorySlider .hw-excursion--categorySlider-btn:hover {\n  background-color: var(--hw-brand-orange-light);\n  border-color: var(--hw-brand-orange);\n  color: var(--hw-brand-orange);\n}\n\n.hw-excursion--categorySlider .hw-excursion--categorySlider-btn:active {\n  transform: scale(0.95);\n}\n\n.hw-excursion--categorySlider .hw-excursion--categorySlider-btn.prev {\n  order: -1;\n}\n\n.hw-excursion--categorySlider .hw-excursion--categorySlider-btn.next {\n  order: 1;\n}\n\n.hw-excursion--categorySlider .hw-excursion--customSlider {\n  flex: 1;\n  overflow: hidden;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.hw-excursion--categorySlider .hw-excursion--customSlider::-webkit-scrollbar {\n  display: none;\n}\n\n.hw-excursion--categorySlider .swiper-button-next {\n  width: 18px !important;\n  height: 18px !important;\n  transform: rotate(-90deg) !important;\n  aspect-ratio: 1/1 !important;\n}\n\n.hw-excursion--iconScrollItem {\n  /* padding: 0.5rem 1.2rem;\n  border: 1px solid var(--hw-gray-600);\n  border-radius: 5px;\n  display: flex !important;\n  align-items: center;\n  gap: 0.8rem;\n  white-space: nowrap;\n  color: var(--hw-black-900);\n  font-size: 1.6rem;\n  line-height: 1.5;\n  font-weight: 500;\n  cursor: pointer;\n  transition: 0.2s ease-in-out; */\n  border-radius: 5px;\n  border: 1px solid #D7D7D7;\n  background: var(--White, #FFF);\n  display: flex;\n  padding: 10px 24px;\n  align-items: center;\n  gap: 8px;\n  color: var(--Violet, #121826);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 28px;\n}\n\n.hw-excursion--iconScrollItem:hover {\n  background-color: var(--hw-brand-blue-light);\n  border-color: var(--hw-brand-orange);\n  cursor: pointer;\n}\n\n.hw-book--filterResult .load-more {\n  max-width: 18rem;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.hw-excursion--thubmGalleryItem .hw-btn {\n  column-gap: 0.8rem;\n}\n\n.hw-excursion--thubmGalleryItem .hw-btn svg {\n  width: 2rem;\n  height: 2rem;\n}\n\n.image-gallery-swipe .image-gallery-slides {\n  border-radius: 0.5rem;\n}\n\n.react-datepicker-wrapper .hw-input--input,\n.hw-person--roomInput svg {\n  color: var(--hw-brand-blue);\n}\n\n.hw-excursion--selectSlider p:last-child {\n  margin-bottom: 0;\n}\n\n.hw-widget--ticketCheckout .hw-passenger--detailsGroup {\n  margin-top: 2rem;\n}\n\n.hw-passenger--wrapperExcursionCheckout .hw-after--bookingWidget.price-backup {\n  padding: 0;\n}\n\n/*Time slot design*/\n.time-picker-container {\n  /* max-width: 79.8rem; */\n  background: var(--hw-white);\n  padding: 0 0 0 3rem;\n}\n\n.time-options-container {\n  display: flex;\n  gap: 4rem;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.legend {\n  display: flex;\n  gap: 1.6rem;\n  margin-bottom: 1rem;\n  align-items: center;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.legend-item-tooltip {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  /* cursor: help; */\n}\n\n.legend-tooltip {\n  visibility: hidden;\n  opacity: 0;\n  position: absolute;\n  bottom: 3rem;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: white;\n  color: var(--hw-black);\n  padding: 0.8rem 1.2rem;\n  font-size: 1.2rem;\n  line-height: 1.5;\n  font-weight: 400;\n  white-space: normal;\n  width: 18rem;\n  /* max-width: 90vw; */\n  z-index: 1000;\n  transition: opacity 0.3s ease, visibility 0.3s ease;\n  text-align: center;\n  border: 1px solid #3264FF;\n}\n\n.legend-tooltip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border-width: 6px;\n  border-style: solid;\n  border-color: #3264FF transparent transparent transparent;\n}\n\n.legend-item-tooltip:hover .legend-tooltip {\n  visibility: visible;\n  opacity: 1;\n}\n\n.legend-color {\n  width: 1.1rem;\n  height: 1.2rem;\n  border-radius: 2px;\n  border: 1px solid transparent;\n}\n\n.prime-color {\n  background-color: #3264FF;\n  border-color: #3264FF;\n}\n\n.non-prime-color {\n  background-color: #4AB562;\n  border-color: #4AB562;\n}\n\n.nonprime-color {\n  color: #4AB562;\n  line-height: 24px;\n}\n\n.primecolor {\n  color: #3264FF;\n  line-height: 24px;\n}\n\n.lowticket-color {\n  color: #DA102A;\n  line-height: 24px;\n}\n\n.low-ticket-color {\n  background-color: #DA102A;\n  border-color: #DA102A;\n}\n\n.time-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 1.6rem;\n  max-width: 79.6rem;\n  /* min-width: 79.6rem; */\n  min-width: auto;\n  /* Remove fixed min-width */\n}\n\n.time-slot {\n  padding: 0;\n  border: 1px solid;\n  border-radius: 5px;\n  text-align: center;\n  font-size: 16px;\n  font-weight: normal;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background-color: var(--hw-white);\n  user-select: none;\n  max-height: 4.5rem;\n  max-width: 180px;\n}\n\n.time-slot-seats {\n  color: #7B7B7B;\n  font-weight: 500;\n}\n\n.time-slot:hover {\n  transform: translateY(-1px);\n\n}\n\n.time-slot.disabled-slot {\n  cursor: not-allowed;\n  border-color: #DA102A !important;\n}\n\n.time-slot.disabled-slot .time-grid--topTime {\n  border-radius: 5px !important;\n  color: #DA102A !important;\n  background-color: #FCEFF1 !important;\n}\n\n.time-slot.disabled-slot .time-slot-seats {\n  color: #DA102A !important;\n}\n\n.time-slot:active,\n.time-slot.selected {\n  transform: translateY(0);\n}\n\n.time-slot.selected {\n  cursor: auto;\n}\n\n.time-slot.prime {\n  border-color: rgba(50, 100, 255, 0.30);\n}\n\n.time-slot.open-date {\n  border-color: #3264FF;\n  max-height: fit-content;\n}\n\n.time-slot.open-date:hover,\n.time-slot.open-date.selected {\n  border-color: #3264FF;\n}\n\n.time-slot.prime:hover,\n.time-slot.prime.selected {\n  border-color: #3264FF;\n}\n\n.time-slot.open-date .time-grid--topTime {\n  color: #3264FF;\n  border-radius: 5px;\n\n}\n\n.time-slot.open-date.selected .time-grid--topTime {\n  background-color: #3264FF;\n  color: #fff;\n}\n\n.time-slot.open-date.selected .time-grid--topTime svg g path {\n  stroke: #fff;\n}\n\n.time-slot.non-prime {\n  border-color: rgba(74, 181, 98, 0.30);\n}\n\n.time-slot.low-ticket {\n  border-color: rgba(218, 16, 42, 0.30);\n}\n\n.time-slot.non-prime:hover,\n.time-slot.non-prime.selected {\n  border-color: #1EAC3E;\n}\n\n.time-slot.low-ticket:hover,\n.time-slot.low-ticket.selected {\n  border-color: #DA102A;\n}\n\n.time-grid--topTime {\n  display: flex;\n  padding: 1.1rem;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  font-weight: 700;\n  align-self: stretch;\n  min-height: 3.6rem;\n}\n\n.time-slot.non-prime .time-grid--topTime {\n  color: #1EAC3E;\n  background-color: rgba(30, 172, 62, 0.10);\n}\n\n.time-slot.prime .time-grid--topTime {\n  background: rgba(50, 100, 255, 0.10);\n  color: #3264FF;\n}\n\n.time-slot.low-ticket .time-grid--topTime {\n  color: #DA102A;\n  background-color: #FCEFF1;\n  border-radius: 5px;\n}\n\n.time-grid--priceDetails {\n  display: flex;\n  flex-direction: column;\n  row-gap: 0.8rem;\n  padding: 0.8rem;\n}\n\n.time-grid--priceDetails div>span:first-child {\n  margin-right: 0.4rem;\n}\n\n.time-slot.non-prime.selected .time-grid--topTime,\n.time-slot.non-prime.selected .time-slot-seats {\n  background-color: #1EAC3E;\n  color: var(--hw-white);\n}\n\n.time-slot.low-ticket.selected .time-grid--topTime,\n.time-slot.low-ticket.selected .time-slot-seats {\n  background-color: #DA102A;\n  color: var(--hw-white);\n}\n\n.time-slot.prime.selected .time-grid--topTime,\n.time-slot.prime.selected .time-slot-seats {\n  background-color: #3264FF;\n  color: var(--hw-white);\n}\n\n.time-options-right {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  width: -webkit-fill-available;\n  max-width: 350px;\n}\n\n.time-options-item {\n  border-radius: 10px;\n  border: 1px solid rgba(215, 215, 215, 0.20);\n  background: #FFF;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);\n  display: flex;\n  padding: 8px 16px;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1 0 0;\n}\n\n.time-options-item-price {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n}\n\n.time-options-item-price .price {\n  overflow: hidden;\n  color: var(--hw-brand-blue);\n  text-overflow: ellipsis;\n  font-weight: 700;\n  line-height: 24px;\n}\n\n.excursion-error-cls {\n  margin-top: 10px;\n  max-width: 130px;\n}\n\n.hw-excursion--pageLoader {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(255, 255, 255, 0.7);\n  backdrop-filter: blur(1px);\n}\n\n.hw-excursion--pageLoaderSpinner {\n  width: 4rem;\n  height: 4rem;\n  border-radius: 50%;\n  border: 0.5rem solid var(--hw-brand-orange-light);\n  border-top-color: var(--hw-brand-orange);\n  animation: loading 2s linear infinite;\n}\n\n.hw-variation--cancellation {\n  margin-top: 1.6rem;\n}\n\n.hw-variation--cancellation .hw-passenger--listShow__widget {\n  padding: 0;\n  border: none;\n  background: transparent;\n  box-shadow: none;\n}\n\n.hw-variation--cancellation .hw-text20 {\n  font-size: 1.6rem;\n}\n\n.hw-cancellation--list,\n.hw-cancellation--list ul {\n  margin: 0;\n  padding-left: 1.8rem;\n  list-style: disc;\n}\n\n.hw-cancellation--list li {\n  font-size: 1.4rem;\n  line-height: 1.6;\n  color: var(--hw-black-900);\n}\n\n.hw-cancellation--list li+li {\n  margin-top: 0.6rem;\n}\n\n.hw-availability--error {\n  margin-top: 0.8rem;\n  font-size: 1.3rem;\n  line-height: 1.4;\n  text-align: right;\n}\n\n.excursion-error-cls.w-100 {\n  max-width: 100%;\n  width: 100%;\n  text-align: right;\n  white-space: normal;\n}\n\n/* Responsive adjustments */\n@media (max-width: 640px) {\n  .time-grid {\n    grid-template-columns: repeat(auto-fit, minmax(90px, 1fr));\n    gap: 10px;\n  }\n\n  .time-slot {\n    /* padding: 10px 12px; */\n    font-size: 13px;\n    min-width: 90px;\n  }\n\n  .legend {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .time-grid--topTime {\n    padding: 0;\n  }\n\n  .time-slot-seats {\n    white-space: nowrap;\n    font-size: 10px;\n  }\n\n  .excursion-error-cls {\n    max-width: 100%;\n  }\n\n  .hw-excursion--checkout {\n    align-items: flex-start;\n  }\n}\n\n/*End Time slot design*/\n\n\n@media (min-width: 768px) {\n  .image-gallery-swipe .image-gallery-slides {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  .hw-excursion--mainSearch {\n    /* margin-top: 11rem; */\n  }\n\n  .hw-excursion--mainSearch .hw-widget--card {\n    padding: 2.4rem;\n  }\n}\n\n@media (min-width: 901px) {\n  .hw-excursion--iconScroll {\n    gap: 1.6rem;\n  }\n\n  .hw-excursion--iconScrollItem {\n    padding: 0.9rem 2.4rem;\n    font-size: 1.8rem;\n    line-height: 1.55556;\n  }\n\n  .hw-search--excursionList {\n    align-items: flex-start;\n  }\n\n  /* Keep the sticky filter below the fixed site header so its top\n     (Filters bar + search box) is never hidden behind it. */\n  .hw-search--excursionList .hw-search--flightFilter {\n    top: 9rem;\n    max-height: calc(100dvh - 11rem);\n  }\n\n  /* .hw-search--excursionList .hw-search--flightFilter__top {\n    padding-top: 0.4rem;\n    padding-bottom: 0.4rem;\n  } */\n}\n\n@media (min-width: 1024px) {\n  .hw-excursion--thubmGalleryItem .hw-btn {\n    padding-left: 2.8rem;\n    padding-right: 2.8rem;\n  }\n}\n\n@media (min-width: 1360px) {\n\n  .hw-person--roomInput .hw-input--input,\n  .hw-gp--btn .hw-btn,\n  .hw-excursion--listProductData .hw-datepicker--input .react-datepicker-wrapper .hw-input--input {\n    min-height: 7.6rem;\n  }\n\n  .hw-excursion--listProductData .hw-input--input,\n  .hw-excursion--listProductData .hw-gp--btn .hw-btn {\n    min-height: 7.6rem !important;\n  }\n}\n\n.hw-excursion-search .css-1jqq78o-placeholder {\n  color: var(--Dark-Blue, #0F294D);\n  font-family: \"DM Sans\";\n  font-style: normal;\n  font-weight: 500 !important;\n  line-height: 1.75rem;\n  padding-left: 2rem;\n  /* margin-left: 2rem !important; */\n}\n\n/*End New Design CSS*/\n\n.hw-excursion-search .css-19bb58m {\n  padding-left: 1.8rem;\n}\n\n.hw-excursion-search .css-1cfo1cf {\n  padding-left: 2rem;\n}\n\n.hw-excursion-search .css-eegupw-control svg {\n  color: var(--hw-brand-blue) !important;\n}\n\n.hw-excursion-search .css-b62m3t-container>div {\n  background-repeat: no-repeat;\n  background-size: 2rem 2rem;\n  min-height: 5rem;\n  background-position: left 1.5rem center;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3E%3Cpath d='M19 19L13 13M1 8C1 8.91925 1.18106 9.82951 1.53284 10.6788C1.88463 11.5281 2.40024 12.2997 3.05025 12.9497C3.70026 13.5998 4.47194 14.1154 5.32122 14.4672C6.1705 14.8189 7.08075 15 8 15C8.91925 15 9.82951 14.8189 10.6788 14.4672C11.5281 14.1154 12.2997 13.5998 12.9497 12.9497C13.5998 12.2997 14.1154 11.5281 14.4672 10.6788C14.8189 9.82951 15 8.91925 15 8C15 7.08075 14.8189 6.1705 14.4672 5.32122C14.1154 4.47194 13.5998 3.70026 12.9497 3.05025C12.2997 2.40024 11.5281 1.88463 10.6788 1.53284C9.82951 1.18106 8.91925 1 8 1C7.08075 1 6.1705 1.18106 5.32122 1.53284C4.47194 1.88463 3.70026 2.40024 3.05025 3.05025C2.40024 3.70026 1.88463 4.47194 1.53284 5.32122C1.18106 6.1705 1 7.08075 1 8Z' stroke='%230F294D' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n}\n\n.hw-excursion-search .css-b62m3t-container>div:hover {\n  background-color: var(--hw-brand-orange-light);\n  border-color: var(--hw-brand-orange);\n  cursor: pointer;\n}\n\n.hw-excursion-search .css-b62m3t-container>div>.css-hlgwow {\n  padding-left: 1rem;\n}\n\n.hw-excursion-search .css-b62m3t-container>div .css-1dimb5e-singleValue {\n  padding-left: 2rem;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n@media (min-width: 1200px) {\n\n  .hw-person--roomInput .hw-input--input,\n  .hw-gp--btn .hw-btn,\n  .hw-excursion--listProductData .hw-datepicker--input .react-datepicker-wrapper .hw-input--input {\n    min-height: 7.6rem;\n  }\n}\n\n.hw-date-right-align {\n  margin-left: auto;\n}\n\n.hw-excursion--listProduct .image-gallery-icon.image-gallery-fullscreen-button:hover {\n  background-color: #3264FF;\n}\n\n.hw-excursion--listProduct .image-gallery-icon.image-gallery-fullscreen-button:hover svg path {\n  fill: white !important;\n}\n\n@media (max-width: 468px) {\n  .hw-excursion-search>div:first-child {\n    width: 100% !important;\n  }\n\n  .hw-excursion-banner-title {\n    font-size: 25px;\n  }\n\n  .time-picker-container {\n    padding: 0;\n  }\n\n  .time-grid {\n    min-width: 9rem !important;\n  }\n\n  .time-options-right {\n    min-width: auto;\n  }\n}\n\n@media (max-width: 1268px) {\n  .time-grid {\n    min-width: max-content;\n  }\n\n  .time-options-right {\n    width: 30rem;\n  }\n}\n\n.hw-excursion--note {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  align-self: stretch;\n}\n\n.hw-p-success-cls {\n  color: #1EAC3E;\n}\n\n.hw-excursion--note.note-seat-available {\n  border-radius: 5px;\n  background: #FBE7EA;\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 12px;\n  color: #DA102A;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  margin-top: 2rem;\n  flex-wrap: wrap;\n}\n\n.hw-excursion--note.note-seat-available svg {\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  margin-top: 2px;\n}\n\n.hw-excursion--note.seat-available {\n  border-radius: 5px;\n  background: #E7F5E9;\n  display: flex;\n  padding: 12px;\n  align-items: center;\n  gap: 8px;\n  align-self: stretch;\n  color: #0A7519;\n  margin-top: 2rem;\n}\n\n.hw-excursion--note.note-seat-available span {\n  white-space: nowrap;\n}\n\n.hw-excursion--error-cls {\n  /* bottom: -120% !important; */\n  position: absolute;\n  top: 8%;\n  right: 15%;\n}\n\n.opendate-color svg {\n  width: 1.5rem !important;\n  height: 1.5rem !important;\n}\n\n@media (max-width : 1100px) {\n  .hw-excursion--error-cls {\n    right: 18%;\n  }\n}\n\n@media (max-width: 768px) {\n  .hw-excursion--note.note-seat-available {\n    font-size: 14px;\n    line-height: 20px;\n    padding: 10px;\n    gap: 6px;\n    margin-top: 1.5rem;\n  }\n\n  .hw-excursion--note.note-seat-available svg {\n    width: 18px;\n    height: 18px;\n  }\n\n  .hw-excursion-search>div:first-child {\n    width: 70% !important;\n  }\n\n  .hw-excursion--error-cls {\n    top: 13%;\n    right: 25%;\n  }\n}\n\n@media (max-width: 480px) {\n  .hw-excursion-search>div:first-child {\n    width: 100% !important;\n  }\n\n  .hw-excursion--note.note-seat-available {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 6px;\n  }\n\n  .hw-excursion--note.note-seat-available span {\n    white-space: normal;\n  }\n\n  .hw-excursion--error-cls {\n    top: 13%;\n    right: 15%;\n  }\n}\n\n.hw-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid white;\n  border-top: 3px solid transparent;\n  border-radius: 50%;\n  animation: spin 0.7s linear infinite;\n}\n\n@keyframes spin {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.hw-excursion-banner-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, rgba(15, 41, 77, 0.4) 0%, rgba(15, 41, 77, 0.6) 100%);\n  z-index: 1;\n}\n\n.hw-excursion-banner-title {\n  position: relative;\n  z-index: 2;\n  font-family: 'Poppins', sans-serif;\n  font-size: 3.6rem;\n  font-weight: 600;\n  color: var(--hw-white);\n  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  margin-bottom: 2rem;\n}\n\n.hw-excursion-search-widget {\n  position: relative;\n  z-index: 20;\n  background: var(--hw-white);\n  border-radius: 1.2rem;\n  padding: 1.5rem 2.5rem;\n  box-shadow: 0 10px 40px rgba(15, 41, 77, 0.15);\n  display: flex;\n  align-items: stretch;\n  gap: 2rem;\n  width: 100%;\n  max-width: 100%;\n  margin-top: 1rem;\n}\n\n.hw-excursion-search-col {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.hw-excursion-search-col label {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--hw-gray-500);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.hw-excursion-search-btn {\n  background-color: var(--hw-brand-orange);\n  color: var(--hw-white);\n  border: none;\n  border-radius: 0.8rem;\n  padding: 0;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  flex: 1;\n  min-height: 5.5rem;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.hw-excursion-search-col-btn {\n  flex: 0 0 10rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.hw-excursion-search-btn svg {\n  width: 2.2rem;\n  height: 2.2rem;\n}\n\n/* Travel date field in hero search widget */\n.hw-excursion-search-col .react-datepicker-wrapper,\n.hw-excursion-search-col .hw-excursion-search-datepicker {\n  display: flex;\n  flex: 1;\n  width: 100%;\n}\n\n.hw-excursion-search-col-date .react-datepicker__input-container {\n  display: flex;\n  width: 100%;\n}\n\n.hw-excursion-search-col-date .hw-input--input {\n  display: flex;\n  align-items: center;\n  column-gap: 1rem;\n  min-height: 5.5rem;\n  height: 100%;\n  width: 100%;\n  padding: 0 1.4rem;\n  border: 1px solid var(--hw-gray-400);\n  border-radius: 4px;\n  background-color: var(--hw-white);\n  cursor: pointer;\n  font-size: 1.4rem;\n  position: relative;\n}\n\n.hw-excursion-search-col-date .hw-input--input:hover {\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-excursion-search-col-date .hw-input--input svg {\n  flex-shrink: 0;\n}\n\n.hw-excursion-search-col-date .hw-date--selectedDate {\n  font-weight: 500;\n  color: var(--hw-black-900);\n}\n\n.hw-excursion-search-col-date {\n  position: relative;\n}\n\n/* Anchor the calendar directly below the field, flush with the widget's bottom edge */\n.hw-excursion-search-col-date .react-datepicker__tab-loop {\n  position: absolute;\n  top: calc(100% + 1.6rem);\n  left: 0;\n  width: 100%;\n  z-index: 30;\n}\n\n.hw-excursion-search-col-date .react-datepicker-popper {\n  position: static !important;\n  transform: none !important;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n.hw-excursion-search-col-date .react-datepicker {\n  width: 100%;\n  background-color: var(--hw-white);\n  border: 1px solid var(--hw-gray-400);\n  border-radius: 1.2rem;\n  padding: 1.6rem;\n  box-shadow: 0 10px 40px rgba(15, 41, 77, 0.2);\n}\n\n.hw-excursion-search-col-date .react-datepicker__month-container {\n  float: none;\n  width: 100%;\n}\n\n.hw-excursion-search-col-date .react-datepicker__day-names,\n.hw-excursion-search-col-date .react-datepicker__week {\n  display: flex;\n  column-gap: 0.5rem;\n  width: 100%;\n}\n\n.hw-excursion-search-col-date .react-datepicker__day-name,\n.hw-excursion-search-col-date .react-datepicker__day {\n  flex: 1 1 0;\n  width: auto;\n  min-width: 0;\n  margin: 0;\n  text-align: center;\n}\n\n.hw-select--option {\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 1rem 1.4rem;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.hw-select--option .hw-select--optionRow {\n  display: flex;\n  align-items: center;\n  column-gap: 1rem;\n  width: 100%;\n  pointer-events: none;\n}\n\n.hw-select--option.is-focused,\n.hw-select--option:hover {\n  background-color: var(--hw-brand-orange-light);\n}\n\n.hw-select--option.is-selected {\n  background-color: var(--hw-brand-orange-light);\n  font-weight: 600;\n}\n\n.hw-excursion-search-col-date .hw-blue.overflow-hidden {\n  flex: 1;\n  min-width: 0;\n  overflow: visible;\n}\n\n.hw-excursion-search-col-date .hw-date--selectedDate {\n  display: block;\n  line-height: 1.6;\n  padding-block: 0.2rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.hw-excursion-search-col-date .hw-line--height1 {\n  line-height: 1.6;\n}\n\n.hw-excursion-search-col-date .react-datepicker__day--outside-month:not([aria-disabled=\"true\"]),\n.hw-date-range-picker-excursion+.react-datepicker__tab-loop .react-datepicker__day--outside-month:not([aria-disabled=\"true\"]) {\n  cursor: pointer;\n  color: var(--hw-gray-700);\n}\n\n.hw-excursion-search-col-date .react-datepicker__day--outside-month:not([aria-disabled=\"true\"]):hover,\n.hw-date-range-picker-excursion+.react-datepicker__tab-loop .react-datepicker__day--outside-month:not([aria-disabled=\"true\"]):hover {\n  background-color: var(--hw-brand-orange-light) !important;\n  color: var(--hw-brand-orange);\n}\n\n.hw-excursion-search-skeleton {\n  flex: 1;\n  display: flex;\n  min-height: 5.5rem;\n  width: 100%;\n}\n\n.hw-excursion-search-skeleton .react-loading-skeleton {\n  height: 100%;\n  width: 100%;\n}\n\n.hw-excursion-search-error {\n  font-size: 1.2rem;\n  color: var(--hw-red, #e02424);\n  line-height: 1.3;\n  margin-top: 0.2rem;\n}\n\n.hw-excursion-search-col-date .hw-input--input.hw--error-cls-date-input {\n  border-color: var(--hw-red, #e02424);\n}\n\n@media (max-width: 992px) {\n  .hw-excursion-search-col-btn {\n    flex: 1;\n  }\n\n  .hw-excursion-search-col-btn label {\n    display: none;\n  }\n}\n\n.hw-excursion-search-btn:hover {\n  background-color: var(--hw-brand-orange-hover);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(50, 100, 255, 0.3);\n}\n\n.hw-excursion-section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  /* border-left: 4px solid var(--hw-brand-orange);\n  padding-left: 1.5rem; */\n}\n\n.hw-excursion-section-title {\n  font-family: 'Poppins';\n  font-size: 2.4rem;\n  font-weight: 600;\n  color: var(--hw-black-900);\n  margin-bottom: 0;\n}\n\n.hw-excursion-section-subtitle {\n  font-size: 1.4rem;\n  color: var(--hw-gray-500);\n  margin-top: 0.4rem;\n}\n\n.hw-excursion-slider-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.hw-excursion-card-slider {\n  display: flex;\n  gap: 2rem;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  padding: 1rem 0;\n  width: 100%;\n}\n\n.hw-excursion-card-slider::-webkit-scrollbar {\n  display: none;\n}\n\n.hw-excursion-premium-card {\n  flex: 0 0 28rem;\n  background: var(--hw-white);\n  border-radius: 1rem;\n  border: 1px solid var(--hw-gray-200);\n  overflow: hidden;\n  position: relative;\n  transition: all 0.3s ease;\n  display: flex;\n  flex-direction: column;\n}\n\n.hw-excursion-premium-card:hover {\n  /* transform: translateY(-5px);\n  box-shadow: 0 10px 25px rgba(15, 41, 77, 0.1); */\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-excursion-card-img-wrapper {\n  position: relative;\n  width: 100%;\n  height: 18rem;\n  overflow: hidden;\n}\n\n.hw-excursion-card-img-wrapper img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.5s ease;\n}\n\n.hw-excursion-premium-card:hover .hw-excursion-card-img-wrapper img {\n  transform: scale(1.1);\n}\n\n.hw-excursion-card-badge {\n  position: absolute;\n  top: 1rem;\n  left: 1rem;\n  background-color: var(--hw-brand-blue);\n  color: var(--hw-white);\n  font-size: 1.1rem;\n  font-weight: 700;\n  padding: 0.4rem 0.8rem;\n  border-radius: 0.4rem;\n  z-index: 2;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n\n.hw-excursion-card-content {\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n}\n\n.hw-excursion-card-category {\n  font-size: 1.2rem;\n  color: var(--hw-brand-orange);\n  font-weight: 600;\n  margin-bottom: 0.6rem;\n  text-transform: uppercase;\n}\n\n.hw-excursion-card-title {\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: var(--hw-black-900);\n  line-height: 1.4;\n  margin-bottom: 1rem;\n  height: 4.4rem;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.hw-excursion-card-meta {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  font-size: 1.2rem;\n  color: var(--hw-gray-500);\n  margin-bottom: 1.5rem;\n}\n\n.hw-excursion-card-meta-item {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.hw-excursion-card-rating {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  color: #ffc107;\n  font-weight: 700;\n}\n\n.hw-excursion-card-rating span {\n  color: var(--hw-black-900);\n}\n\n.hw-excursion-card-footer {\n  margin-top: auto;\n  border-top: 1px solid var(--hw-gray-200);\n  padding-top: 1.2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.hw-excursion-card-price {\n  display: flex;\n  flex-direction: column;\n}\n\n.hw-excursion-card-price-label {\n  font-size: 1.1rem;\n  color: var(--hw-gray-500);\n}\n\n.hw-excursion-card-price-amount {\n  font-size: 1.8rem;\n  font-weight: 800;\n  color: var(--hw-black-900);\n}\n\n.hw-excursion-card-btn {\n  background-color: var(--hw-brand-orange-light);\n  color: var(--hw-brand-orange);\n  border: 1px solid transparent;\n  border-radius: 0.6rem;\n  padding: 0.6rem 1.2rem;\n  font-size: 1.3rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.hw-excursion-card-btn:hover {\n  background-color: var(--hw-brand-orange);\n  color: var(--hw-white);\n}\n\n.hw-excursion-grid-container {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 2.5rem;\n  margin-top: 1rem;\n}\n\n.hw-excursion-slider-nav-btn {\n  position: absolute;\n  width: 4rem;\n  height: 4rem;\n  border-radius: 50%;\n  background-color: var(--hw-white);\n  border: 1px solid var(--hw-brand-orange);\n  color: var(--hw-brand-orange);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 10;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  transition: all 0.2s ease;\n}\n\n.hw-excursion-slider-nav-btn:hover:not(:disabled) {\n  background-color: var(--hw-brand-orange);\n  color: var(--hw-white);\n  box-shadow: 0 4px 12px rgba(50, 100, 255, 0.3);\n}\n\n.hw-excursion-slider-nav-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.4;\n  border-color: var(--hw-gray-400);\n  color: var(--hw-gray-500);\n  background-color: var(--hw-white);\n  box-shadow: none;\n}\n\n.hw-excursion-slider-nav-btn.prev {\n  left: -2rem;\n}\n\n.hw-excursion-slider-nav-btn.next {\n  right: -2rem;\n}\n\n@media (max-width: 992px) {\n  .hw-excursion-search-widget {\n    flex-direction: column;\n    padding: 2rem;\n    gap: 1.5rem;\n    align-items: stretch;\n  }\n\n  .hw-excursion-search-btn {\n    width: 100%;\n    margin-top: 1rem;\n  }\n\n  .hw-excursion-grid-container {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 576px) {\n  .hw-excursion-grid-container {\n    grid-template-columns: 1fr;\n  }\n\n  .hw-excursion-banner-title {\n    font-size: 2.2rem;\n    text-align: center;\n  }\n}\n\n.typewriter-text {\n  color: #ffc107;\n  font-weight: 700;\n  border-right: 2px solid #ffc107;\n  padding-right: 5px;\n  animation: blink-cursor 0.75s step-end infinite;\n}\n\n@keyframes blink-cursor {\n\n  from,\n  to {\n    border-color: transparent\n  }\n\n  50% {\n    border-color: #ffc107;\n  }\n}\n\n.hw-excursion-banner-title.single-line {\n  white-space: nowrap;\n}\n\n@media (max-width: 768px) {\n  .hw-excursion-banner-title.single-line {\n    font-size: 2.2rem;\n    white-space: normal;\n  }\n}\n\n/* Best Cities to Visit — immersive image cards */\n.hw-city-card {\n  position: relative;\n  height: 30rem;\n  border-radius: 1.6rem;\n  overflow: hidden;\n  cursor: pointer;\n  opacity: 0;\n  transition: box-shadow 0.4s ease;\n}\n\n.hw-city-slider {\n  cursor: grab;\n  user-select: none;\n}\n\n.hw-city-slider.dragging {\n  cursor: grabbing;\n}\n\n.hw-city-slider.dragging .hw-city-card {\n  pointer-events: none;\n}\n\n/* Scroll-in entrance (staggered via inline animation-delay) */\n.hw-city-slider.in-view .hw-city-card {\n  animation: hwCityCardIn 0.65s cubic-bezier(0.165, 0.84, 0.44, 1) both;\n}\n\n@keyframes hwCityCardIn {\n  from {\n    opacity: 0;\n    transform: translateY(2.8rem) scale(0.97);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .hw-city-slider.in-view .hw-city-card {\n    animation: none;\n    opacity: 1;\n  }\n}\n\n.hw-city-card-media {\n  position: absolute;\n  inset: 0;\n}\n\n.hw-city-card-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.7s cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n\n.hw-city-card:hover .hw-city-card-img {\n  transform: scale(1.08);\n}\n\n.hw-city-card-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, rgba(15, 41, 77, 0) 35%, rgba(15, 41, 77, 0.35) 65%, rgba(15, 41, 77, 0.75) 100%);\n}\n\n.hw-city-card-overlay::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, rgba(15, 41, 77, 0.1) 0%, rgba(15, 41, 77, 0.85) 100%);\n  opacity: 0;\n  transition: opacity 0.4s ease;\n}\n\n.hw-city-card:hover .hw-city-card-overlay::after {\n  opacity: 1;\n}\n\n.hw-city-card-weather {\n  position: absolute;\n  top: 1.2rem;\n  right: 1.2rem;\n  z-index: 2;\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(4px);\n  color: var(--hw-black-900);\n  font-size: 1.2rem;\n  font-weight: 600;\n  padding: 0.4rem 1rem;\n  border-radius: 99rem;\n}\n\n.hw-city-card-content {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 2;\n  padding: 1.6rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  transform: translateY(3.4rem);\n  transition: transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n\n.hw-city-card:hover .hw-city-card-content {\n  transform: translateY(0);\n}\n\n.hw-city-card-subtitle {\n  font-size: 1.1rem;\n  font-weight: 600;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.75);\n  margin-bottom: 0;\n}\n\n.hw-city-card-title {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: var(--hw-white);\n  line-height: 1.3;\n  margin-bottom: 0.6rem;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.hw-city-card-cta {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  opacity: 0;\n  transform: translateY(8px);\n  transition: opacity 0.35s ease 0.08s, transform 0.35s ease 0.08s;\n}\n\n.hw-city-card:hover .hw-city-card-cta {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.hw-city-card-cta-label {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: var(--hw-white);\n}\n\n.hw-city-card-arrow {\n  width: 3rem;\n  height: 3rem;\n  border-radius: 50%;\n  background: var(--hw-white);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--hw-black-900);\n  transition: background 0.25s ease, color 0.25s ease, transform 0.25s ease;\n}\n\n.hw-city-card:hover .hw-city-card-arrow {\n  background: var(--hw-brand-orange);\n  color: var(--hw-white);\n  transform: translateX(0.3rem);\n}\n\n.hw-city-card-arrow svg {\n  width: 1.6rem;\n  height: 1.6rem;\n}\n\n/* Touch devices: no hover — keep content and CTA fully visible */\n@media (hover: none) {\n  .hw-city-card-content {\n    transform: translateY(0);\n  }\n\n  .hw-city-card-cta {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.hw-abu-dhabi-card {\n  position: relative;\n  border-radius: 1.6rem;\n  overflow: hidden;\n  height: 36rem;\n  cursor: pointer;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.hw-abu-dhabi-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n}\n\n.hw-abu-dhabi-card-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.5s ease;\n}\n\n.hw-abu-dhabi-card:hover .hw-abu-dhabi-card-img {\n  transform: scale(1.05);\n}\n\n.hw-abu-dhabi-card-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.8) 100%);\n  z-index: 1;\n  pointer-events: none;\n}\n\n.hw-abu-dhabi-card-content {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 2rem;\n  z-index: 2;\n  color: var(--hw-white);\n}\n\n.hw-abu-dhabi-card-title {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: var(--hw-white);\n  margin-bottom: 0.8rem;\n  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);\n}\n\n.hw-abu-dhabi-card-desc {\n  font-size: 1.3rem;\n  color: rgba(255, 255, 255, 0.8);\n  margin-bottom: 1.2rem;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);\n}\n\n.hw-abu-dhabi-card-price {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--hw-white);\n}\n\n.hw-abu-dhabi-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 2.5rem;\n  margin-top: 1rem;\n}\n\n@media (max-width: 992px) {\n  .hw-abu-dhabi-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 576px) {\n  .hw-abu-dhabi-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.hw-rak-card {\n  position: relative;\n  border-radius: 2rem;\n  background: var(--hw-white);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n  padding: 1.2rem;\n  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n\n.hw-rak-card-img-wrapper {\n  position: relative;\n  width: 100%;\n  height: 20rem;\n  border-radius: 1.6rem;\n  overflow: hidden;\n}\n\n.hw-rak-card-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n\n.hw-rak-card-badge {\n  position: absolute;\n  top: 1.2rem;\n  left: 1.2rem;\n  background: var(--hw-brand-orange);\n  color: var(--hw-white);\n  padding: 0.4rem 1rem;\n  border-radius: 1rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n  z-index: 2;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n}\n\n.hw-rak-card-info {\n  padding: 1.6rem 0.8rem 0.8rem 0.8rem;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  transition: transform 0.3s ease;\n}\n\n.hw-rak-card-title {\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: var(--hw-black-900);\n  margin-bottom: 0.8rem;\n  line-height: 1.3;\n  transition: color 0.3s ease;\n}\n\n.hw-rak-card-desc {\n  font-size: 1.2rem;\n  color: var(--hw-gray-500);\n  line-height: 1.5;\n  margin-bottom: 1.5rem;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.hw-rak-card-footer {\n  /* margin-top: auto; */\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.hw-rak-card-price {\n  font-size: 1.8rem;\n  font-weight: 800;\n  color: var(--hw-brand-orange);\n}\n\n.hw-rak-card-arrow {\n  width: 3.2rem;\n  height: 3.2rem;\n  border-radius: 50%;\n  background: #f8f9fa;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--hw-black-900);\n  transition: all 0.3s ease;\n}\n\n.hw-rak-card-arrow svg {\n  width: 1.6rem;\n  height: 1.6rem;\n}\n\n.hw-rak-card:hover {\n  border-color: rgba(255, 127, 80, 0.2);\n}\n\n.hw-rak-card:hover .hw-rak-card-img {\n  transform: scale(1.08) rotate(1deg);\n}\n\n.hw-rak-card:hover .hw-rak-card-title {\n  color: var(--hw-brand-orange);\n}\n\n.hw-rak-card:hover .hw-rak-card-arrow {\n  background: var(--hw-brand-orange);\n  color: var(--hw-white);\n  transform: translateX(3px);\n}\n\n.hw-abu-dhabi-card-badge {\n  position: absolute;\n  top: 1.5rem;\n  left: 1.5rem;\n  background: var(--hw-brand-orange);\n  color: var(--hw-white);\n  padding: 0.4rem 1rem;\n  border-radius: 1rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n  z-index: 2;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n}\n\n/* /excursion/cities — all cities directory page */\n\n.hw-cities-page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.hw-cities-page-title {\n  font-size: 2.4rem;\n  font-weight: 700;\n  color: var(--hw-black-900);\n  margin: 0;\n}\n\n.hw-cities-filter {\n  display: flex;\n  gap: 1rem;\n  overflow-x: auto;\n  padding: 0.4rem 0.2rem;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n  outline: none;\n  cursor: grab;\n  user-select: none;\n}\n\n.hw-cities-filter.dragging {\n  cursor: grabbing;\n  scroll-behavior: auto;\n}\n\n.hw-cities-filter.dragging .hw-cities-chip {\n  pointer-events: none;\n}\n\n.hw-cities-filter:focus-visible {\n  border-radius: 0.6rem;\n  box-shadow: 0 0 0 2px var(--hw-brand-orange-light);\n}\n\n.hw-cities-filter::-webkit-scrollbar {\n  display: none;\n}\n\n.hw-cities-chip {\n  flex-shrink: 0;\n  padding: 0.8rem 1.6rem;\n  background: var(--hw-white);\n  border: 1px solid var(--hw-gray-400);\n  border-radius: 0.6rem;\n  font-size: 1.3rem;\n  font-weight: 500;\n  color: var(--hw-black-900);\n  white-space: nowrap;\n  cursor: pointer;\n  transition: border-color 0.2s ease, color 0.2s ease, background-color 0.2s ease;\n}\n\n.hw-cities-chip:hover {\n  border-color: var(--hw-brand-orange);\n  color: var(--hw-brand-orange);\n}\n\n.hw-cities-chip.active {\n  border-color: var(--hw-brand-orange);\n  color: var(--hw-brand-orange);\n  background: var(--hw-brand-orange-light);\n}\n\n.hw-cities-grid {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 2rem;\n  margin-top: 2.4rem;\n}\n\n@media (max-width: 1200px) {\n  .hw-cities-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .hw-cities-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 576px) {\n  .hw-cities-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.hw-cities-card {\n  background: var(--hw-white);\n  border: 1px solid var(--hw-gray-300, #e9ecef);\n  border-radius: 1.2rem;\n  padding: 1rem;\n  cursor: pointer;\n  transition: box-shadow 0.25s ease, transform 0.25s ease, border-color 0.25s ease;\n}\n\n.hw-cities-card:hover {\n  border-color: var(--hw-gray-400);\n  box-shadow: 0 10px 24px rgba(15, 41, 77, 0.12);\n  transform: translateY(-2px);\n}\n\n.hw-cities-card-img-wrapper {\n  border-radius: 0.8rem;\n  overflow: hidden;\n  aspect-ratio: 1 / 1;\n}\n\n.hw-cities-card-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.4s ease;\n}\n\n.hw-cities-card:hover .hw-cities-card-img {\n  transform: scale(1.06);\n}\n\n.hw-cities-card-title {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: var(--hw-black-900);\n  line-height: 1.35;\n  margin-top: 1.2rem;\n}\n\n.hw-cities-card:hover .hw-cities-card-title {\n  color: var(--hw-brand-orange);\n}\n\n.hw-cities-card-country {\n  font-size: 1.2rem;\n  color: var(--hw-gray-500);\n  margin-top: 0.4rem;\n}\n/* ============================================================\n   Excursion checkout redesign (stepped) — scoped .hw-exchk\n   ============================================================ */\n.hw-exchk { width: 100%; }\n.hw-exchk--body { max-width: 144rem; width: 100%; margin-left: auto; margin-right: auto; padding: 0 1.5rem 40px; }\n.hw-exchk--heroInner { max-width: 144rem; width: 100%; margin-left: auto; margin-right: auto; padding: 0 1.5rem; }\n@media (min-width: 600px) { .hw-exchk--body, .hw-exchk--heroInner { padding-left: 3rem; padding-right: 3rem; } }\n@media (min-width: 1200px) { .hw-exchk--body, .hw-exchk--heroInner { padding-left: 5rem; padding-right: 5rem; } }\n@media (min-width: 1300px) { .hw-exchk--body, .hw-exchk--heroInner { padding-left: 6rem; padding-right: 6rem; } }\n@media (min-width: 1400px) { .hw-exchk--body, .hw-exchk--heroInner { padding-left: 10rem; padding-right: 10rem; } }\n.hw-exchk--hero { background: linear-gradient(120deg, #283D6B 0%, #22335e 52%, #3264FF 165%); border-radius: 0; padding: 18px 0 60px; margin: 0; color: #fff; box-shadow: 0 10px 26px -18px rgba(40,61,107,.5); min-height: 147px; }\n.hw-exchk--hero .hw-exchk--back { color: rgba(255,255,255,.85); }\n.hw-exchk--hero .hw-exchk--back:hover { color: #fff; }\n.hw-exchk--heroBar { display: flex; align-items: center; justify-content: space-between; gap: 20px; flex-wrap: wrap; margin-top: 4px; }\n.hw-exchk--heroTitle { margin: 0; color: #fff; font-weight: 700; font-size: clamp(20px, 2.4vw, 27px); }\n.hw-exchk--hero .hw-exchk--step { color: rgba(255,255,255,.6); }\n.hw-exchk--hero .hw-exchk--step:not(:last-child)::after { background: rgba(255,255,255,.28); }\n.hw-exchk--hero .hw-exchk--step.is-done:not(:last-child)::after { background: rgba(255,255,255,.55); }\n.hw-exchk--hero .hw-exchk--stepNum { background: rgba(255,255,255,.18); color: #fff; border: 1.5px solid rgba(255,255,255,.5); }\n.hw-exchk--hero .hw-exchk--step.is-active { color: #fff; }\n.hw-exchk--hero .hw-exchk--step.is-active .hw-exchk--stepNum { background: #fff; color: #283D6B; border-color: #fff; }\n.hw-exchk--hero .hw-exchk--step.is-done { color: #fff; }\n.hw-exchk--hero .hw-exchk--step.is-done .hw-exchk--stepNum { background: #4ade80; color: #0f3d22; border-color: #4ade80; }\n.hw-exchk--back { display: inline-flex; align-items: center; gap: 6px; background: none; border: none; color: #556; font-weight: 600; cursor: pointer; padding: 6px 8px 6px 0; }\n.hw-exchk--back:hover { color: #3264FF; }\n.hw-exchk--steps { list-style: none; display: flex; align-items: center; gap: 6px; margin: 0; padding: 0; }\n.hw-exchk--step { display: flex; align-items: center; gap: 8px; color: #98a2b6; font-weight: 600; font-size: 14px; }\n.hw-exchk--step:not(:last-child)::after { content: \"\"; width: 30px; height: 2px; background: #e2e6ee; margin: 0 6px; border-radius: 2px; }\n.hw-exchk--step.is-done:not(:last-child)::after { background: #b8d8c3; }\n.hw-exchk--stepNum { width: 26px; height: 26px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; background: #eef1f7; color: #98a2b6; font-size: 13px; font-weight: 700; }\n.hw-exchk--step.is-active { color: #1b2439; }\n.hw-exchk--step.is-active .hw-exchk--stepNum { background: #3264FF; color: #fff; }\n.hw-exchk--step.is-done { color: #283D6B; cursor: pointer; }\n.hw-exchk--step.is-done .hw-exchk--stepNum { background: #137333; color: #fff; }\n\n.hw-exchk--grid { display: grid; grid-template-columns: minmax(0,1fr) 450px; gap: 2rem; align-items: start; margin-top: -34px; position: relative; z-index: 1; }\n.hw-exchk--main { min-width: 0; }\n.hw-exchk--panel { background: #fff; border: 1px solid #eceef3; border-radius: 6px; padding: 22px; box-shadow: 0 1px 2px rgba(16,24,40,.04); }\n.hw-exchk--panelTitle { font-size: 18px; font-weight: 700; color: #1b2439; margin-bottom: 14px; }\n.hw-exchk--sectionHead { display: flex; align-items: center; gap: 12px; padding-bottom: 14px; margin-bottom: 20px; border-bottom: 1px solid #eceef3; }\n.hw-exchk--sectionIcon { display: inline-flex; align-items: center; justify-content: center; width: 36px; height: 36px; flex-shrink: 0; border-radius: 10px; background: #ebefff; color: #3264ff; }\n.hw-exchk--sectionIcon svg { width: 18px; height: 18px; color: #3264ff; }\n.hw-exchk--sectionTitle { font-size: 18px; font-weight: 700; color: #1b2439; letter-spacing: -0.01em; }\n.hw-exchk--sectionHead__toggle { cursor: pointer; user-select: none; margin-bottom: 0; transition: margin-bottom .25s ease; }\n.hw-exchk--sectionHead__toggle.is-open { margin-bottom: 20px; }\n.hw-exchk--sectionToggle { display: inline-flex; align-items: center; gap: 10px; margin-left: auto; }\n.hw-exchk--sectionMeta { font-size: 13px; font-weight: 600; color: black; margin-left: auto; }\n.hw-exchk--sectionToggle .hw-exchk--sectionMeta { margin-left: 0; }\n.hw-exchk--sectionChevron { display: inline-flex; align-items: center; justify-content: center; color: black; transition: transform .25s ease; }\n.hw-exchk--sectionChevron svg { width: 20px; height: 20px; }\n.hw-exchk--sectionHead__toggle.is-open .hw-exchk--sectionChevron { transform: rotate(180deg); }\n\n.hw-exchk--collapseWrapper { display: grid; grid-template-rows: 0fr; transition: grid-template-rows .3s cubic-bezier(0.4, 0, 0.2, 1); overflow: hidden; }\n.hw-exchk--collapseWrapper.is-open { grid-template-rows: 1fr; }\n.hw-exchk--collapseInner { min-height: 0; overflow: hidden; }\n.hw-exchk--stickyFoot { position: sticky; bottom: 0; z-index: 3; display: flex; justify-content: flex-end; background: #fff; margin: 22px -22px -22px; padding: 16px 22px; border-top: 1px solid #eef1f7; border-radius: 0 0 6px 6px; }\n.hw-exchk--agree { margin-top: 16px; }\n.hw-exchk--agreeCheck { display: flex; align-items: flex-start; gap: 10px; font-size: 13.5px; color: #4b5563; line-height: 1.55; cursor: pointer; }\n.hw-exchk--agreeCheck input { width: 18px; height: 18px; margin-top: 1px; flex-shrink: 0; accent-color: #3264FF; cursor: pointer; }\n.hw-exchk--agreeCheck a { color: #3264FF; text-decoration: underline; }\n.hw-exchk--agree .hw-p-error-cls { margin-top: 2rem; }\n.hw-exchk--panelHint { font-size: 13.5px; color: #6b7280; margin: -6px 0 16px; }\n.hw-exchk--field { margin-top: 16px; }\n.hw-exchk--label { display: block; font-weight: 600; color: #1b2439; margin-bottom: 6px; font-size: 14px; }\n.hw-exchk--optional { color: #98a2b6; font-weight: 500; }\n.hw-exchk--panelFoot { margin-top: 20px; display: flex; }\n.hw-exchk--panelFoot--split { justify-content: space-between; gap: 12px; }\n.hw-exchk--btnWide { min-width: 200px; }\n.hw-exchk--panelFoot .hw-btn { min-width: 100px;column-gap: 0rem; }\n\n.hw-exchk--aside { position: sticky; top: 110px; align-self: start; }\n.hw-exchk--summary { background: #fff; border: 1px solid #eceef3; border-radius: 6px; padding: 18px; box-shadow: 0 1px 2px rgba(16,24,40,.04); }\n.hw-exchk--summaryHead { font-size: 16px; font-weight: 700; color: #1b2439; margin-bottom: 14px; }\n.hw-exchk--miniTour { display: flex; gap: 12px; padding-bottom: 14px; margin-bottom: 14px; border-bottom: 1px solid #eef1f7; }\n.hw-exchk--miniTour img { width: 64px; height: 64px; border-radius: 10px; object-fit: cover; flex: none; }\n.hw-exchk--miniInfo { min-width: 0; }\n.hw-exchk--miniTitle { font-weight: 700; color: #1b2439; font-size: 14px; line-height: 1.3; }\n.hw-exchk--miniMeta { color: #6b7280; font-size: 12.5px; margin-top: 3px; }\n.hw-exchk--trust { list-style: none; margin: 14px 0 0; padding: 14px 0 0; border-top: 1px solid #eef1f7; display: grid; gap: 10px; }\n.hw-exchk--trust li { display: flex; align-items: center; gap: 9px; color: #283D6B; font-size: 13px; font-weight: 600; }\n.hw-exchk--trust svg { color: #3264FF; flex: none; }\n.hw-exchk--asideCta { margin-top: 16px; padding-top: 16px; border-top: 1px solid #eef1f7; display: grid; gap: 8px; }\n.hw-exchk--asideCta .hw-btn { width: 100%; }\n.hw-exchk--asideBack { background: none; border: none; color: #556; font-weight: 600; font-size: 13px; cursor: pointer; padding: 4px; }\n.hw-exchk--asideBack:hover { color: #3264FF; }\n.hw-exchk--bookingRef { margin-top: 18px; padding-top: 18px; border-top: 1px solid #eef1f7; }\n\n.hw-exchk--payGrid { display: flex; flex-wrap: wrap; gap: 12px; }\n.hw-exchk--method { display: flex; align-items: center; gap: 14px; flex: 1 1 240px; min-width: 0; text-align: left; background: #fff; border: 1.5px solid #e2e6ee; border-radius: 12px; padding: 16px; cursor: pointer; transition: border-color .15s, box-shadow .15s, background .15s; }\n.hw-exchk--method:hover { border-color: #c3ccdb; }\n.hw-exchk--method.is-selected { border-color: #3264FF; background: #f5f8ff }\n.hw-exchk--methodRadio { width: 20px; height: 20px; border-radius: 50%; border: 2px solid #c3ccdb; flex: none; position: relative; }\n.hw-exchk--method.is-selected .hw-exchk--methodRadio { border-color: #3264FF; }\n.hw-exchk--method.is-selected .hw-exchk--methodRadio::after { content: \"\"; position: absolute; inset: 3px; border-radius: 50%; background: #3264FF; }\n.hw-exchk--methodIco { color: #283D6B; display: inline-flex; }\n.hw-exchk--methodBody { display: flex; flex-direction: column; }\n.hw-exchk--methodName { font-weight: 700; color: #1b2439; font-size: 15px; }\n.hw-exchk--methodDesc { color: #6b7280; font-size: 12.5px; margin-top: 2px; }\n.hw-exchk--pay { min-width: 180px; }\n\n.hw-exchk--tourCard { display: flex; gap: 12px; align-items: flex-start; }\n.hw-exchk--tourImg { width: 110px; height: 66px; border-radius: 4px; object-fit: cover; flex: none; }\n.hw-exchk--tourInfo { min-width: 0; }\n.hw-exchk--tourTitle { font-weight: 700; color: #1b2439; font-size: 18px; line-height: 1.3; }\n.hw-exchk--edit { background: none; border: none; padding: 0; margin-top: 5px; color: #3264FF; font-weight: 600; font-size: 13px; cursor: pointer; }\n.hw-exchk--edit:hover { text-decoration: underline; }\n.hw-exchk--ticketLine { margin-top: 14px; font-weight: 700; color: #1b2439; font-size: 16px; }\n.hw-exchk--summaryDivider { height: 1px; background: #eef1f7; margin: 14px 0; }\n.hw-exchk--cancel { margin-top: 14px; padding-top: 14px; border-top: 1px solid #eef1f7; }\n.hw-exchk--cancelHead { display: flex; align-items: center; justify-content: space-between; gap: 10px; width: 100%; background: none; border: none; padding: 0; cursor: pointer; text-align: left; font-weight: 700; color: #1b2439; font-size: 16px; }\n.hw-exchk--cancelChevron { display: inline-flex; color: #6b7280; flex: none; transition: transform .2s ease; }\n.hw-exchk--cancel.is-open .hw-exchk--cancelChevron { transform: rotate(180deg); }\n.hw-exchk--cancelBody { color: #6b7280; font-size: 13px; line-height: 1.5; margin-top: 8px; }\n.hw-exchk--cancelBody ul { padding-left: 16px; margin: 6px 0; }\n.hw-exchk--terms { margin: 16px 0 0; color: #6b7280; font-size: 12.5px; line-height: 1.5; }\n.hw-exchk--terms a { color: #3264FF; text-decoration: underline; }\n.hw-exchk--review { border: 1px solid #eceef3; border-radius: 12px; padding: 14px 16px; margin-bottom: 18px; background: #fbfcfe; }\n.hw-exchk--reviewHead { display: flex; align-items: center; justify-content: space-between; font-weight: 700; color: #1b2439; font-size: 15px; margin-bottom: 8px; }\n.hw-exchk--reviewList { list-style: none; margin: 0; padding: 0; display: grid; gap: 8px; }\n.hw-exchk--reviewRow { display: flex; justify-content: space-between; gap: 16px; font-size: 13.5px; }\n.hw-exchk--reviewLbl { color: #6b7280; flex: none; }\n.hw-exchk--reviewVal { color: #1b2439; font-weight: 600; text-align: right; display: flex; flex-direction: column; align-items: flex-end; }\n.hw-exchk--reviewSub { color: #98a2b6; font-weight: 500; font-size: 12px; margin-top: 2px; }\n.hw-exchk--payHead { font-weight: 700; color: #1b2439; font-size: 15px; margin-bottom: 10px; }\n.hw-exchk--mobileBar { display: none; }\n\n@media (max-width: 991px) {\n  .hw-exchk--grid { grid-template-columns: 1fr; }\n  .hw-exchk--aside { position: static; }\n  .hw-exchk--asideCta { display: none; }\n}\n@media (max-width: 767px) {\n  .hw-exchk--body { padding-bottom: 84px; }\n  .hw-exchk--panel { padding: 18px; }\n  .hw-exchk--stickyFoot { display: none; }\n  .hw-exchk--btnWide, .hw-exchk--panelFoot .hw-btn { min-width: 0; flex: 1; }\n  /* .hw-exchk--stepLabel { display: none; } */\n  .hw-exchk--step.is-active .hw-exchk--stepLabel { display: inline; }\n  .hw-exchk--heroBar { flex-direction: column; align-items: flex-start; gap: 12px; margin-top: 10px; }\n  .hw-exchk--steps { gap: 4px; flex-wrap: nowrap; }\n  .hw-exchk--step { font-size: 13px; }\n  .hw-exchk--step:not(:last-child)::after { width: 20px; margin: 0 4px; }\n  .hw-exchk--stepNum { width: 24px; height: 24px; font-size: 12px; flex: none; }\n  .hw-exchk--mobileBar { display: flex; position: fixed; left: 0; right: 0; bottom: 0; z-index: 60; background: #fff; border-top: 1px solid #e6e9f0; padding: 10px 16px; align-items: center; justify-content: space-between; gap: 12px; box-shadow: 0 -4px 16px rgba(16,24,40,.08); }\n  .hw-exchk--mobileTotal { display: flex; flex-direction: column; }\n  .hw-exchk--mobileTotal span { font-size: 16px; color: #000; }\n  .hw-exchk--mobileTotal strong { font-size: 17px; color: #1b2439; }\n  .hw-exchk--mobileBar .hw-btn { min-width: 150px; }\n}\n/* end excursion checkout redesign */\n\n.hw-bkovl { position: fixed; inset: 0; z-index: 3000; display: flex; align-items: center; justify-content: center; padding: 20px; background: rgba(20,28,48,.55); -webkit-backdrop-filter: blur(3px); backdrop-filter: blur(3px); }\n.hw-bkovl--card { width: 100%; max-width: 380px; background: #fff; border-radius: 18px; padding: 30px 26px 22px; box-shadow: 0 26px 64px -22px rgba(16,24,40,.45); text-align: center; animation: hwBkPop .28s ease; }\n@keyframes hwBkPop { from { opacity: 0; transform: translateY(10px) scale(.97); } to { opacity: 1; transform: none; } }\n.hw-bkovl--ring { position: relative; width: 74px; height: 74px; margin: 0 auto 16px; }\n.hw-bkovl--spinner { width: 74px; height: 74px; animation: hwBkRotate 1.3s linear infinite; }\n.hw-bkovl--track { fill: none; stroke: #eaf0ff; stroke-width: 4; }\n.hw-bkovl--path { fill: none; stroke: #3264FF; stroke-width: 4; stroke-linecap: round; stroke-dasharray: 85 160; }\n.hw-bkovl--lock { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; color: #283D6B; }\n@keyframes hwBkRotate { to { transform: rotate(360deg); } }\n.hw-bkovl--title { font-size: 18px; font-weight: 800; color: #1b2439; }\n.hw-bkovl--sub { margin-top: 4px; color: #6b7280; font-size: 13px; }\n.hw-bkovl--steps { list-style: none; margin: 18px 0 0; padding: 0; display: grid; gap: 11px; text-align: left; }\n.hw-bkovl--step { display: flex; align-items: center; gap: 11px; color: #98a2b6; font-size: 14px; font-weight: 600; transition: color .3s; }\n.hw-bkovl--step.is-active { color: #1b2439; }\n.hw-bkovl--step.is-done { color: #137333; }\n.hw-bkovl--dot { width: 21px; height: 21px; border-radius: 50%; border: 2px solid #dfe4ee; display: inline-flex; align-items: center; justify-content: center; flex: none; color: #fff; transition: all .3s; }\n.hw-bkovl--dot svg { opacity: 0; transition: opacity .2s; }\n.hw-bkovl--step.is-active .hw-bkovl--dot { border-color: #3264FF; box-shadow: 0 0 0 4px rgba(50,100,255,.12); animation: hwBkPulse 1.2s ease-in-out infinite; }\n.hw-bkovl--step.is-done .hw-bkovl--dot { background: #137333; border-color: #137333; }\n.hw-bkovl--step.is-done .hw-bkovl--dot svg { opacity: 1; }\n@keyframes hwBkPulse { 0%,100% { box-shadow: 0 0 0 4px rgba(50,100,255,.12); } 50% { box-shadow: 0 0 0 7px rgba(50,100,255,.05); } }\n.hw-bkovl--note { margin-top: 18px; padding-top: 14px; border-top: 1px solid #eef1f7; color: #6b7280; font-size: 12.5px; }\n\n.hw-cfhero { width: 100%; color: #fff; padding: 26px 0 125px; }\n.hw-cfhero.is-confirm { background: linear-gradient(120deg, #283D6B 0%, #22335e 52%, #3264FF 165%);padding: 26px 0 75px; }\n.hw-cfhero.is-cancel-hotel { background: linear-gradient(120deg, #283D6B 0%, #22335e 52%, #3264FF 165%); padding: 26px 0 75px;}\n.hw-cfhero.is-confirm-hotel { background: linear-gradient(120deg, #283D6B 0%, #22335e 52%, #3264FF 165%);padding: 26px 0 75px; }\n.hw-cfhero--bar { display: flex; align-items: center; justify-content: space-between; gap: 20px; flex-wrap: wrap; }\n.hw-cfhero--left { display: flex; align-items: center; gap: 16px; }\n.hw-cfhero--badge { width: 40px; height: 40px; border-radius: 50%; background: rgba(255,255,255,.16); display: inline-flex; align-items: center; justify-content: center; flex: none; }\n.hw-cfhero--title { margin: 0; color: #fff; font-weight: 700; font-size: clamp(20px, 2.4vw, 27px);  }\n.hw-cfhero--sub { margin: 3px 0 0; color: rgba(255,255,255,.85); font-size: 14px; max-width: 640px; line-height: 1.45; }\n.hw-cfhero--id { text-align: right; }\n.hw-cfhero--idLabel { display: flex; color: rgba(255,255,255,.7); font-size: 11.5px; text-transform: uppercase; letter-spacing: .05em; }\n.hw-cfhero--idVal { display: block; color: #fff; font-weight: 800; font-size: 16px; margin-top: 2px; }\n@media (max-width: 600px) { .hw-cfhero--id { text-align: left; } .hw-cfhero--sub , .hw-cfhero--idVal { font-size: 12px; } .hw-cfhero.is-confirm , .hw-cfhero.is-confirm-hotel{padding : 26px 0 60px} }\n\n.hw-exchk--confirm {  position: relative; z-index: 1; }\n.hw-exchk--panelHead { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 14px; }\n.hw-exchk--panelHead .hw-exchk--panelTitle { margin-bottom: 0; }\n.hw-exchk--travelerTable table { width: 100%; border-collapse: collapse; }\n.hw-exchk--travelerTable th { text-align: left; font-size: 12px; text-transform: uppercase; letter-spacing: .03em; color: #1b2439; font-weight: 700; padding: 0 0 10px; border-bottom: 1px solid #eef1f7; }\n.hw-exchk--travelerTable td { padding: 12px 2px; border-bottom: 1px solid #f1f3f8; color: #1b2439; font-weight: 600; font-size: 14px; }\n.hw-exchk--travelerTable tr:last-child td { border-bottom: 0; }\n.hw-exchk--travelerTable th:nth-child(2), .hw-exchk--travelerTable td:nth-child(2) { text-align: right; }\n.hw-exchk--dl { display: inline-flex; align-items: center; justify-content: center; width: 34px; height: 34px; border-radius: 8px; border: 1px solid #e2e6ee; color: #3264FF; transition: background .15s, border-color .15s; }\n.hw-exchk--dl:hover { background: #f5f8ff; border-color: #3264FF; }\n.hw-hotel--reviewRoomCard { border: 1px solid #eef1f7; border-radius: 6px; overflow: hidden; margin-top: 12px; }\n.hw-hotel--reviewRoomCard:first-of-type { margin-top: 10px; }\n.hw-hotel--reviewRoomHead { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 12px 16px; background: #F8FAFC; border-bottom: 1px solid #e2e6ee; }\n.hw-hotel--reviewRoomBadge { font-size: 14.5px; font-weight: 700; color: #1e293b; letter-spacing: .01em; }\n.hw-hotel--reviewRoomCount { font-size: 14.5px; font-weight: 600; color: #1e293b; }\n.hw-hotel--reviewList { list-style: none; margin: 0; padding: 0; }\n.hw-hotel--reviewGuest { display: flex; align-items: center; gap: 12px; padding: 12px 14px; background: #fff; }\n.hw-hotel--reviewGuest + .hw-hotel--reviewGuest { border-top: 1px solid #f0f2f7; }\n.hw-hotel--reviewGuestIcon { display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border-radius: 50%; background: #eaf0ff; color: #3264FF; flex: none; }\n.hw-hotel--reviewGuestIcon svg { width: 16px; height: 16px; }\n.hw-hotel--reviewGuestName { font-size: 14.5px; font-weight: 600; color: #1e293b; flex: 1 1 auto; min-width: 0; }\n.hw-hotel--reviewGuestType { font-size: 11.5px; font-weight: 600; color: #1e293b; background: #f7f9fc; border: 1px solid #e2e6ee; border-radius: 999px; padding: 3px 11px; flex: none; }\n.hw-exchk--richText { color: #6b7280; font-size: 13.5px; line-height: 1.6; }\n.hw-exchk--richText ul { padding-left: 18px; margin: 6px 0; }\n\n\n.hw-exchk--tourImg { width: 96px; height: 66px; border-radius: 8px; object-fit: cover; flex: none; }\n.hw-exchk--tourInfo { min-width: 0; }\n.hw-exchk--tourVariation { color: #6b7280; font-size: 13px; margin-top: 3px; }\n.hw-exchk--facts { list-style: none; margin: 14px 0 0; padding: 0; display: grid; gap: 10px; }\n.hw-exchk--facts li { display: flex; justify-content: space-between; gap: 12px; font-size: 13.5px; }\n.hw-exchk--factLbl { color: #6b7280; }\n.hw-exchk--factVal { color: #1b2439; font-weight: 600; text-align: right; }\n\n.hw-cfhero--back { color: rgba(255,255,255,.85); margin-bottom: 6px; }\n.hw-cfhero--back:hover { color: #fff; }\n\n.hw-exchk--ticketsSection { position: sticky; bottom: 0; background: #fff; padding: 16px 0 6px; border-top: 1px solid #eef1f7; z-index: 2; }\n.hw-exchk--panelSubTitle { font-size: 15px; font-weight: 700; color: #1b2439; margin-bottom: 12px; }\n.hw-exchk--ticketsSection .hw-after--bookingWidget.tickets > .d-flex.justify-between { display: none !important; }\n.hw-exchk--ticketsSection .hw-after--bookingWidget.tickets { display: block; margin: 0; padding: 0; }\n.hw-tk--dlRow { display: flex;gap: 10px; margin: 0 0 10px; }\n/* .hw-tk--dlRow > div { flex: 1 1 200px; min-width: 0; margin: 0; } */\n.hw-tk--dlRow > div > .hw-btn { width: 100%; padding: 11px 14px; font-size: 14px; font-weight: 600; border-radius: 4px; height: auto; line-height: 1.2; }\n.hw-exchk--ticketsSection .hw-after--bookingWidget.tickets > span { display: block; margin-top: 6px; }\n\n.hw-exchk--summary .price-backup { padding: 0; }\n.hw-exchk--summary .price-backup h4 { font-size: 16px; font-weight: 700; color: #1b2439; margin: 0 0 6px; line-height: 1.3; }\n.hw-exchk--summary .price-backup .hw-passenger--fareSummary__thead,\n.hw-exchk--summary .price-backup .hw-passenger--fareSummary__tbodyTR { margin-top: 4px; }\n.hw-exchk--summary .price-backup .hw-passenger--fareSummary__tfoot { padding-top: 1.4rem; }\n\n.hw-tk--dlRow > div { min-width: 160px; }\n.hw-tk--dlRow > div > .hw-btn { min-height: 44px; min-width: 160px; display: inline-flex; align-items: center; justify-content: center; white-space: nowrap; }\n.hw-tk--dlRow > div > .hw-btn .hw-main--loaderCommon { min-width: 20px !important; min-height: 20px !important; width: 20px; height: 20px; }\n\n/* confirm: download tickets label + buttons on one line (buttons keep their width) */\n.hw-exchk--dlInline { display: flex; align-items: center; flex-wrap: wrap; gap: 12px 16px; }\n.hw-exchk--dlInline .hw-exchk--panelSubTitle { margin: 0; white-space: nowrap; flex: none; }\n.hw-exchk--ticketsSection.hw-exchk--dlInline .hw-after--bookingWidget.tickets { display: contents; }\n.hw-exchk--dlInline .hw-tk--dlRow { margin: 0; }\n.hw-exchk--dlInline .hw-after--bookingWidget.tickets > span { flex: 1 1 100%; margin: 0; }\n@media (max-width: 575px) {\n  .hw-exchk--dlInline { align-items: stretch; }\n  .hw-tk--dlRow > div{ min-width: 0;}\n  .hw-tk--dlRow > div > .hw-btn {min-width: 0;  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
